<template>
  <div class="h-100" ref="container">
    <div
      v-for="(s, k) in stackedLines"
      :key="k"
      :id="k"
      class="stackedLine"
      style="position: absolute; bottom: 0; right: 0px; z-index: -1; opacity: 0"
      :style="{ width: width[k], height: height[k] }"
    >{{k}}</div>
    <div
      v-for="(s, k) in stackedLines2"
      :key="k"
      :id="k"
      class="stackedLine"
      style="position: absolute; bottom: 0; right: 0px; z-index: -1; opacity: 0"
      :style="{ width: width[k], height: height[k] }"
    >{{k}}</div>
    <div
      v-for="(s, k) in stackedBars"
      :key="k"
      :id="k"
      class="stackedBar"
      style="position: absolute; bottom: 0; right: 0px; z-index: -1; opacity: 0"
      :style="{ width: width[k], height: height[k] }"
    ></div>
    <a-layout-header class="header-wrap bg-white">
      <p>{{ $t('configuration.title') }}</p>
      <a-space>
        <a-button type="primary" @click="save">{{ $t('buttons.save') }}</a-button>
        <a-button @click="cancel">{{ $t('common.cancelText') }}</a-button>
      </a-space>
    </a-layout-header>
    <a-layout class="h-100">
      <a-layout-sider style="min-width: 300px;border-right: 1px solid #eee" class="bg-white">
        <a-collapse v-model="activeKey" :bordered="false">
          <template v-slot:expandIcon="props">
            <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
          </template>
          <a-collapse-panel
            v-for="item in resourceList"
            :key="`${item.value}`"
            :style="collapsePanelStyle"
          >
            <div style="font-size: 12px" slot="header">{{ item.text }}</div>
            <template v-if="item.children.length > 0">
              <a-row style="padding: 4px 16px 16px;">
                <a-col
                  draggable="true"
                  class="item-wrapper"
                  style="padding-bottom: 30px; height: 80px; cursor: pointer"
                  v-for="(i, index) in item.children"
                  :key="i.id"
                  :span="8"
                  :style="{ marginTop: index > 2 ? '30px' : '0' }"
                >
                  <Item :src="i.url" :name="i.name" :type="i.type" :extra="i.extra" />
                </a-col>
              </a-row>
            </template>
          </a-collapse-panel>
        </a-collapse>
      </a-layout-sider>
      <a-layout-content>
        <div class="container-header bg-white">
          <div class="container-selector">
            <span
              style="font-size: 12px;color: #333;margin-right: 8px"
            >{{ $t('configuration.backgroundColor')}}</span>
            <a-popover v-model="colorPicker.visible" trigger="click" placement="bottomLeft">
              <a slot="content">
                <chrome-picker v-model="colorPicker.obj" />
              </a>
              <div
                style="display: inline-block;width: 70px;height: 50%;background-color:#fff;cursor: pointer;"
              >
                <div
                  :style="{ backgroundColor: colorPicker.obj.hex }"
                  style="width: 100%;height: 100%;"
                ></div>
              </div>
            </a-popover>
          </div>
        </div>
        <div :style="{ backgroundColor: colorPicker.obj.hex }" id="container"></div>
      </a-layout-content>
      <a-layout-sider
        style="min-width: 300px;max-width: 250px;border-left: 1px solid #eee;"
        class="bg-white"
      >
        <a-collapse
          v-model="propertyKey"
          :bordered="false"
          style="display: flex; flex-direction: column;"
        >
          <template v-slot:expandIcon="props">
            <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
          </template>
          <a-collapse-panel key="1">
            <div style="font-size: 12px" slot="header">{{ $t('configuration.style') }}</div>
            <template v-if="currentItem !== null && transformer.nodes().length === 1">
              <a-row>
                <a-col :span="2"></a-col>
                <a-col :span="6">X</a-col>
                <a-col :span="16">
                  <a-input
                    size="small"
                    :value="Math.round(currentItem.absolutePosition().x)"
                    @change="(e) => currentItem.absolutePosition({ x: Number(e.target.value), y: currentItem.absolutePosition().y })"
                  />
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="2"></a-col>
                <a-col :span="6">Y</a-col>
                <a-col :span="16">
                  <a-input
                    size="small"
                    :value="Math.round(currentItem.absolutePosition().y)"
                    @change="(e) => currentItem.absolutePosition({ x: currentItem.absolutePosition().x, y: Number(e.target.value) })"
                  />
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="2"></a-col>
                <a-col :span="6">{{ $t('configuration.width') }}</a-col>
                <a-col :span="16">
                  <a-input
                    size="small"
                    :value="Math.round(currentItem.width())"
                    @change="handleSizeChange($event, 'width')"
                  />
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="2"></a-col>
                <a-col :span="6">{{ $t('configuration.height') }}</a-col>
                <a-col :span="16">
                  <a-input
                    size="small"
                    :value="Math.round(currentItem.height())"
                    @change="handleSizeChange($event, 'height')"
                  />
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="2"></a-col>
                <a-col :span="6">{{ $t('configuration.scaleX') }}</a-col>
                <a-col :span="16">
                  <a-input
                    size="small"
                    :value="currentItem.scaleX()"
                    @change="handleScaleChange($event, 'X')"
                  />
                  <!-- @change="(e) => currentItem.scaleX(Number(e.target.value))" -->
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="2"></a-col>
                <a-col :span="6">{{ $t('configuration.scaleY') }}</a-col>
                <a-col :span="16">
                  <a-input
                    size="small"
                    :value="currentItem.scaleY()"
                    @change="handleScaleChange($event, 'Y')"
                  />
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="2"></a-col>
                <a-col :span="6">{{ $t('configuration.rotate') }}</a-col>
                <a-col :span="16">
                  <a-input
                    size="small"
                    :value="Math.round(currentItem.rotation())"
                    @change="(e) => currentItem.rotation(Number(e.target.value))"
                  />
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="2"></a-col>
                <a-col :span="6">{{ $t('configuration.zIndex') }}</a-col>
                <a-col :span="16">
                  <a-input
                    size="small"
                    :value="currentItem.zIndex()"
                    @change="(e) => currentItem.zIndex(Number(e.target.value))"
                  />
                </a-col>
              </a-row>
              <template v-if="changeFontStyle">
                <a-row>
                  <a-col :span="2"></a-col>
                  <a-col :span="6">{{ $t('configuration.fontFamily') }}</a-col>
                  <a-col :span="16">
                    <a-input
                      size="small"
                      :value="currentItem.fontFamily()"
                      @change="(e) => currentItem.fontFamily(e.target.value)"
                    />
                  </a-col>
                </a-row>
                <a-row>
                  <a-col :span="2"></a-col>
                  <a-col :span="6">{{ $t('configuration.fontSize') }}</a-col>
                  <a-col :span="16">
                    <a-input
                      size="small"
                      :value="currentItem.fontSize()"
                      @change="(e) => currentItem.fontSize(Number(e.target.value))"
                    />
                  </a-col>
                </a-row>
                <a-row>
                  <a-col :span="2"></a-col>
                  <a-col :span="6">{{ $t('configuration.color') }}</a-col>
                  <a-col :span="16">
                    <a-popover trigger="click" placement="bottomRight">
                      <a slot="content">
                        <chrome-picker
                          :value="currentItem.fill()"
                          @input="(colorObj) => { currentItem.fill(colorObj.hex);$forceUpdate() } "
                        />
                      </a>
                      <div
                        style="display: inline-block;width: 100%;height: 100%;background-color:#fff;cursor: pointer;"
                      >
                        <div
                          :style="{ backgroundColor: currentItem.fill(), color: currentItem.fill() }"
                          style="width: 100%;height: 100%;"
                        >1</div>
                      </div>
                    </a-popover>
                  </a-col>
                </a-row>
              </template>
              <template
                v-if="currentItem.name() === 'dataRow' || currentItem.name() === 'statsWidget'"
              >
                <a-col :span="lang === 'en' ? 1 : 2"></a-col>
                <a-col :span="lang === 'en' ? 7 : 6">{{ $t('configuration.borderRadius') }}</a-col>
                <a-col :span="16">
                  <a-input
                    size="small"
                    :value="currentItem.findOne('.background').cornerRadius()"
                    @keyup.enter="(e) => currentItem.findOne('.background').cornerRadius(Number(e.target.value))"
                  />
                </a-col>
                <a-col :span="lang === 'en' ? 1 : 2"></a-col>
                <a-col :span="lang === 'en' ? 7 : 6">{{ $t('configuration.backgroundColor') }}</a-col>
                <a-col :span="16">
                  <a-popover trigger="click" placement="bottomRight">
                    <a slot="content">
                      <chrome-picker
                        :value="{ rgba: currentItem.findOne('.background').fill() }"
                        @input="colorObj => { setBackgroundColor(currentItem.findOne('.background'), colorObj.rgba) }"
                      />
                    </a>
                    <div
                      style="display: inline-block;width: 100%;height: 100%;background-color:#fff;cursor: pointer;"
                    >
                      <div
                        :style="{ backgroundColor: currentItem.findOne('.background').fill() }"
                        style="width: 100%;height: 100%;"
                      >
                        <span style="color: rgba(255,255,255,0)">1</span>
                      </div>
                    </div>
                  </a-popover>
                </a-col>
              </template>
              <template v-if="currentItem.name() === 'dataBlock'">
                <a-col :span="2"></a-col>
                <a-col :span="6">{{ $t('configuration.backgroundColor') }}</a-col>
                <a-col :span="16">
                  <a-popover trigger="click" placement="bottomRight">
                    <a slot="content">
                      <chrome-picker
                        :value="{ rgba: currentItem.findOne('.dataBlockBody').fill() }"
                        @input="colorObj => { setBackgroundColor(currentItem.findOne('.dataBlockBody'), colorObj.rgba) }"
                      />
                    </a>
                    <div
                      style="display: inline-block;width: 100%;height: 100%;background-color:#fff;cursor: pointer;"
                    >
                      <div
                        :style="{ backgroundColor: dataBlockBackgroundColor }"
                        style="width: 100%;height: 100%;"
                      >
                        <span style="color: rgba(255,255,255,0)">1</span>
                      </div>
                    </div>
                  </a-popover>
                </a-col>
              </template>
              <template v-if="currentItem.name() === 'controlWidget'">
                <a-col :span="2"></a-col>
                <a-col :span="6">{{ $t('configuration.borderRadius') }}</a-col>
                <a-col :span="16">
                  <a-input
                    size="small"
                    :value="currentItem.findOne('Tag').cornerRadius()"
                    @keyup.enter="(e) => currentItem.findOne('Tag').cornerRadius(Number(e.target.value))"
                  />
                </a-col>
                <a-col :span="2"></a-col>
                <a-col :span="6">{{ $t('configuration.backgroundColor') }}</a-col>
                <a-col :span="16">
                  <a-popover trigger="click" placement="bottomRight">
                    <a slot="content">
                      <chrome-picker
                        :value="{ rgba: currentItem.findOne('Tag').fill() }"
                        @input="colorObj => { setBackgroundColor(currentItem.findOne('Tag'), colorObj.rgba) }"
                      />
                    </a>
                    <div
                      style="display: inline-block;width: 100%;height: 100%;background-color:#fff;cursor: pointer;"
                    >
                      <div
                        :style="{ backgroundColor: currentItem.findOne('Tag').fill() }"
                        style="width: 100%;height: 100%;"
                      >
                        <span style="color: rgba(255,255,255,0)">1</span>
                      </div>
                    </div>
                  </a-popover>
                </a-col>
                <a-col :span="2"></a-col>
                <a-col :span="6">{{ $t('configuration.color') }}</a-col>
                <a-col :span="16">
                  <a-popover trigger="click" placement="bottomRight">
                    <a slot="content">
                      <chrome-picker
                        :value="{ rgba: currentItem.findOne('Text').fill() }"
                        @input="colorObj => { setBackgroundColor(currentItem.findOne('Text'), colorObj.rgba) }"
                      />
                    </a>
                    <div
                      style="display: inline-block;width: 100%;height: 100%;background-color:#fff;cursor: pointer;"
                    >
                      <div
                        :style="{ backgroundColor: currentItem.findOne('Text').fill() }"
                        style="width: 100%;height: 100%;"
                      >
                        <span style="color: rgba(255,255,255,0)">1</span>
                      </div>
                    </div>
                  </a-popover>
                </a-col>
              </template>
            </template>
          </a-collapse-panel>
          <a-collapse-panel key="2">
            <div style="font-size: 12px" slot="header">{{ $t('configuration.data') }}</div>
            <template
              v-if="currentItem !== null && currentItem.name() === 'stackedLine2Title' && transformer.nodes().length === 1"
            >
              <a-row>
                <a-col :span="2"></a-col>
                <a-col :span="6">{{ $t('configuration.content') }}</a-col>
                <a-col :span="16">
                  <a-input
                    :value="currentItem.text()"
                    size="small"
                    @change="e => currentItem.text(e.target.value)"
                  />
                </a-col>
              </a-row>
            </template>
            <template
              v-if="currentItem !== null && (currentItem.name() === 'text' || currentItem.name() === 'dataBlockTitle' || currentItem.name() === 'dataGroupBodyRowKey' || currentItem.name() === 'dataGroupBodyRowUnit' || currentItem.name() === 'dataKey' || currentItem.name() === 'monitorKey' || currentItem.name() === 'stackedbar2Title') && transformer.nodes().length === 1"
            >
              <a-row>
                <a-col :span="2"></a-col>
                <a-col :span="6">{{ $t('configuration.content') }}</a-col>
                <a-col :span="16">
                  <a-input
                    :value="currentItem.text()"
                    size="small"
                    @change="changeStatisticsBlockTitle"
                  />
                </a-col>
              </a-row>
            </template>
            <template
              v-if="currentItem !== null && (currentItem.name() === 'dataBlock' || currentItem.name() === 'dataBlockHeader') && transformer.nodes().length === 1"
            >
              <a-row type="flex" justify="center">
                <a-col :span="lang === 'en' ? 0 : 2"></a-col>
                <a-col :span="lang === 'en' ? 8 : 6">{{ $t('configuration.bind') }}</a-col>
                <a-col :span="15">
                  <a-select
                    size="small"
                    class="w-100"
                    :value="currentDataBlock.getAttr('device') !== undefined ? currentDataBlock.getAttr('device').id : ''"
                    @change="value => dataBlockBindDevice(currentDataBlock, value)"
                  >
                    <a-select-option
                      v-for="device in deviceList"
                      :key="device.id"
                      :value="device.id"
                    >{{ device.name }}</a-select-option>
                  </a-select>
                </a-col>
              </a-row>
            </template>
            <div
              v-if="currentItem !== null && currentItem.name() === 'dataRow' && transformer.nodes().length === 1"
              style="flex: 1; overflow: auto; max-height: 560px"
            >
              <a-row type="flex" justify="center">
                <a-col :span="2"></a-col>
                <a-col :span="6">{{ $t('configuration.device') }}</a-col>
                <a-col :span="16">
                  <a-select
                    size="small"
                    class="w-100"
                    :value="currentItem.getAttr('device') !== undefined ? currentItem.getAttr('device').id : ''"
                    @change="bindingDevice"
                  >
                    <a-select-option
                      v-for="device in deviceList"
                      :key="device.id"
                      :value="device.id"
                      :label="`${device.name} - ${device.model}`"
                    >
                      <a-tooltip>
                        <template slot="title">
                          {{ device.name }} - {{ device.model }} - {{ device.code }}
                        </template>
                        {{ device.name }} - {{ device.model }}
                      </a-tooltip>
                    </a-select-option>
                  </a-select>
                </a-col>
              </a-row>
              <a-row v-if="protocolDataPoints.length !== 0">
                <a-col :span="2"></a-col>
                <a-col :span="8">{{ $t('configuration.parameter') }}</a-col>
                <a-col :span="8">{{ $t('configuration.unit') }}</a-col>
                <a-col :span="6">{{ $t('configuration.show') }}</a-col>
              </a-row>
              <a-row v-for="item in protocolDataPoints" :key="item.code">
                <a-col :span="2"></a-col>
                <a-col :span="8">{{ item[lang] }}</a-col>
                <a-col :span="8">{{ item.unit }}</a-col>
                <a-col :span="6">
                  <a-checkbox
                    :checked="item.show"
                    @change="(val) => { item.show = val.target.checked;addDataToStatisticsBlock(val.target.checked, item) }"
                  ></a-checkbox>
                </a-col>
              </a-row>
            </div>
            <div
              v-if="currentItem !== null && (currentItem.attrs.type || currentItem.name()) === 'monitorBlock'"
              style="flex: 1; overflow: auto; max-height: 580px"
            >
              <a-row type="flex" justify="center">
                <a-col :span="2"></a-col>
                <a-col :span="6">{{ $t('configuration.device') }}</a-col>
                <a-col :span="16">
                  <a-select
                    size="small"
                    class="w-100"
                    :value="currentItem.getAttr('device') !== undefined ? currentItem.getAttr('device').id : ''"
                    @change="bindingMonitorDevice"
                  >
                    <a-select-option
                      v-for="device in deviceList"
                      :key="device.id"
                      :value="device.id"
                      :label="`${device.name} - ${device.model}`"
                    >
                      <a-tooltip>
                        <template slot="title">
                          {{ device.name }} - {{ device.model }} - {{ device.code }}
                        </template>
                        {{ device.name }} - {{ device.model }}
                      </a-tooltip>
                    </a-select-option>
                  </a-select>
                </a-col>
              </a-row>
              <a-row v-if="protocolDataPoints.length !== 0">
                <a-col :span="2"></a-col>
                <a-col :span="8">{{ $t('configuration.parameter') }}</a-col>
                <a-col :span="8">{{ $t('configuration.unit') }}</a-col>
                <a-col :span="6">{{ $t('configuration.show') }}</a-col>
              </a-row>
              <a-row v-for="item in protocolDataPoints" :key="item.code">
                <a-col :span="2"></a-col>
                <a-col :span="8">{{ item[lang] }}</a-col>
                <a-col :span="8">{{ item.unit }}</a-col>
                <a-col :span="6">
                  <a-checkbox
                    :checked="item.show"
                    @change="(val) => { item.show = val.target.checked; addDataToMonitorBlock(val.target.checked, item) }"
                  ></a-checkbox>
                </a-col>
              </a-row>
            </div>
            <template
              v-if="currentItem !== null && (currentItem.attrs.type || currentItem.name()) === 'stationunit'"
            >
              <a-row type="flex" justify="center">
                <a-col :span="2"></a-col>
                <a-col :span="6">{{ $t('configuration.station') }}</a-col>
                <a-col :span="16">
                  <a-select
                    size="small"
                    class="w-100"
                    :value="currentItem.getAttr('station') !== undefined ? currentItem.getAttr('station').id : ''"
                    @change="bindingStation"
                  >
                    <a-select-option
                      v-for="station in stations"
                      :key="station.id"
                      :value="station.id"
                    >{{ station.name }}</a-select-option>
                  </a-select>
                </a-col>
              </a-row>
              <a-row v-show="stationDataBlockShow">
                <a-col :span="2"></a-col>
                <a-col :span="8">{{ $t('configuration.parameter') }}</a-col>
                <a-col :span="8">{{ $t('configuration.unit') }}</a-col>
                <a-col :span="6">{{ $t('configuration.show') }}</a-col>
              </a-row>
              <a-row
                v-show="stationDataBlockShow"
                v-for="(item, index) in stationDataPoints"
                :key="item.name"
              >
                <a-col :span="2"></a-col>
                <a-col :span="8">{{ item[lang] }}</a-col>
                <a-col :span="8">{{ item.unit }}</a-col>
                <a-col :span="6">
                  <a-checkbox
                    :checked="item.show"
                    @change="(val) => { item.show = val.target.checked; addDataToStationBlock(val, index) }"
                  ></a-checkbox>
                </a-col>
              </a-row>
            </template>
            <template v-if="currentItem !== null && currentItem.name() === 'controlWidget'">
              <a-row type="flex" justify="center">
                <a-col :span="2"></a-col>
                <a-col :span="6">{{ $t('configuration.text') }}</a-col>
                <a-col :span="16">
                  <a-input
                    size="small"
                    class="w-100"
                    :value="currentItem.findOne('Text').text()"
                    @change="e => currentItem.findOne('Text').text(e.target.value)"
                  />
                </a-col>
              </a-row>
              <a-row type="flex" justify="center">
                <a-col :span="2"></a-col>
                <a-col :span="6">{{ $t('configuration.device') }}</a-col>
                <a-col :span="16">
                  <a-select
                    size="small"
                    class="w-100"
                    :value="currentItem.getAttr('deviceId') || ''"
                    @change="value => bindControlWidget(value)"
                  >
                    <a-select-option
                      v-for="device in deviceList"
                      :key="device.id"
                      :value="device.id"
                      :label="`${device.name} - ${device.model}`"
                    >
                      <a-tooltip>
                        <template slot="title">
                          {{ device.name }} - {{ device.model }} - {{ device.code }}
                        </template>
                        {{ device.name }} - {{ device.model }}
                      </a-tooltip>
                    </a-select-option>
                  </a-select>
                </a-col>
              </a-row>
              <a-row type="flex" justify="center" v-if="currentItem.getAttr('deviceCode')">
                <a-col :span="2"></a-col>
                <a-col :span="6">{{ $t('configuration.cp') }}</a-col>
                <a-col :span="16">
                  <a-select
                    size="small"
                    class="w-100"
                    :value="currentItem.getAttr('pointName') || ''"
                    @change="value => bindControlWidgetPoint(value)"
                  >
                    <a-select-option
                      v-for="point in protocolDataPoints"
                      :key="point.code"
                      :value="point.code"
                    >{{ point.name }}</a-select-option>
                  </a-select>
                </a-col>
              </a-row>
              <a-row type="flex" justify="center" v-if="currentItem.getAttr('deviceCode')">
                <a-col :span="2"></a-col>
                <a-col :span="6">{{ $t('configuration.range') }}</a-col>
                <a-col :span="16">
                  <span>{{ currentItem.getAttr('range0') }}</span>&nbsp;~&nbsp;
                  <span>{{ currentItem.getAttr('range1') }}</span>
                </a-col>
              </a-row>
              <a-row type="flex" justify="center" v-if="currentItem.getAttr('deviceCode')">
                <a-col :span="2"></a-col>
                <a-col :span="6">{{ $t('configuration.coefficient') }}</a-col>
                <a-col :span="16">
                  <span>{{ currentItem.getAttr('coefficient') }}</span>
                </a-col>
              </a-row>
              <a-row type="flex" justify="center" v-if="currentItem.getAttr('deviceCode')">
                <a-col :span="2"></a-col>
                <a-col :span="6">{{ $t('device.value') }}</a-col>
                <a-col :span="16">
                  <a-input size="small" class="w-100" :value="currentItem.getAttr('value')" @change="e => { currentItem.setAttr('value', e.target.value); $forceUpdate() }" />
                </a-col>
              </a-row>
              <!-- <a-row type="flex" justify="center">
                <a-col :span="2"></a-col>
                <a-col :span="6">{{ $t('device.hint') }}</a-col>
                <a-col :span="16">
                  <a-input size="small" class="w-100" :value="currentItem.getAttr('hint')" @change="e => { currentItem.setAttr('hint', e.target.value); $forceUpdate() }" />
                </a-col>
              </a-row> -->
              <a-row type="flex" justify="center">
                <a-col :span="2"></a-col>
                <a-col :span="6">{{ $t('device.delay') }}</a-col>
                <a-col :span="16">
                  <a-input size="small" class="w-100" :value="currentItem.getAttr('delay') || '60'" @change="e => { currentItem.setAttr('delay', e.target.value); $forceUpdate() }" />
                </a-col>
              </a-row>
            </template>
            <template v-if="currentItem !== null && currentItem.name() === 'statsValue'">
              <stats-data-panel
                :currentItem="currentItem"
                :devices="deviceList"
                @change="bindStatsWidget"
              />
            </template>
            <template v-if="currentItem !== null && currentItem.name() === 'effectiveAccumulation'">
              <a-row type="flex" justify="center">
                <a-col :span="2"></a-col>
                <a-col :span="5">
                  {{ $t('station.DB') }}
                </a-col>
                <a-col :span="17">
                  <a-select :value="currentItem.getAttr('e')" @change="handleEChange" mode="multiple" style="width: 100%" size="small">
                    <a-select-option
                      v-for="e in electricityList"
                      :key="e.id"
                      :value="e.code"
                    >
                      {{ e.name }}
                    </a-select-option>
                  </a-select>
                </a-col>
              </a-row>
              <a-row type="flex" justify="center">
                <a-col :span="2"></a-col>
                <a-col :span="5">
                  {{ $t('station.LLJ') }}
                </a-col>
                <a-col :span="17">
                  <a-select :value="currentItem.getAttr('f')" @change="hanldeFChange" mode="multiple" style="width: 100%" size="small">
                    <a-select-option
                      v-for="f in flowList"
                      :key="f.id"
                      :value="f.code"
                    >
                      {{ f.name }}
                    </a-select-option>
                  </a-select>
                </a-col>
              </a-row>
              <a-row type="flex" justify="center">
                <a-col :span="2"></a-col>
                <a-col :span="5">
                  {{ $t('configuration.updateTerm') }}
                </a-col>
                <a-col :span="9">
                  <a-input-number
                    :value="currentItem.getAttr('updateTermNumber')"
                    size="small"
                    style="width: 100%"
                    @change="bindUpdateTermNumberToStackedBar"
                  />
                </a-col>
                <a-col :span="8">
                  <a-select
                    style="width: 100%;"
                    size="small"
                    :value="currentItem.getAttr('gap')"
                    @change="bindUpdateTermTypeToSatckedBar"
                  >
                    <a-select-option :value="1">
                      {{ $t('common.second') }}
                    </a-select-option>
                    <a-select-option :value="60">
                      {{ $t('common.minute') }}
                    </a-select-option>
                    <a-select-option :value="3600">
                      {{ $t('common.hour') }}
                    </a-select-option>
                  </a-select>
                </a-col>
              </a-row>
            </template>
            <template v-if="currentItem !== null && currentItem.name() === 'effectiveCurrent'">
              <a-row type="flex" justify="center">
                <a-col :span="2"></a-col>
                <a-col :span="4">
                  {{ $t('station.DB') }}
                </a-col>
                <a-col :span="18">
                  <a-select :value="currentItem.getAttr('e')" @change="handleEchangeC" mode="multiple" style="width: 100%" size="small">
                    <a-select-option
                      v-for="e in electricityList"
                      :key="e.id"
                      :value="e.code"
                    >
                      {{ e.name }}
                    </a-select-option>
                  </a-select>
                </a-col>
              </a-row>
              <a-row type="flex" justify="center">
                <a-col :span="2"></a-col>
                <a-col :span="4">
                  {{ $t('station.LLJ') }}
                </a-col>
                <a-col :span="18">
                  <a-select :value="currentItem.getAttr('f')" @change="handleFchangeC" mode="multiple" style="width: 100%" size="small">
                    <a-select-option
                      v-for="f in flowList"
                      :key="f.id"
                      :value="f.code"
                    >
                      {{ f.name }}
                    </a-select-option>
                  </a-select>
                </a-col>
              </a-row>
            </template>
            <template v-if="currentItem !== null && currentItem.name() === 'socialEffective'">
              <a-row type="flex" justify="center">
                <a-col :span="2"></a-col>
                <a-col :span="5">
                  {{ $t('station.DB') }}
                </a-col>
                <a-col :span="17">
                  <a-select :value="currentItem.getAttr('e')" @change="handleSEChange" mode="multiple" style="width: 100%" size="small">
                    <a-select-option
                      v-for="e in electricityList"
                      :key="e.id"
                      :value="e.code"
                    >
                      {{ e.name }}
                    </a-select-option>
                  </a-select>
                </a-col>
              </a-row>
              <a-row type="flex" justify="center">
                <a-col :span="2"></a-col>
                <a-col :span="5">
                  {{ $t('station.LLJ') }}
                </a-col>
                <a-col :span="17">
                  <a-select :value="currentItem.getAttr('f')" @change="hanldeSFChange" mode="multiple" style="width: 100%" size="small">
                    <a-select-option
                      v-for="f in flowList"
                      :key="f.id"
                      :value="f.code"
                    >
                      {{ f.name }}
                    </a-select-option>
                  </a-select>
                </a-col>
              </a-row>
              <a-row type="flex" justify="center">
                <a-col :span="2"></a-col>
                <a-col :span="5">
                  {{ $t('configuration.updateTerm') }}
                </a-col>
                <a-col :span="9">
                  <a-input-number
                    :value="currentItem.getAttr('updateTermNumber')"
                    size="small"
                    style="width: 100%"
                    @change="bindUpdateTermNumberToStackedBar"
                  />
                </a-col>
                <a-col :span="8">
                  <a-select
                    style="width: 100%;"
                    size="small"
                    :value="currentItem.getAttr('gap')"
                    @change="bindUpdateTermTypeToSatckedBar"
                  >
                    <a-select-option :value="1">
                      {{ $t('common.second') }}
                    </a-select-option>
                    <a-select-option :value="60">
                      {{ $t('common.minute') }}
                    </a-select-option>
                    <a-select-option :value="3600">
                      {{ $t('common.hour') }}
                    </a-select-option>
                  </a-select>
                </a-col>
              </a-row>
            </template>
            <template v-if="currentItem !== null && currentItem.name() === 'runningState'">
              <a-row type="flex" justify="center">
                <a-col :span="2"></a-col>
                <a-col :span="5">
                  {{ $t('configuration.updateTerm') }}
                </a-col>
                <a-col :span="9">
                  <a-input-number
                    :value="currentItem.getAttr('updateTermNumber')"
                    size="small"
                    style="width: 100%"
                    @change="bindUpdateTermNumberToStackedBar"
                  />
                </a-col>
                <a-col :span="8">
                  <a-select
                    style="width: 100%;"
                    size="small"
                    :value="currentItem.getAttr('gap')"
                    @change="bindUpdateTermTypeToSatckedBar"
                  >
                    <a-select-option :value="1">
                      {{ $t('common.second') }}
                    </a-select-option>
                    <a-select-option :value="60">
                      {{ $t('common.minute') }}
                    </a-select-option>
                    <a-select-option :value="3600">
                      {{ $t('common.hour') }}
                    </a-select-option>
                  </a-select>
                </a-col>
              </a-row>
            </template>
          </a-collapse-panel>
          <a-collapse-panel
            key="3"
            v-if="currentItem !== null && currentItem.name() === 'StackedLine'"
          >
            <div style="font-size: 12px" slot="header">{{ $t('configuration.chartsSetting') }}</div>
            <a-row type="flex" justify="center">
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.device') }}</a-col>
              <a-col :span="16">
                <a-select size="small" class="w-100" :value="currentItem.getAttr('deviceId')" @change="bindDeviceToChart">
                  <a-select-option
                    v-for="d in deviceList"
                    :key="d.id"
                  >{{ d.name }} - {{ d.model }}</a-select-option>
                </a-select>
              </a-col>
            </a-row>
            <a-row v-if="currentItem !== null && currentItem.getAttr('protocolCode')">
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.parameter') }}</a-col>
              <a-col :span="16">
                <a-select size="small" class="w-100" :value="currentItem.getAttr('point')">
                  <a-select-option
                    v-for="p in (currentItem.name() === 'StackedLine' ? pointsOfStackedLine : pointsOfStackedBar)"
                    :key="p.code"
                    @click.native="bindPointToChart(p)"
                  >{{ p.name }}</a-select-option>
                </a-select>
              </a-col>
            </a-row>
            <template>
              <div v-show="currentItem.name() === 'StackedBar'">
                <a-row>
                  <a-col :span="2"></a-col>
                  <a-col :span="6">{{ $t('configuration.aggregationType')}}</a-col>
                  <a-col :span="16">
                    <a-select
                      :value="currentItem.getAttr('aggregationType')"
                      size="small"
                      style="width: 100%"
                      @change="bindAggregationTypeToStackedBar"
                    >
                      <a-select-option value="AVG">{{ $t('warningForm.AVERAGE') }}</a-select-option>
                      <a-select-option value="SUM">{{ $t('configuration.SUM') }}</a-select-option>
                      <a-select-option value="MAX">{{ $t('warningForm.MAX') }}</a-select-option>
                      <a-select-option value="MIN">{{ $t('warningForm.MIN') }}</a-select-option>
                      <a-select-option value="DIFF">{{ $t('configuration.DIFF') }}</a-select-option>
                    </a-select>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col :span="2"></a-col>
                  <a-col :span="6">{{ $t('configuration.term') }}</a-col>
                  <a-col :span="16">
                    <a-select
                      :value="currentItem.getAttr('term')"
                      size="small"
                      style="width: 100%"
                      @change="bindTermToStackedBar"
                    >
                      <a-select-option value="1h">{{ $t('common.hour') }}</a-select-option>
                      <a-select-option value="1d">{{ $t('configuration.day') }}</a-select-option>
                      <a-select-option value="30d">{{ $t('configuration.month') }}</a-select-option>
                    </a-select>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col :span="2"></a-col>
                  <a-col :span="6">{{ $t('configuration.terms') }}</a-col>
                  <a-col :span="16">
                    <a-input-number
                      :value="currentItem.getAttr('termNumber')"
                      size="small"
                      style="width: 100%"
                      @change="bindTermNumberToStackedBar"
                    />
                  </a-col>
                </a-row>
                <a-row>
                  <a-col :span="2"></a-col>
                  <a-col :span="6">{{ $t('configuration.updateTerm') }}</a-col>
                  <a-col :span="9">
                    <a-input-number
                      :value="currentItem.getAttr('updateTermNumber')"
                      size="small"
                      style="width: 100%"
                      @change="bindUpdateTermNumberToStackedBar"
                    />
                  </a-col>
                  <a-col :span="7">
                    <a-select
                      style="width: 100%;"
                      size="small"
                      :value="currentItem.getAttr('gap')"
                      @change="bindUpdateTermTypeToSatckedBar"
                    >
                      <a-select-option :value="1">
                        {{ $t('common.second') }}
                      </a-select-option>
                      <a-select-option :value="60">
                        {{ $t('common.minute') }}
                      </a-select-option>
                      <a-select-option :value="3600">
                        {{ $t('common.hour') }}
                      </a-select-option>
                    </a-select>
                  </a-col>
                </a-row>
              </div>
            </template>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.chartType') }}</a-col>
              <a-col :span="16">
                <a-radio-group
                  name="radioGroup"
                  :value="currentItem.getAttr('chartType')"
                  @change="handleTypeChange"
                >
                  <a-radio value="line">{{ $t('line') }}</a-radio>
                  <a-radio value="bar">{{ $t('bar') }}</a-radio>
                </a-radio-group>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.Y') }}</a-col>
              <a-col :span="16">
                <a-radio-group
                  name="radioGroup"
                  :value="currentItem.getAttr('yPosition')"
                  @change="handleYPositionChange"
                >
                  <a-radio value="1">{{ $t('warning.show') }}</a-radio>
                  <a-radio value="0">{{ $t('warning.hide_o') }}</a-radio>
                </a-radio-group>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.X') }}</a-col>
              <a-col :span="16">
                <a-radio-group
                  name="radioGroup"
                  :value="currentItem.getAttr('xPosition')"
                  @change="handleXPositionChange"
                >
                  <a-radio value="1">{{ $t('warning.show') }}</a-radio>
                  <a-radio value="0">{{ $t('warning.hide_o') }}</a-radio>
                </a-radio-group>
              </a-col>
            </a-row>
            <a-row v-show="currentItem.name() === 'StackedLine'">
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.max') }}</a-col>
              <a-col :span="16">
                <a-input-number
                  size="small"
                  style="width: 100%"
                  :value="currentItem.getAttr('maxPoints')"
                  @change="handleMaxPointsChange"
                />
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.XFontSize') }}</a-col>
              <a-col :span="16">
                <a-input
                  size="small"
                  style="width: 100%"
                  :value="currentItem.getAttr('xFont')"
                  @change="handleXChange"
                />
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.XFontColor') }}</a-col>
              <a-col :span="16">
                <a-popover v-model="xColorVisible" trigger="click" placement="bottom">
                  <a slot="content">
                    <div>
                      <chrome-picker v-model="xColor" />
                      <div class="btn-group">
                        <el-button plain size="mini" @click="cancelColorPick('xColorVisible', 'xColor', '#FFFFFFFF')">{{ $t('common.cancelText') }}</el-button>
                        <el-button plain type="primary" size="mini" @click="confirmColorPick('xColorVisible', 'xColor', 'setXColor')">{{ $t('common.okText') }}</el-button>
                      </div>
                    </div>
                  </a>
                  <div style="width: 100%; height: 20px; cursor: pointer" :style="{ backgroundColor: xColor.hex8 }"></div>
                </a-popover>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.YFontSize') }}</a-col>
              <a-col :span="16">
                <a-input
                  size="small"
                  style="width: 100%"
                  :value="currentItem.getAttr('yFont')"
                  @change="handleYChange"
                />
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.YFontColor') }}</a-col>
              <a-col :span="16">
                <a-popover v-model="yColorVisible" trigger="click" placement="bottom">
                  <a slot="content">
                    <div>
                      <chrome-picker v-model="yColor" />
                      <div class="btn-group">
                        <el-button plain size="mini" @click="cancelColorPick('yColorVisible', 'yColor', '#FFFFFFFF')">{{ $t('common.cancelText') }}</el-button>
                        <el-button plain type="primary" size="mini" @click="confirmColorPick('yColorVisible', 'yColor', 'setYColor')">{{ $t('common.okText') }}</el-button>
                      </div>
                    </div>
                  </a>
                  <div style="width: 100%; height: 20px; cursor: pointer" :style="{ backgroundColor: yColor.hex8 }"></div>
                </a-popover>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.labelFont') }}</a-col>
              <a-col :span="16">
                <a-input
                  size="small"
                  style="width: 100%"
                  :value="currentItem.getAttr('labelFont')"
                  @change="handleLabelChange"
                />
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.labelColor') }}</a-col>
              <a-col :span="16">
                <a-popover v-model="labelColorVisible" trigger="click" placement="bottom">
                  <a slot="content">
                    <div>
                      <chrome-picker v-model="labelColor" />
                      <div class="btn-group">
                        <el-button plain size="mini" @click="cancelColorPick('labelColorVisible', 'labelColor', '#FFFFFFFF')">{{ $t('common.cancelText') }}</el-button>
                        <el-button plain type="primary" size="mini" @click="confirmColorPick('labelColorVisible', 'labelColor', 'setLabelColor')">{{ $t('common.okText') }}</el-button>
                      </div>
                    </div>
                  </a>
                  <div style="width: 100%; height: 20px; cursor: pointer" :style="{ backgroundColor: labelColor.hex8 }"></div>
                </a-popover>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.decimals') }}</a-col>
              <a-col :span="16">
                <a-input :placeholder="$t('configuration.returnOrigin')" size="small" :value="currentItem.getAttr('fixed')" @change="changeFixed" />
              </a-col>
            </a-row>
            <a-row v-show="currentItem.getAttr('chartType') === 'bar'">
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.borderRadius') }}</a-col>
              <a-col :span="16">
                <a-input size="small" :value="currentItem.getAttr('borderRadius')" @change="changeBorderRadius" />
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.linear') }}</a-col>
              <a-col :span="16">
                <a-radio-group
                  name="radioGroup"
                  :value="currentItem.getAttr('colorLinear')"
                  @change="handleColorLinearChange"
                >
                  <a-radio :value="true">{{ $t('common.yes') }}</a-radio>
                  <a-radio :value="false">{{ $t('common.no') }}</a-radio>
                </a-radio-group>
              </a-col>
            </a-row>
            <a-row v-show="!(currentItem.getAttr('chartType') === 'bar' && currentItem.getAttr('colorLinear'))">
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ currentItem.getAttr('chartType') === 'bar' ? $t('configuration.barColor') : $t('configuration.lineColor') }}</a-col>
              <a-col :span="16">
                <a-popover v-model="popVisible" trigger="click" placement="bottom">
                  <a slot="content">
                    <div>
                      <chrome-picker v-model="itemStyle" />
                      <div class="btn-group">
                        <el-button plain size="mini" @click="cancelColorPick('popVisble', 'itemStyle', '#5470C6FF')">{{ $t('common.cancelText') }}</el-button>
                        <el-button plain type="primary" size="mini" @click="confirmColorPick('popVisible', 'itemStyle', 'setItemStyle')">{{ $t('common.okText') }}</el-button>
                      </div>
                    </div>
                  </a>
                  <div style="width: 100%; height: 20px; cursor: pointer" :style="{ backgroundColor: itemStyle.hex8 }"></div>
                </a-popover>
              </a-col>
            </a-row>
            <a-row v-show="currentItem.getAttr('colorLinear')">
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.linearStart') }}</a-col>
              <a-col :span="16">
                <a-popover v-model="linearStartVisible" trigger="click" placement="bottom">
                  <a slot="content">
                    <div>
                      <chrome-picker v-model="linearStart" />
                      <div class="btn-group">
                        <el-button plain size="mini" @click="cancelColorPick('linearStartVisible', 'linearStart', '#157FFF99')">{{ $t('common.cancelText') }}</el-button>
                        <el-button plain type="primary" size="mini" @click="confirmColorPick('linearStartVisible', 'linearStart', 'setLinearColor')">{{ $t('common.okText') }}</el-button>
                      </div>
                    </div>
                  </a>
                  <div style="width: 100%; height: 20px; cursor: pointer" :style="{ backgroundColor: linearStart.hex8 }"></div>
                </a-popover>
              </a-col>
            </a-row>
            <a-row v-show="currentItem.getAttr('colorLinear')">
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.linearEnd') }}</a-col>
              <a-col :span="16">
                <a-popover v-model="linearEndVisible" trigger="click" placement="bottom">
                  <a slot="content">
                    <div>
                      <chrome-picker v-model="linearEnd" />
                      <div class="btn-group">
                        <el-button plain size="mini" @click="cancelColorPick('linearEndVisible', 'linearEnd', '#061E3C99')">{{ $t('common.cancelText') }}</el-button>
                        <el-button plain type="primary" size="mini" @click="confirmColorPick('linearEndVisible', 'linearEnd', 'setLinearColor')">{{ $t('common.okText') }}</el-button>
                      </div>
                    </div>
                  </a>
                  <div style="width: 100%; height: 20px; cursor: pointer" :style="{ backgroundColor: linearEnd.hex8 }"></div>
                </a-popover>
              </a-col>
            </a-row>
          </a-collapse-panel>
          <a-collapse-panel
            key="3"
            v-if="currentItem !== null && currentItem.name() === 'StackedBar'"
          >
            <div style="font-size: 12px" slot="header">{{ $t('configuration.chartsSetting') }}</div>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="7">
                <a-checkbox :checked="currentItem.getAttr('ratio')" @change="toggleRatioModeToNode">{{ $t("station.ratioT") }}</a-checkbox>
              </a-col>
            </a-row>
            <template v-if="currentItem.getAttr('ratio')">
              <a-row type="flex" justify="center">
                <a-col :span="2"></a-col>
                <a-col :span="6">{{ $t('station.LLJ') }}</a-col>
                <a-col :span="16">
                  <a-select size="small" class="w-100" :value="currentItem.getAttr('LLJs')" @change="bindLLJsToChart" mode="multiple">
                    <a-select-option
                      v-for="d in flowList"
                      :key="d.id"
                    >{{ d.name }} - {{ d.model }}</a-select-option>
                  </a-select>
                </a-col>
              </a-row>
              <a-row type="flex" justify="center">
                <a-col :span="2"></a-col>
                <a-col :span="6">{{ $t('station.DB') }}</a-col>
                <a-col :span="16">
                  <a-select size="small" class="w-100" :value="currentItem.getAttr('DBs')" @change="bindDBsToChart" mode="multiple">
                    <a-select-option
                      v-for="d in electricityList"
                      :key="d.id"
                    >{{ d.name }} - {{ d.model }}</a-select-option>
                  </a-select>
                </a-col>
              </a-row>
            </template>
            <a-row type="flex" justify="center" v-else>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.device') }}</a-col>
              <a-col :span="16">
                <a-select size="small" class="w-100" :value="currentItem.getAttr('deviceId')" @change="bindDeviceToChart2" mode="multiple">
                  <a-select-option
                    v-for="d in deviceList"
                    :key="d.id"
                  >{{ d.name }} - {{ d.model }}</a-select-option>
                </a-select>
              </a-col>
            </a-row>
            <template v-if="currentItem.getAttr('ratio')">
              <a-row v-if="currentItem !== null && currentItem.getAttr('LLJs')">
                <a-col :span="2"></a-col>
                <a-col :span="6">{{ $t('station.LLJParameter') }}</a-col>
                <a-col :span="16">
                  <a-select size="small" class="w-100" :value="currentItem.getAttr('LLJPoint')">
                    <a-select-option
                      v-for="p in LLJPoints"
                      :key="p.code"
                      @click.native="bindLLJPointToChart(p)"
                    >{{ p.name }}</a-select-option>
                  </a-select>
                </a-col>
              </a-row>
              <a-row v-if="currentItem !== null && currentItem.getAttr('DBs')">
                <a-col :span="2"></a-col>
                <a-col :span="6">{{ $t('station.DBParameter') }}</a-col>
                <a-col :span="16">
                  <a-select size="small" class="w-100" :value="currentItem.getAttr('DBPoint')">
                    <a-select-option
                      v-for="p in DBPoints"
                      :key="p.code"
                      @click.native="bindDBPointToChart(p)"
                    >{{ p.name }}</a-select-option>
                  </a-select>
                </a-col>
              </a-row>
            </template>
            <template v-else>
              <a-row v-if="currentItem !== null && currentItem.getAttr('protocolCode')">
                <a-col :span="2"></a-col>
                <a-col :span="6">{{ $t('configuration.parameter') }}</a-col>
                <a-col :span="16">
                  <a-select size="small" class="w-100" :value="currentItem.getAttr('point')">
                    <a-select-option
                      v-for="p in (currentItem.name() === 'StackedLine' ? pointsOfStackedLine : pointsOfStackedBar)"
                      :key="p.code"
                      @click.native="bindPointToChart(p)"
                    >{{ p.name }}</a-select-option>
                  </a-select>
                </a-col>
              </a-row>
            </template>
            <template>
              <div v-show="currentItem.name() === 'StackedBar'">
                <a-row>
                  <a-col :span="2"></a-col>
                  <a-col :span="6">{{ $t('configuration.aggregationType')}}</a-col>
                  <a-col :span="16">
                    <a-select
                      :value="currentItem.getAttr('aggregationType')"
                      size="small"
                      style="width: 100%"
                      @change="bindAggregationTypeToStackedBar"
                    >
                      <a-select-option value="AVG">{{ $t('warningForm.AVERAGE') }}</a-select-option>
                      <a-select-option value="SUM">{{ $t('configuration.SUM') }}</a-select-option>
                      <a-select-option value="MAX">{{ $t('warningForm.MAX') }}</a-select-option>
                      <a-select-option value="MIN">{{ $t('warningForm.MIN') }}</a-select-option>
                      <a-select-option value="DIFF">{{ $t('configuration.DIFF') }}</a-select-option>
                    </a-select>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col :span="2"></a-col>
                  <a-col :span="6">{{ $t('configuration.term') }}</a-col>
                  <a-col :span="16">
                    <a-select
                      :value="currentItem.getAttr('term')"
                      size="small"
                      style="width: 100%"
                      @change="bindTermToStackedBar"
                    >
                      <a-select-option value="1h">{{ $t('common.hour') }}</a-select-option>
                      <a-select-option value="1d">{{ $t('configuration.day') }}</a-select-option>
                      <a-select-option value="1w">{{ $t('common.week') }}</a-select-option>
                      <a-select-option value="30d">{{ $t('configuration.month') }}</a-select-option>
                    </a-select>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col :span="2"></a-col>
                  <a-col :span="6">{{ $t('configuration.terms') }}</a-col>
                  <a-col :span="16">
                    <a-input-number
                      :value="currentItem.getAttr('termNumber')"
                      size="small"
                      style="width: 100%"
                      @change="bindTermNumberToStackedBar"
                    />
                  </a-col>
                </a-row>
                <a-row>
                  <a-col :span="2"></a-col>
                  <a-col :span="6">{{ $t('configuration.updateTerm') }}</a-col>
                  <a-col :span="9">
                    <a-input-number
                      :value="currentItem.getAttr('updateTermNumber')"
                      size="small"
                      style="width: 100%"
                      @change="bindUpdateTermNumberToStackedBar"
                    />
                  </a-col>
                  <a-col :span="7">
                    <a-select
                      style="width: 100%;"
                      size="small"
                      :value="currentItem.getAttr('gap')"
                      @change="bindUpdateTermTypeToSatckedBar"
                    >
                      <a-select-option :value="1">
                        {{ $t('common.second') }}
                      </a-select-option>
                      <a-select-option :value="60">
                        {{ $t('common.minute') }}
                      </a-select-option>
                      <a-select-option :value="3600">
                        {{ $t('common.hour') }}
                      </a-select-option>
                    </a-select>
                  </a-col>
                </a-row>
              </div>
            </template>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.chartType') }}</a-col>
              <a-col :span="16">
                <a-radio-group
                  name="radioGroup"
                  :value="currentItem.getAttr('chartType')"
                  @change="handleTypeChange"
                >
                  <a-radio value="line">{{ $t('line') }}</a-radio>
                  <a-radio value="bar">{{ $t('bar') }}</a-radio>
                </a-radio-group>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.Y') }}</a-col>
              <a-col :span="16">
                <a-radio-group
                  name="radioGroup"
                  :value="currentItem.getAttr('yPosition')"
                  @change="handleYPositionChange"
                >
                  <a-radio value="1">{{ $t('warning.show') }}</a-radio>
                  <a-radio value="0">{{ $t('warning.hide_o') }}</a-radio>
                </a-radio-group>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.X') }}</a-col>
              <a-col :span="16">
                <a-radio-group
                  name="radioGroup"
                  :value="currentItem.getAttr('xPosition')"
                  @change="handleXPositionChange"
                >
                  <a-radio value="1">{{ $t('warning.show') }}</a-radio>
                  <a-radio value="0">{{ $t('warning.hide_o') }}</a-radio>
                </a-radio-group>
              </a-col>
            </a-row>
            <a-row v-show="currentItem.name() === 'StackedLine'">
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.max') }}</a-col>
              <a-col :span="16">
                <a-input-number
                  size="small"
                  style="width: 100%"
                  :value="currentItem.getAttr('maxPoints')"
                  @change="handleMaxPointsChange"
                />
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.XFontSize') }}</a-col>
              <a-col :span="16">
                <a-input
                  size="small"
                  style="width: 100%"
                  :value="currentItem.getAttr('xFont')"
                  @change="handleXChange"
                />
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.XFontColor') }}</a-col>
              <a-col :span="16">
                <a-popover v-model="xColorVisible" trigger="click" placement="bottom">
                  <a slot="content">
                    <div>
                      <chrome-picker v-model="xColor" />
                      <div class="btn-group">
                        <el-button plain size="mini" @click="cancelColorPick('xColorVisible', 'xColor', '#FFFFFFFF')">{{ $t('common.cancelText') }}</el-button>
                        <el-button plain type="primary" size="mini" @click="confirmColorPick('xColorVisible', 'xColor', 'setXColor')">{{ $t('common.okText') }}</el-button>
                      </div>
                    </div>
                  </a>
                  <div style="width: 100%; height: 20px; cursor: pointer" :style="{ backgroundColor: xColor.hex8 }"></div>
                </a-popover>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.YFontSize') }}</a-col>
              <a-col :span="16">
                <a-input
                  size="small"
                  style="width: 100%"
                  :value="currentItem.getAttr('yFont')"
                  @change="handleYChange"
                />
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.YFontColor') }}</a-col>
              <a-col :span="16">
                <a-popover v-model="yColorVisible" trigger="click" placement="bottom">
                  <a slot="content">
                    <div>
                      <chrome-picker v-model="yColor" />
                      <div class="btn-group">
                        <el-button plain size="mini" @click="cancelColorPick('yColorVisible', 'yColor', '#FFFFFFFF')">{{ $t('common.cancelText') }}</el-button>
                        <el-button plain type="primary" size="mini" @click="confirmColorPick('yColorVisible', 'yColor', 'setYColor')">{{ $t('common.okText') }}</el-button>
                      </div>
                    </div>
                  </a>
                  <div style="width: 100%; height: 20px; cursor: pointer" :style="{ backgroundColor: yColor.hex8 }"></div>
                </a-popover>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.labelFont') }}</a-col>
              <a-col :span="16">
                <a-input
                  size="small"
                  style="width: 100%"
                  :value="currentItem.getAttr('labelFont')"
                  @change="handleLabelChange"
                />
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.labelColor') }}</a-col>
              <a-col :span="16">
                <a-popover v-model="labelColorVisible" trigger="click" placement="bottom">
                  <a slot="content">
                    <div>
                      <chrome-picker v-model="labelColor" />
                      <div class="btn-group">
                        <el-button plain size="mini" @click="cancelColorPick('labelColorVisible', 'labelColor', '#FFFFFFFF')">{{ $t('common.cancelText') }}</el-button>
                        <el-button plain type="primary" size="mini" @click="confirmColorPick('labelColorVisible', 'labelColor', 'setLabelColor')">{{ $t('common.okText') }}</el-button>
                      </div>
                    </div>
                  </a>
                  <div style="width: 100%; height: 20px; cursor: pointer" :style="{ backgroundColor: labelColor.hex8 }"></div>
                </a-popover>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.decimals') }}</a-col>
              <a-col :span="16">
                <a-input :placeholder="$t('configuration.returnOrigin')" size="small" :value="currentItem.getAttr('fixed')" @change="changeFixed" />
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.dataRate') }}</a-col>
              <a-col :span="16">
                <a-input size="small" :value="currentItem.getAttr('dataRate')" @change="changeDataRate" />
              </a-col>
            </a-row>
            <a-row v-show="currentItem.getAttr('chartType') === 'bar'">
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.borderRadius') }}</a-col>
              <a-col :span="16">
                <a-input size="small" :value="currentItem.getAttr('borderRadius')" @change="changeBorderRadius" />
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.linear') }}</a-col>
              <a-col :span="16">
                <a-radio-group
                  name="radioGroup"
                  :value="currentItem.getAttr('colorLinear')"
                  @change="handleColorLinearChange"
                >
                  <a-radio :value="true">{{ $t('common.yes') }}</a-radio>
                  <a-radio :value="false">{{ $t('common.no') }}</a-radio>
                </a-radio-group>
              </a-col>
            </a-row>
            <a-row v-show="!(currentItem.getAttr('chartType') === 'bar' && currentItem.getAttr('colorLinear'))">
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ currentItem.getAttr('chartType') === 'bar' ? $t('configuration.barColor') : $t('configuration.lineColor') }}</a-col>
              <a-col :span="16">
                <a-popover v-model="popVisible" trigger="click" placement="bottom">
                  <a slot="content">
                    <div>
                      <chrome-picker v-model="itemStyle" />
                      <div class="btn-group">
                        <el-button plain size="mini" @click="cancelColorPick('popVisble', 'itemStyle', '#5470C6FF')">{{ $t('common.cancelText') }}</el-button>
                        <el-button plain type="primary" size="mini" @click="confirmColorPick('popVisible', 'itemStyle', 'setItemStyle')">{{ $t('common.okText') }}</el-button>
                      </div>
                    </div>
                  </a>
                  <div style="width: 100%; height: 20px; cursor: pointer" :style="{ backgroundColor: itemStyle.hex8 }"></div>
                </a-popover>
              </a-col>
            </a-row>
            <a-row v-show="currentItem.getAttr('colorLinear')">
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.linearStart') }}</a-col>
              <a-col :span="16">
                <a-popover v-model="linearStartVisible" trigger="click" placement="bottom">
                  <a slot="content">
                    <div>
                      <chrome-picker v-model="linearStart" />
                      <div class="btn-group">
                        <el-button plain size="mini" @click="cancelColorPick('linearStartVisible', 'linearStart', '#157FFF99')">{{ $t('common.cancelText') }}</el-button>
                        <el-button plain type="primary" size="mini" @click="confirmColorPick('linearStartVisible', 'linearStart', 'setLinearColor')">{{ $t('common.okText') }}</el-button>
                      </div>
                    </div>
                  </a>
                  <div style="width: 100%; height: 20px; cursor: pointer" :style="{ backgroundColor: linearStart.hex8 }"></div>
                </a-popover>
              </a-col>
            </a-row>
            <a-row v-show="currentItem.getAttr('colorLinear')">
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.linearEnd') }}</a-col>
              <a-col :span="16">
                <a-popover v-model="linearEndVisible" trigger="click" placement="bottom">
                  <a slot="content">
                    <div>
                      <chrome-picker v-model="linearEnd" />
                      <div class="btn-group">
                        <el-button plain size="mini" @click="cancelColorPick('linearEndVisible', 'linearEnd', '#061E3C99')">{{ $t('common.cancelText') }}</el-button>
                        <el-button plain type="primary" size="mini" @click="confirmColorPick('linearEndVisible', 'linearEnd', 'setLinearColor')">{{ $t('common.okText') }}</el-button>
                      </div>
                    </div>
                  </a>
                  <div style="width: 100%; height: 20px; cursor: pointer" :style="{ backgroundColor: linearEnd.hex8 }"></div>
                </a-popover>
              </a-col>
            </a-row>
          </a-collapse-panel>
          <a-collapse-panel
            key="3"
            v-if="currentItem !== null && currentItem.name() === 'StackedBar2'"
          >
            <div style="font-size: 12px" slot="header">{{ $t('configuration.chartsSetting') }}</div>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="7">
                <a-checkbox :checked="currentItem.getAttr('ratio')" @change="toggleRatioModeToNode">{{ $t("station.ratioT") }}</a-checkbox>
              </a-col>
            </a-row>
            <template v-if="currentItem.getAttr('ratio')">
              <a-row type="flex" justify="center">
                <a-col :span="2"></a-col>
                <a-col :span="6">{{ $t('station.LLJ') }}</a-col>
                <a-col :span="16">
                  <a-select size="small" class="w-100" :value="currentItem.getAttr('LLJs')" @change="bindLLJsToChart" mode="multiple">
                    <a-select-option
                      v-for="d in flowList"
                      :key="d.id"
                    >{{ d.name }} - {{ d.model }}</a-select-option>
                  </a-select>
                </a-col>
              </a-row>
              <a-row type="flex" justify="center">
                <a-col :span="2"></a-col>
                <a-col :span="6">{{ $t('station.DB') }}</a-col>
                <a-col :span="16">
                  <a-select size="small" class="w-100" :value="currentItem.getAttr('DBs')" @change="bindDBsToChart" mode="multiple">
                    <a-select-option
                      v-for="d in electricityList"
                      :key="d.id"
                    >{{ d.name }} - {{ d.model }}</a-select-option>
                  </a-select>
                </a-col>
              </a-row>
            </template>
            <a-row type="flex" justify="center" v-else>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.device') }}</a-col>
              <a-col :span="16">
                <a-select size="small" class="w-100" :value="currentItem.getAttr('deviceId')" @change="bindDeviceToChart2" mode="multiple">
                  <a-select-option
                    v-for="d in deviceList"
                    :key="d.id"
                  >{{ d.name }} - {{ d.model }}</a-select-option>
                </a-select>
              </a-col>
            </a-row>
            <template v-if="currentItem.getAttr('ratio')">
              <a-row v-if="currentItem !== null && currentItem.getAttr('LLJs')">
                <a-col :span="2"></a-col>
                <a-col :span="6">{{ $t('station.LLJParameter') }}</a-col>
                <a-col :span="16">
                  <a-select size="small" class="w-100" :value="currentItem.getAttr('LLJPoint')">
                    <a-select-option
                      v-for="p in LLJPoints"
                      :key="p.code"
                      @click.native="bindLLJPointToChart(p)"
                    >{{ p.name }}</a-select-option>
                  </a-select>
                </a-col>
              </a-row>
              <a-row v-if="currentItem !== null && currentItem.getAttr('DBs')">
                <a-col :span="2"></a-col>
                <a-col :span="6">{{ $t('station.DBParameter') }}</a-col>
                <a-col :span="16">
                  <a-select size="small" class="w-100" :value="currentItem.getAttr('DBPoint')">
                    <a-select-option
                      v-for="p in DBPoints"
                      :key="p.code"
                      @click.native="bindDBPointToChart(p)"
                    >{{ p.name }}</a-select-option>
                  </a-select>
                </a-col>
              </a-row>
            </template>
            <template v-else>
              <a-row v-if="currentItem !== null && currentItem.getAttr('protocolCode')">
                <a-col :span="2"></a-col>
                <a-col :span="6">{{ $t('configuration.parameter') }}</a-col>
                <a-col :span="16">
                  <a-select size="small" class="w-100" :value="currentItem.getAttr('point')">
                    <a-select-option
                      v-for="p in (currentItem.name() === 'StackedLine' ? pointsOfStackedLine : pointsOfStackedBar)"
                      :key="p.code"
                      @click.native="bindPointToChart(p)"
                    >{{ p.name }}</a-select-option>
                  </a-select>
                </a-col>
              </a-row>
            </template>
            <template>
              <div v-show="currentItem.name() === 'StackedBar2'">
                <a-row>
                  <a-col :span="2"></a-col>
                  <a-col :span="6">{{ $t('configuration.aggregationType')}}</a-col>
                  <a-col :span="16">
                    <a-select
                      :value="currentItem.getAttr('aggregationType')"
                      size="small"
                      style="width: 100%"
                      @change="bindAggregationTypeToStackedBar"
                    >
                      <a-select-option value="AVG">{{ $t('warningForm.AVERAGE') }}</a-select-option>
                      <a-select-option value="SUM">{{ $t('configuration.SUM') }}</a-select-option>
                      <a-select-option value="MAX">{{ $t('warningForm.MAX') }}</a-select-option>
                      <a-select-option value="MIN">{{ $t('warningForm.MIN') }}</a-select-option>
                      <a-select-option value="DIFF">{{ $t('configuration.DIFF') }}</a-select-option>
                    </a-select>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col :span="2"></a-col>
                  <a-col :span="6">{{ $t('configuration.term') }}</a-col>
                  <a-col :span="16">
                    <a-select
                      :value="currentItem.getAttr('term')"
                      size="small"
                      style="width: 100%"
                      @change="bindTermToStackedBar"
                    >
                      <a-select-option value="1h">{{ $t('common.hour') }}</a-select-option>
                      <a-select-option value="1d">{{ $t('configuration.day') }}</a-select-option>
                      <a-select-option value="1w">{{ $t('common.week') }}</a-select-option>
                      <a-select-option value="30d">{{ $t('configuration.month') }}</a-select-option>
                    </a-select>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col :span="2"></a-col>
                  <a-col :span="6">{{ $t('configuration.terms') }}</a-col>
                  <a-col :span="16">
                    <a-input-number
                      :value="currentItem.getAttr('termNumber')"
                      size="small"
                      style="width: 100%"
                      @change="bindTermNumberToStackedBar"
                    />
                  </a-col>
                </a-row>
                <a-row>
                  <a-col :span="2"></a-col>
                  <a-col :span="6">{{ $t('configuration.updateTerm') }}</a-col>
                  <a-col :span="9">
                    <a-input-number
                      :value="currentItem.getAttr('updateTermNumber')"
                      size="small"
                      style="width: 100%"
                      @change="bindUpdateTermNumberToStackedBar"
                    />
                  </a-col>
                  <a-col :span="7">
                    <a-select
                      style="width: 100%;"
                      size="small"
                      :value="currentItem.getAttr('gap')"
                      @change="bindUpdateTermTypeToSatckedBar"
                    >
                      <a-select-option :value="1">
                        {{ $t('common.second') }}
                      </a-select-option>
                      <a-select-option :value="60">
                        {{ $t('common.minute') }}
                      </a-select-option>
                      <a-select-option :value="3600">
                        {{ $t('common.hour') }}
                      </a-select-option>
                    </a-select>
                  </a-col>
                </a-row>
              </div>
            </template>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.chartType') }}</a-col>
              <a-col :span="16">
                <a-radio-group
                  name="radioGroup"
                  :value="currentItem.getAttr('chartType')"
                  @change="handleTypeChange"
                >
                  <a-radio value="line">{{ $t('line') }}</a-radio>
                  <a-radio value="bar">{{ $t('bar') }}</a-radio>
                </a-radio-group>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.Y') }}</a-col>
              <a-col :span="16">
                <a-radio-group
                  name="radioGroup"
                  :value="currentItem.getAttr('yPosition')"
                  @change="handleYPositionChange"
                >
                  <a-radio value="1">{{ $t('warning.show') }}</a-radio>
                  <a-radio value="0">{{ $t('warning.hide_o') }}</a-radio>
                </a-radio-group>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.X') }}</a-col>
              <a-col :span="16">
                <a-radio-group
                  name="radioGroup"
                  :value="currentItem.getAttr('xPosition')"
                  @change="handleXPositionChange"
                >
                  <a-radio value="1">{{ $t('warning.show') }}</a-radio>
                  <a-radio value="0">{{ $t('warning.hide_o') }}</a-radio>
                </a-radio-group>
              </a-col>
            </a-row>
            <a-row v-show="currentItem.name() === 'StackedLine'">
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.max') }}</a-col>
              <a-col :span="16">
                <a-input-number
                  size="small"
                  style="width: 100%"
                  :value="currentItem.getAttr('maxPoints')"
                  @change="handleMaxPointsChange"
                />
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.XFontSize') }}</a-col>
              <a-col :span="16">
                <a-input
                  size="small"
                  style="width: 100%"
                  :value="currentItem.getAttr('xFont')"
                  @change="handleXChange"
                />
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.XFontColor') }}</a-col>
              <a-col :span="16">
                <a-popover v-model="xColorVisible" trigger="click" placement="bottom">
                  <a slot="content">
                    <div>
                      <chrome-picker v-model="xColor" />
                      <div class="btn-group">
                        <el-button plain size="mini" @click="cancelColorPick('xColorVisible', 'xColor', '#FFFFFFFF')">{{ $t('common.cancelText') }}</el-button>
                        <el-button plain type="primary" size="mini" @click="confirmColorPick('xColorVisible', 'xColor', 'setXColor')">{{ $t('common.okText') }}</el-button>
                      </div>
                    </div>
                  </a>
                  <div style="width: 100%; height: 20px; cursor: pointer" :style="{ backgroundColor: xColor.hex8 }"></div>
                </a-popover>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.YFontSize') }}</a-col>
              <a-col :span="16">
                <a-input
                  size="small"
                  style="width: 100%"
                  :value="currentItem.getAttr('yFont')"
                  @change="handleYChange"
                />
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.YFontColor') }}</a-col>
              <a-col :span="16">
                <a-popover v-model="yColorVisible" trigger="click" placement="bottom">
                  <a slot="content">
                    <div>
                      <chrome-picker v-model="yColor" />
                      <div class="btn-group">
                        <el-button plain size="mini" @click="cancelColorPick('yColorVisible', 'yColor', '#FFFFFFFF')">{{ $t('common.cancelText') }}</el-button>
                        <el-button plain type="primary" size="mini" @click="confirmColorPick('yColorVisible', 'yColor', 'setYColor')">{{ $t('common.okText') }}</el-button>
                      </div>
                    </div>
                  </a>
                  <div style="width: 100%; height: 20px; cursor: pointer" :style="{ backgroundColor: yColor.hex8 }"></div>
                </a-popover>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.labelFont') }}</a-col>
              <a-col :span="16">
                <a-input
                  size="small"
                  style="width: 100%"
                  :value="currentItem.getAttr('labelFont')"
                  @change="handleLabelChange"
                />
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.labelColor') }}</a-col>
              <a-col :span="16">
                <a-popover v-model="labelColorVisible" trigger="click" placement="bottom">
                  <a slot="content">
                    <div>
                      <chrome-picker v-model="labelColor" />
                      <div class="btn-group">
                        <el-button plain size="mini" @click="cancelColorPick('labelColorVisible', 'labelColor', '#FFFFFFFF')">{{ $t('common.cancelText') }}</el-button>
                        <el-button plain type="primary" size="mini" @click="confirmColorPick('labelColorVisible', 'labelColor', 'setLabelColor')">{{ $t('common.okText') }}</el-button>
                      </div>
                    </div>
                  </a>
                  <div style="width: 100%; height: 20px; cursor: pointer" :style="{ backgroundColor: labelColor.hex8 }"></div>
                </a-popover>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.decimals') }}</a-col>
              <a-col :span="16">
                <a-input :placeholder="$t('configuration.returnOrigin')" size="small" :value="currentItem.getAttr('fixed')" @change="changeFixed" />
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.dataRate') }}</a-col>
              <a-col :span="16">
                <a-input size="small" :value="currentItem.getAttr('dataRate')" @change="changeDataRate" />
              </a-col>
            </a-row>
            <a-row v-show="currentItem.getAttr('chartType') === 'bar'">
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.borderRadius') }}</a-col>
              <a-col :span="16">
                <a-input size="small" :value="currentItem.getAttr('borderRadius')" @change="changeBorderRadius" />
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.linear') }}</a-col>
              <a-col :span="16">
                <a-radio-group
                  name="radioGroup"
                  :value="currentItem.getAttr('colorLinear')"
                  @change="handleColorLinearChange"
                >
                  <a-radio :value="true">{{ $t('common.yes') }}</a-radio>
                  <a-radio :value="false">{{ $t('common.no') }}</a-radio>
                </a-radio-group>
              </a-col>
            </a-row>
            <a-row v-show="!(currentItem.getAttr('chartType') === 'bar' && currentItem.getAttr('colorLinear'))">
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ currentItem.getAttr('chartType') === 'bar' ? $t('configuration.barColor') : $t('configuration.lineColor') }}</a-col>
              <a-col :span="16">
                <a-popover v-model="popVisible" trigger="click" placement="bottom">
                  <a slot="content">
                    <div>
                      <chrome-picker v-model="itemStyle" />
                      <div class="btn-group">
                        <el-button plain size="mini" @click="cancelColorPick('popVisble', 'itemStyle', '#5470C6FF')">{{ $t('common.cancelText') }}</el-button>
                        <el-button plain type="primary" size="mini" @click="confirmColorPick('popVisible', 'itemStyle', 'setItemStyle')">{{ $t('common.okText') }}</el-button>
                      </div>
                    </div>
                  </a>
                  <div style="width: 100%; height: 20px; cursor: pointer" :style="{ backgroundColor: itemStyle.hex8 }"></div>
                </a-popover>
              </a-col>
            </a-row>
            <a-row v-show="currentItem.getAttr('colorLinear')">
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.linearStart') }}</a-col>
              <a-col :span="16">
                <a-popover v-model="linearStartVisible" trigger="click" placement="bottom">
                  <a slot="content">
                    <div>
                      <chrome-picker v-model="linearStart" />
                      <div class="btn-group">
                        <el-button plain size="mini" @click="cancelColorPick('linearStartVisible', 'linearStart', '#157FFF99')">{{ $t('common.cancelText') }}</el-button>
                        <el-button plain type="primary" size="mini" @click="confirmColorPick('linearStartVisible', 'linearStart', 'setLinearColor')">{{ $t('common.okText') }}</el-button>
                      </div>
                    </div>
                  </a>
                  <div style="width: 100%; height: 20px; cursor: pointer" :style="{ backgroundColor: linearStart.hex8 }"></div>
                </a-popover>
              </a-col>
            </a-row>
            <a-row v-show="currentItem.getAttr('colorLinear')">
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.linearEnd') }}</a-col>
              <a-col :span="16">
                <a-popover v-model="linearEndVisible" trigger="click" placement="bottom">
                  <a slot="content">
                    <div>
                      <chrome-picker v-model="linearEnd" />
                      <div class="btn-group">
                        <el-button plain size="mini" @click="cancelColorPick('linearEndVisible', 'linearEnd', '#061E3C99')">{{ $t('common.cancelText') }}</el-button>
                        <el-button plain type="primary" size="mini" @click="confirmColorPick('linearEndVisible', 'linearEnd', 'setLinearColor')">{{ $t('common.okText') }}</el-button>
                      </div>
                    </div>
                  </a>
                  <div style="width: 100%; height: 20px; cursor: pointer" :style="{ backgroundColor: linearEnd.hex8 }"></div>
                </a-popover>
              </a-col>
            </a-row>
          </a-collapse-panel>
          <a-collapse-panel
            key="3"
            v-if="currentItem !== null && currentItem.name() === 'stackedLine2'"
          >
            <div style="font-size: 12px" slot="header">{{ $t('configuration.chartsSetting') }}</div>
            <a-row type="flex" justify="center">
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.device') }}</a-col>
              <a-col :span="16">
                <a-select size="small" class="w-100" :value="currentItem.getAttr('deviceId')" @change="bindDeviceToChart">
                  <a-select-option
                    v-for="d in deviceList"
                    :key="d.id"
                  >{{ d.name }} - {{ d.model }}</a-select-option>
                </a-select>
              </a-col>
            </a-row>
            <a-row v-if="currentItem !== null && currentItem.getAttr('protocolCode')">
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.parameter') }}</a-col>
              <a-col :span="16">
                <a-select size="small" class="w-100" :value="currentItem.getAttr('point')">
                  <a-select-option
                    v-for="p in pointsOfStackedLine2"
                    :key="p.code"
                    @click.native="bindPointToChart(p)"
                  >{{ p.name }}</a-select-option>
                </a-select>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.chartType') }}</a-col>
              <a-col :span="16">
                <a-radio-group
                  name="radioGroup"
                  :value="currentItem.getAttr('chartType')"
                  @change="handleTypeChange"
                >
                  <a-radio value="line">{{ $t('line') }}</a-radio>
                  <a-radio value="bar">{{ $t('bar') }}</a-radio>
                </a-radio-group>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.Y') }}</a-col>
              <a-col :span="16">
                <a-radio-group
                  name="radioGroup"
                  :value="currentItem.getAttr('yPosition')"
                  @change="handleYPositionChange"
                >
                  <a-radio value="1">{{ $t('warning.show') }}</a-radio>
                  <a-radio value="0">{{ $t('warning.hide_o') }}</a-radio>
                </a-radio-group>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.X') }}</a-col>
              <a-col :span="16">
                <a-radio-group
                  name="radioGroup"
                  :value="currentItem.getAttr('xPosition')"
                  @change="handleXPositionChange"
                >
                  <a-radio value="1">{{ $t('warning.show') }}</a-radio>
                  <a-radio value="0">{{ $t('warning.hide_o') }}</a-radio>
                </a-radio-group>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.max') }}</a-col>
              <a-col :span="16">
                <a-input-number
                  size="small"
                  style="width: 100%"
                  :value="currentItem.getAttr('maxPoints')"
                  @change="handleMaxPointsChange"
                />
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.XFontSize') }}</a-col>
              <a-col :span="16">
                <a-input
                  size="small"
                  style="width: 100%"
                  :value="currentItem.getAttr('xFont')"
                  @change="handleXChange"
                />
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.XFontColor') }}</a-col>
              <a-col :span="16">
                <a-popover v-model="xColorVisible" trigger="click" placement="bottom">
                  <a slot="content">
                    <div>
                      <chrome-picker v-model="xColor" />
                      <div class="btn-group">
                        <el-button plain size="mini" @click="cancelColorPick('xColorVisible', 'xColor', '#FFFFFFFF')">{{ $t('common.cancelText') }}</el-button>
                        <el-button plain type="primary" size="mini" @click="confirmColorPick('xColorVisible', 'xColor', 'setXColor')">{{ $t('common.okText') }}</el-button>
                      </div>
                    </div>
                  </a>
                  <div style="width: 100%; height: 20px; cursor: pointer" :style="{ backgroundColor: xColor.hex8 }"></div>
                </a-popover>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.YFontSize') }}</a-col>
              <a-col :span="16">
                <a-input
                  size="small"
                  style="width: 100%"
                  :value="currentItem.getAttr('yFont')"
                  @change="handleYChange"
                />
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.YFontColor') }}</a-col>
              <a-col :span="16">
                <a-popover v-model="yColorVisible" trigger="click" placement="bottom">
                  <a slot="content">
                    <div>
                      <chrome-picker v-model="yColor" />
                      <div class="btn-group">
                        <el-button plain size="mini" @click="cancelColorPick('yColorVisible', 'yColor', '#FFFFFFFF')">{{ $t('common.cancelText') }}</el-button>
                        <el-button plain type="primary" size="mini" @click="confirmColorPick('yColorVisible', 'yColor', 'setYColor')">{{ $t('common.okText') }}</el-button>
                      </div>
                    </div>
                  </a>
                  <div style="width: 100%; height: 20px; cursor: pointer" :style="{ backgroundColor: yColor.hex8 }"></div>
                </a-popover>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.labelFont') }}</a-col>
              <a-col :span="16">
                <a-input
                  size="small"
                  style="width: 100%"
                  :value="currentItem.getAttr('labelFont')"
                  @change="handleLabelChange"
                />
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.labelColor') }}</a-col>
              <a-col :span="16">
                <a-popover v-model="labelColorVisible" trigger="click" placement="bottom">
                  <a slot="content">
                    <div>
                      <chrome-picker v-model="labelColor" />
                      <div class="btn-group">
                        <el-button plain size="mini" @click="cancelColorPick('labelColorVisible', 'labelColor', '#FFFFFFFF')">{{ $t('common.cancelText') }}</el-button>
                        <el-button plain type="primary" size="mini" @click="confirmColorPick('labelColorVisible', 'labelColor', 'setLabelColor')">{{ $t('common.okText') }}</el-button>
                      </div>
                    </div>
                  </a>
                  <div style="width: 100%; height: 20px; cursor: pointer" :style="{ backgroundColor: labelColor.hex8 }"></div>
                </a-popover>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.decimals') }}</a-col>
              <a-col :span="16">
                <a-input :placeholder="$t('configuration.returnOrigin')" size="small" :value="currentItem.getAttr('fixed')" @change="changeFixed" />
              </a-col>
            </a-row>
            <a-row v-show="currentItem.getAttr('chartType') === 'bar'">
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.borderRadius') }}</a-col>
              <a-col :span="16">
                <a-input size="small" :value="currentItem.getAttr('borderRadius')" @change="changeBorderRadius" />
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.linear') }}</a-col>
              <a-col :span="16">
                <a-radio-group
                  name="radioGroup"
                  :value="currentItem.getAttr('colorLinear')"
                  @change="handleColorLinearChange"
                >
                  <a-radio :value="true">{{ $t('common.yes') }}</a-radio>
                  <a-radio :value="false">{{ $t('common.no') }}</a-radio>
                </a-radio-group>
              </a-col>
            </a-row>
            <a-row v-show="!(currentItem.getAttr('chartType') === 'bar' && currentItem.getAttr('colorLinear'))">
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ currentItem.getAttr('chartType') === 'bar' ? $t('configuration.barColor') : $t('configuration.lineColor') }}</a-col>
              <a-col :span="16">
                <a-popover v-model="popVisible" trigger="click" placement="bottom">
                  <a slot="content">
                    <div>
                      <chrome-picker v-model="itemStyle" />
                      <div class="btn-group">
                        <el-button plain size="mini" @click="cancelColorPick('popVisble', 'itemStyle', '#5470C6FF')">{{ $t('common.cancelText') }}</el-button>
                        <el-button plain type="primary" size="mini" @click="confirmColorPick('popVisible', 'itemStyle', 'setItemStyle')">{{ $t('common.okText') }}</el-button>
                      </div>
                    </div>
                  </a>
                  <div style="width: 100%; height: 20px; cursor: pointer" :style="{ backgroundColor: itemStyle.hex8 }"></div>
                </a-popover>
              </a-col>
            </a-row>
            <a-row v-show="currentItem.getAttr('colorLinear')">
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.linearStart') }}</a-col>
              <a-col :span="16">
                <a-popover v-model="linearStartVisible" trigger="click" placement="bottom">
                  <a slot="content">
                    <div>
                      <chrome-picker v-model="linearStart" />
                      <div class="btn-group">
                        <el-button plain size="mini" @click="cancelColorPick('linearStartVisible', 'linearStart', '#157FFF99')">{{ $t('common.cancelText') }}</el-button>
                        <el-button plain type="primary" size="mini" @click="confirmColorPick('linearStartVisible', 'linearStart', 'setLinearColor')">{{ $t('common.okText') }}</el-button>
                      </div>
                    </div>
                  </a>
                  <div style="width: 100%; height: 20px; cursor: pointer" :style="{ backgroundColor: linearStart.hex8 }"></div>
                </a-popover>
              </a-col>
            </a-row>
            <a-row v-show="currentItem.getAttr('colorLinear')">
              <a-col :span="2"></a-col>
              <a-col :span="6">{{ $t('configuration.linearEnd') }}</a-col>
              <a-col :span="16">
                <a-popover v-model="linearEndVisible" trigger="click" placement="bottom">
                  <a slot="content">
                    <div>
                      <chrome-picker v-model="linearEnd" />
                      <div class="btn-group">
                        <el-button plain size="mini" @click="cancelColorPick('linearEndVisible', 'linearEnd', '#061E3C99')">{{ $t('common.cancelText') }}</el-button>
                        <el-button plain type="primary" size="mini" @click="confirmColorPick('linearEndVisible', 'linearEnd', 'setLinearColor')">{{ $t('common.okText') }}</el-button>
                      </div>
                    </div>
                  </a>
                  <div style="width: 100%; height: 20px; cursor: pointer" :style="{ backgroundColor: linearEnd.hex8 }"></div>
                </a-popover>
              </a-col>
            </a-row>
          </a-collapse-panel>
        </a-collapse>
      </a-layout-sider>
    </a-layout>
  </div>
</template>

<script>
import Konva from "konva";
import Item from "@/views/EquipmentManager/EquipmentGroupDetail/components/Item";
import { Chrome } from "vue-color";
import { protocolApi, resourceApi, deviceApi } from "@/api/station";
import { websocketUrl } from "@/plugins/service";
import {
  startFlowingAnimation,
  drawFlowingPipe,
  removePipeline,
  destroyAnimation,
  createDatetimeComponent,
  AddDatetimeToAnim,
  removeDatetimeFromAnim,
  Originator,
  Manager
} from "@/views/EquipmentManager/EquipmentGroupDetail/konva-util";
import widget from "./konva-widget";
import { nanoid } from "nanoid";
import testbg from "@/testImages/Snipaste_2023-06-14_09-43-10.jpg";
import testblock from "@/testImages/datablock.png";
import runningPic from '@/assets/1.png'
import sleepingPic from '@/assets/2.png'
import offlinePic from '@/assets/3.png'
import errorPic from '@/assets/4.png'
import maintainPic from '@/assets/5.png'
import StatsDataPanel from "@/views/EquipmentManager/EquipmentGroupDetail/components/StatsDataPanel.vue";
import {
  getDeviceGroup,
  getResourceList,
  getDeviceGroupList,
  updateDeviceGroup,
  getDeviceHistoryData,
  getDeviceAggregation,
  getMultiAggregation,
  getMonthReport,
  switchDevice
} from "@/api/device";
import { getDict } from "@/api/dict";
import { getProtocol } from "@/api/protocol";
import backBorder from "@/assets/backBorder.png";
import moment from "moment";
import debounce from "@/components/function/debounce";

const defaultContent = {
  key: "#KEY",
  value: "#VALUE",
  unit: "#UNIT"
};
const BG_WIDTH = 170;
const BG_HEIGHT = 18;
const DEFAULT_COLOR = "#fff";
const PADDING = 4;
const GAP = 30;
const map = {
  StackedLine: {
    pointsList: 'pointsOfStackedLine',
    render: 'drawStackedLine',
    options: 'stackedLines'
  },
  stackedLine2: {
    pointsList: 'pointsOfStackedLine2',
    render: 'drawStackedLine',
    options: 'stackedLines2'
  },
  StackedBar: {
    pointsList: 'pointsOfStackedBar',
    render: 'getStackedBarData',
    options: 'stackedBars'
  },
  StackedBar2: {
    pointsList: 'pointsOfStackedBar',
    render: 'getStackedBarData',
    options: 'stackedBars'
  },
  line: 'areaStyle',
  bar: 'itemStyle'
}

export default {
  name: "index",
  components: {
    StatsDataPanel,
    Item,
    "chrome-picker": Chrome
  },
  created() {
    this.charts = {};
    this.barCharts = {};
    this.options = {};
    this.barOptions = {};
    this.effectiveWebsocket = {}
  },
  mounted() {
    this.content = {
      single: "",
      unit: ""
    };
    const lang = this.lang === "en" ? "en-US" : "zh-CN";
    getDict(lang, "deviceStatus").then(({ data }) => {
      this.deviceStatus = data.content;
    });
    // this.$refs.container.style.position = 'left: 2000px'
    getDeviceGroup(this.$route.query.id)
      .then(async ({ data }) => {
        this.stationRecord = data;
        let content;
        const i = JSON.parse(data.content);
        this.chart = data.extraProperty;
        this.gasElectricRatio = data.gasElectricRatio || 0
        if (i) {
          if (i.hasOwnProperty("single")) {
            content = i.single;
            this.content.single = i.single;
          } else {
            content = data.content;
            this.content.single = data.content;
          }
          if (i.hasOwnProperty("unit")) {
            this.content.unit = i.unit;
            this.toggleBtnShow = true;
          }
        }
        if (content) {
          this.loadStage(content);
        } else {
          this.initial();
        }
        return getDeviceGroup(this.$route.query.id);
      })
      .then(({ data: { devices, extraProperty: { deviceCodes } } }) => {
        const e = [], f = []
        this.eReduce = 0
        this.gReduce = 0
        let device
        (JSON.parse(deviceCodes) || []).forEach(d => {
          device = devices.find(de => de.code === d)
          if (device) {
            if (device.type === 'DB') {
              e.push(device)
              this.eReduce += device.initialValue || 0
            }
            if (device.type === 'LLJ') {
              f.push(device)
              this.gReduce += device.initialValue || 0
            }
          }
        })
        this.electricityList = e
        this.flowList = f
        this.deviceList = devices;
        return this.getResourceList();
      })
      .then(() => {
        this.originator = new Originator();
        this.manager = new Manager(this.originator);
        setTimeout(() => {
          this.originator.setStage(this.stage.clone());
          this.manager.save();
        }, 1000);
      })
      .catch(e => {
        console.log(e);
        // this.$message.error("请求失败")
      })
      .finally(async () => {
        document.addEventListener("keydown", e => {
          if (
            this.currentItem !== null &&
            this.transformer.nodes().length !== 0 &&
            e.key === "Delete"
          ) {
            const id = this.currentItem.getAttr('id')
            if (this.options[id]) {
              this.charts[id].dispose()
              delete this.options[id]
            }
            this.transformer.nodes().forEach(item => {
              if (item.name() === "datetime") {
                removeDatetimeFromAnim(item);
              }
              if (item.name() === "flowingPipe") {
                removePipeline(item);
              }
              item.destroy();
            });
            this.transformer.nodes([]);
            this.currentItem = null;
            this.layer.draw();
            this.cache();
          } else if (
            this.transformer.nodes().length !== 0 &&
            e.ctrlKey &&
            e.key === "c"
          ) {
            this.targetItems = [];
            this.transformer.nodes().forEach(item => {
              const duplicateItem = item.clone({
                x: item.x() + 20,
                y: item.y() + 20
              });
              this.targetItems.push(duplicateItem);
            });
          } else if (
            this.transformer.nodes().length !== 0 &&
            e.ctrlKey &&
            e.key === "v"
          ) {
            const isFocused = document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA'
            if (isFocused) {
              return
            }
            this.targetItems.forEach(item => {
              if (
                item.attrs.name === "flowingPipe" &&
                item instanceof Konva.Group
              ) {
                this.startFlowingAnimation(item);
              }
              if (item.attrs.name === "img") {
                item.attrs.rule.id = nanoid();
              }
              if (['StackedLine', 'StackedBar'].includes(item.attrs.name)) {
                const id = nanoid()
                item.setAttr('id', id)
                this[map[item.attrs.name].options][id] = {
                  deviceId: item.getAttr('deviceId'),
                  point: item.getAttr('point')
                }
              }
              this.layer.add(item);
              if (item.name() === "dataRow") {
                this.currentItem = item;
                this.selectedDataRow();
              } else {
                this.currentItem = item;
              }
            });
            this.transformer.nodes(this.targetItems);
            this.layer.draw();
            const rect = this.stage.findOne("#SelectBox");
            if (rect) {
              rect.destroy();
            }
            const list = [];
            this.targetItems.forEach(item => {
              const duplicateItem = item.clone({
                x: item.x() + 20,
                y: item.y() + 20
              });
              list.push(duplicateItem);
            });
            this.targetItems = list;
            this.cache();
          } else if (e.ctrlKey && e.key === "z") {
            this.undo();
          }
          if (e.key === "ArrowUp") {
            this.transformer.nodes().forEach(node => node.y(node.y() - 1));
            this.cache();
          } else if (e.key === "ArrowDown") {
            this.transformer.nodes().forEach(node => node.y(node.y() + 1));
            this.cache();
          } else if (e.key === "ArrowRight") {
            this.transformer.nodes().forEach(node => node.x(node.x() + 1));
            this.cache();
          } else if (e.key === "ArrowLeft") {
            this.transformer.nodes().forEach(node => node.x(node.x() - 1));
            this.cache();
          }
        });
        document.addEventListener("dragend", e => {
          this.stage.setPointersPositions(e);
          let target = e.target
          if (e.target.nodeName !== "IMG") {
            target = e.target.querySelector("img")
          }
          const type = target.getAttribute("data-type");
          switch (type) {
            case "img": {
              const extra = target.getAttribute("data-extra");
              this.addImageToStage(target.src, extra);
              break;
            }
            case "datetime": {
              const datetimeComponent = createDatetimeComponent(
                this.stage.getRelativePointerPosition()
              );
              this.layer.add(datetimeComponent);
              AddDatetimeToAnim(datetimeComponent);
              this.addNodeEvent(datetimeComponent);
              break;
            }
            case "monitorParameter": {
              const group = widget.monitorParameter.createMonitorParameter(
                this.stage.getRelativePointerPosition(),
                this.addNodeEvent,
                "dataRow"
              );
              this.layer.add(group);
              this.layer.draw();
              break;
            }
            case "dataBlock": {
              const block = widget.dataBlock.createDataBlock(
                this.stage.getRelativePointerPosition(),
                this.addNodeEvent
              );
              this.addNodeEvent(block);
              this.layer.add(block);
              this.layer.draw();
              break;
            }
            case "monitorBlock": {
              const block = widget.dataBlock.createMonitorBlock(
                this.stage.getRelativePointerPosition(),
                this.addNodeEvent
              );
              this.addNodeEvent(block);
              this.layer.add(block);
              this.layer.draw();
              break;
            }
            case "label": {
              const label = this.drawLabel();
              label.position(this.stage.getRelativePointerPosition());
              this.addNodeEvent(label);
              this.layer.add(label);
              this.layer.draw();
              break;
            }
            case "pipeline": {
              const group = this.drawFlowingPipe();
              group.position(this.stage.getRelativePointerPosition());
              this.addNodeEvent(group);
              const anim = this.startFlowingAnimation(group);
              this.animation.push(anim);
              this.layer.add(group);
              this.layer.draw();
              break;
            }
            case "controlWidget": {
              const btn = widget.controlWidget.create(
                this.stage.getRelativePointerPosition(),
                this.addNodeEvent
              );
              this.layer.add(btn);
              this.layer.draw();
              break;
            }
            case "statsWidget": {
              const w = widget.statsWidget.create(
                this.stage.getRelativePointerPosition(),
                this.addNodeEvent
              );
              console.log(w);
              this.layer.add(w);
              this.layer.draw();
              break;
            }
            case "StackedLine": {
              // const src = this.StackedLine.getDataURL('png')
              this.addImageToStage("", "StackedLine");
              break;
            }
            case "StackedBar": {
              // const src = this.StackedLine.getDataURL('png')
              this.addImageToStage("", "StackedBar");
              break;
            }
            default:
              break;
          }
          this.cache();
        });
        const stations = this.chart.stations || [];
        if (stations.length > 0) {
          let stationInfo = await getDeviceGroupList(1, 100);
          if (stationInfo.data.total > 100) {
            stationInfo = await getDeviceGroupList(1, stationInfo.data.total);
          }
          this.stations = stations.map(code => {
            return stationInfo.data.records.find(item => item.id == code);
          });
        }
        this.connectWebSocket();
      });
  },
  beforeDestroy() {
    this.clearAnimation();
    destroyAnimation();
    this.webSocket.close();
    this.webSocket = null
    this.manager = null;
    this.originator = null;
    for (let key in this.charts) {
      this.charts[key]?.dispose();
      this.charts[key] = null
    }
    for (let key in this.effectiveWebsocket) {
      this.effectiveWebsocket[key].close()
      this.effectiveWebsocket[key] = null
    }
  },
  data() {
    return {
      customStyle: {
        backgroundColor: "#fff"
      },
      stations: [],
      stage: null,
      layer: null,
      transformer: null,
      activeKey: ["0"],
      propertyKey: ["1"],
      colorPicker: {
        obj: {
          hex: "#000334"
        },
        visible: false
      },
      collapsePanelStyle: {
        border: 0,
        backgroundColor: "#fff"
      },
      maxPoints: "",
      resourceList: [],
      currentItem: null,
      currentItems: [],
      targetItem: null,
      targetItems: [],
      deviceList: [],
      pointsOfStackedLine: [],
      pointsOfStackedLine2: [],
      protocolDataPoints: [],
      ruleProtocolDataPoints: [],
      rectCount: 0,
      animation: [],
      content: "",
      imgFlag: true,
      watcher: "",
      rule: {
        judge: "",
        value: 0
      },
      width: {},
      height: {},
      barWidth: {},
      barHeight: {},
      // width: '500px',
      // height: '200px',
      webSocket: null,
      originator: null,
      manager: null,
      stationDataBlockShow: false,
      stationDataPoints: [
        {
          zh: "今日用电量",
          en: "today's electricity consumption",
          unit: "kWh",
          show: false
        },
        {
          zh: "今日累积流量",
          en: "today's flow consumption",
          unit: "Nm³",
          show: false
        },
        {
          zh: "今日单耗",
          en: "today's consumption",
          unit: "kWh/Nm³",
          show: false
        }
      ],
      currentPreview: "single",
      toggleBtnShow: false,
      stackedLines: {},
      stackedLines2: {},
      pointsOfStackedBar: [],
      stackedBars: {},
      popVisible: false,
      popEVisible: false,
      itemStyle: {
        hex8: '#5470C6FF',
        rgba: {
          r: 84,
          g: 112,
          b: 198,
          a: 1
        }
      },
      linearEnd: {
        hex8: '#061E3C99',
        rgba: {
          r: 6,
          g: 30,
          b: 60,
          a: .6
        }
      },
      linearStart: {
        hex8: '#157FFF99',
        rgba: {
          r: 21,
          g: 127,
          b: 255,
          a: .6
        }
      },
      linearStartVisible: false,
      linearEndVisible: false,
      xColorVisible: false,
      yColorVisible: false,
      labelColorVisible: false,
      xColor: {
        hex8: '#FFFFFFFF',
        rgba: {
          r: 255,
          g: 255,
          b: 255,
          a: 1
        }
      },
      yColor: {
        hex8: '#FFFFFFFF',
        rgba: {
          r: 255,
          g: 255,
          b: 255,
          a: 1
        }
      },
      labelColor: {
        hex8: '#FFFFFFFF',
        rgba: {
          r: 255,
          g: 255,
          b: 255,
          a: 1
        }
      },
      electricityList: [],
      flowList: [],
      LLJPoints: [],
      DBPoints: []
    };
  },
  computed: {
    changeFontStyle() {
      const fontNames = [
        "text",
        "deviceData",
        "datetime",
        "dataKey",
        "dataValue",
        "dataUnit",
        "monitorKey",
        "monitorValue",
        "monitorUnit",
        "dataBlockTitle",
        "statsValue",
        'title',
        "el",
        "fl",
        "ev",
        "fv",
        "ratioLabel",
        "ratioValue",
        "ratioUnit",
        "powerTitle",
        "powerValue",
        "CO2Title",
        "CO2Value",
        "stateTitle",
        "runningValue",
        "runningDescription",
        "sleepingValue",
        "sleepingDescription",
        "offlineValue",
        "offlineDescription",
        "errorValue",
        "errorDescription",
        "maintainValue",
        "maintainDescription",
        "stackedLine2Title",
        "stackedbar2Title"
      ];
      return fontNames.includes(this.currentItem.name());
    },
    currentDataBlock() {
      if (this.currentItem?.name() === "dataBlock") {
        return this.currentItem;
      } else if (this.currentItem?.name() === "dataBlockHeader") {
        return this.currentItem.getParent();
      }
      return null;
    },
    dataBlockBackgroundColor() {
      return this.currentItem.findOne(".dataBlockBody").fill();
    },
    lang() {
      return this.$store.state.lang;
    }
  },
  methods: {
    drawStackedLine(id, name = "", node) {
      const yVisible = node.getAttr('yPosition')
      const xVisible = node.getAttr('xPosition')
      const fixed = node.getAttr('fixed')
      const borderRadius = node.getAttr('borderRadius') || 0
      if (!this.charts[id]) {
        this.charts[id] = this.$echarts.init(
          document.querySelector(`#${id}`),
          null,
          {
            render: "canvas",
            useDirtyRect: false
          }
        );
      }
      
      this.options[id] = {
        animation: false,
        backgroundColor: "",
        tooltip: {
          trigger: "axis"
        },
        title: {
          text: "",
          textStyle: {
            color: "#fff"
          }
        },
        grid: {
          containLabel: true,
          top: "20%",
          left: "6%",
          bottom: "0",
          right: "8%"
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          data: [],
          axisLabel: {
            show: node.getAttr('xPosition') !== '0',
            textStyle: {
              fontSize: node.getAttr('xFont') || 16
            },
            color: node.getAttr('xColor') || this.xColor.hex8,
            show: isNaN(+xVisible) ? true : !!+xVisible
          },
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLine: {
            onZero: false
          }
        },
        yAxis: {
          type: "value",
          axisLabel: {
            show: isNaN(+yVisible) ? true : !!+yVisible,
            textStyle: {
              fontSize: node.getAttr('yFont') || 16
            },
            color: node.getAttr('yColor') || this.yColor.hex8
          },
          splitLine: {
            show: false
          }
        },
        series: [
          {
            name,
            type: node.getAttr('chartType') || 'line',
            data: [],
            // lineStyle: {
            //   color: 'red'
            // },
            label: {
              fontSize: node.getAttr('labelFont') || 16,
              color: node.getAttr('labelColor') || this.labelColor.hex8
            },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#157fff"
                },
                {
                  offset: 1,
                  color: "#061e3c"
                }
              ])
            },
            itemStyle: {
              color: node.getAttr('itemStyle') || this.itemStyle.hex8,
              borderRadius: [+borderRadius, +borderRadius, 0, 0]
            }
          }
        ]
      };
      const colorLinear = node.getAttr('colorLinear')
      if (colorLinear === false) {
        delete this.options[id].series[0].areaStyle
      } else {
        this.options[id].series[0][(node.getAttr('chartType') || 'line') === 'line' ? 'areaStyle' : 'itemStyle'] = {
          color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: node.getAttr('linearStart') || this.linearStart.hex8
            },
            {
              offset: 1,
              color: node.getAttr('linearEnd') || this.linearEnd.hex8
            }
          ]),
          borderRadius: [+borderRadius, +borderRadius, 0, 0]
        }
      }
      
      if (!isNaN(+fixed)) {
        this.options[id].series[0].label.formatter = o => (+o.value).toFixed(+fixed)
      }

      this.charts[id].setOption(this.options[id]);
      
      node.on("transformend", () => {
        const width = this.currentItem.scaleX() * 500;
        const height = this.currentItem.scaleY() * 200;
        this.width[id] = width + "px";
        this.height[id] = height + "px";
        this.width = { ...this.width };
        this.height = { ...this.height };
        
        this.$nextTick(() => {
          this.charts[id].resize();
          const img = new Image();
          img.src = this.charts[id].getDataURL("png");
          console.log(img.src);
          
          const image = this.currentItem.findOne(".img");
          console.log(image.scale());
          
          image.scaleX(1)
          image.scaleY(1)
          image.attrs.image = img;
          // image.scaleX(1 / this.currentItem.scaleX())
          // image.scaleY(1 / this.currentItem.scaleY())
        });
      });
    },
    setBackgroundColor(item, rgba) {
      const { r, g, b, a } = rgba;
      item.fill(`rgba(${r}, ${g}, ${b}, ${a})`);
      item.opacity(a);
    },
    resetWebSocket() {
      this.$forceUpdate();
    },
    getResourceList() {
      const lang = this.lang === "en" ? "en-US" : "zh-CN";
      getDict(lang, "stationResourceCategory")
        .then(({ data }) => {
          this.resourceList = [];
          data.content.forEach(i => {
            if (i.locale === lang) {
              i.children = [];
              this.resourceList.push(i);
            }
          });
          return getResourceList();
        })
        .then(({ data }) => {
          data.forEach(item => {
            item.type = "img";
            const i = this.resourceList.find(
              category => category.value === item.category
            );
            if (item.category === 'background') {
              item.extra = 'background'
            }
            if (item.details[0].name === '累积能效') {
              item.extra = 'effectiveAccumulation'
            }
            if (item.details[0].name === '实时能效') {
              item.extra = 'effectiveCurrent'
            }
            if (item.details[0].name === '社会效益') {
              item.extra = 'socialEffective'
            }
            if (item.details[0].name === '空压机状态') {
              item.extra = 'runningState'
            }
            if (item.details[0].name === '预警信息') {
              item.extra = 'warning'
            }
            if (item.details[0].name === '实时数据') {
              item.extra = 'stackedLine2'
            }
            const name =
              item.details.find(d => d.locale === "zh-CN")?.name || "";
            if (i) {
              this.resourceList
                .find(category => category.value === item.category)
                .children.push({
                  ...item,
                  url: item.url.startsWith("https")
                    ? item.url
                    : "https://ygk.nbdeman.com:9000" + item.url,
                  name
                });
            }
          });
          this.resourceList = this.resourceList.sort(
            (a, b) => a.priority - b.priority
          );
        })
        .catch(e => {
          console.log(e);
          // this.$message.error("请求失败")
        })
        .finally(() => {
          this.resourceList[0].children.push({
            id: 9998,
            name: this.lang === "en" ? "pipe line" : "流动管道",
            url: widget.img.pipeline,
            type: "pipeline"
          });
          this.resourceList[0].children.push({
            id: 9999,
            name: this.lang === "en" ? "monitor parameter" : "监测参数",
            url: widget.img.monitorParameter,
            type: "monitorParameter"
          });
          this.resourceList[0].children.push({
            id: 10000,
            name: this.lang === "en" ? "label" : "文字",
            url: widget.img.label,
            type: "label"
          });
          this.resourceList[0].children.push({
            id: 10001,
            name: this.lang === "en" ? "date time" : "时间日期",
            url: widget.img.dateTime,
            type: "datetime"
          });
          this.resourceList[0].children.push({
            id: 10002,
            name: this.lang === "en" ? "data block" : "参数块",
            url: widget.img.dataBlock,
            type: "dataBlock"
          });
          this.resourceList[0].children.push({
            id: 10006,
            name: this.lang === "en" ? "monitor block" : "监测参数块",
            url: widget.img.dataBlock,
            type: "monitorBlock"
          });
          this.resourceList[0].children.push({
            id: 10003,
            name: this.lang === "en" ? "control widget" : "控制组件",
            url: widget.img.dataBlock,
            type: "controlWidget"
          });
          this.resourceList[0].children.push({
            id: 10004,
            name: this.lang === "en" ? "stats widget" : "统计组件",
            url: widget.img.dataBlock,
            type: "statsWidget"
          });
          this.resourceList[0].children.push({
            id: 10005,
            name: this.lang === "en" ? "line chart" : "实时数据",
            url: widget.img.StackedLine,
            type: "StackedLine"
          });
          this.resourceList[0].children.push({
            id: 10007,
            name: this.lang === "en" ? "bar chart" : "聚合数据",
            url: widget.img.StackedLine,
            type: "StackedBar"
          });
          const i = this.resourceList.find(r => r.value === "station");
          i.children.push({
            id: nanoid(),
            name:
              this.lang === "en"
                ? "background of associated station"
                : "关联站房背景",
            url: testbg,
            type: "img"
          });
          i.children.push({
            id: nanoid(),
            name: this.lang === "en" ? "station unit" : "参数块",
            url: testblock,
            type: "img",
            extra: "stationunit"
          });

          const data = this.resourceList.find(r => r.value === "data")
          
          data.children.push({
            ...data.children.at(-1),
            id: 10009,
            name: this.lang === "en" ? "bar chart" : "聚合数据",
            extra: "StackedBar2"
          })
        });
    },
    clearAnimation() {
      this.animation.forEach(anim => {
        if (anim.isRunning()) {
          anim.stop();
        }
      });
      this.animation = [];
    },
    initial() {
      this.initStage();
      this.initTransformer();
      this.addStageEvent(this.stage);
      this.layer = new Konva.Layer();
      this.layer.add(this.transformer);
      this.stage.add(this.layer);
    },
    loadStage(data) {
      this.stage = Konva.Node.create(data, "container");
      this.stage.width(window.innerWidth);
      this.stage.height(window.innerHeight - 34);
      this.addStageEvent(this.stage);
      this.layer = this.stage.findOne("Layer");
      this.transformer = this.stage.findOne("Transformer");
      this.transformer.boundBoxFunc((oldBox, newBox) => {
        if (newBox.width <= 1 || newBox.height <= 1) {
          return oldBox;
        }
        return newBox;
      });
      this.loadNode();
    },
    loadNode() {
      this.clearAnimation();
      let statsWidgets = {},
        aggregations = [];
      this.stage.find(".statsValue").forEach(v => {
        const value = v.getAttr("data");
        const { deviceId, pointCode, aggregationType } = value;
        if (deviceId > 0 && pointCode !== "" && aggregationType !== "") {
          statsWidgets[deviceId] = v;
          aggregations.push(value);
        }
      });
      getDeviceAggregation(aggregations).then(({ data }) => {
        let result = {};
        data.forEach(d => {
          result[d.deviceId] = d.value;
        });
        for (let k in statsWidgets) {
          if (result[k]) {
            statsWidgets[k].text(result[k]);
          } else {
            statsWidgets[k].text(0);
          }
        }
      });
      this.stage.find(".text").forEach(node => {
        this.addNodeEvent(node);
      });
      this.stage.find(".circle").forEach(node => {
        this.addNodeEvent(node);
      });
      this.stage.find(".dataRow").forEach(node => {
        widget.monitorParameter.loadMonitorParameter(node, this.addNodeEvent);
      });
      this.stage.find(".monitorRow").forEach(node => {
        widget.monitorParameter.loadMonitorRow(node, this.addNodeEvent);
      });
      this.stage.find(".controlWidget").forEach(node => {
        widget.controlWidget.load(node, this.addNodeEvent);
      });
      this.stage.find(".statsWidget").forEach(node => {
        widget.statsWidget.load(node, this.addNodeEvent);
      });
      this.stage.find(".monitorKey").forEach(node => {
        this.addNodeEvent(node)
      })
      widget.dataBlock.loadDataBlock(this.stage, this.addNodeEvent);
      widget.dataBlock.loadMonitorBlock(this.stage, this.addNodeEvent);
      this.stage.find(async node => {
        // if (node.attrs.name === 'img') {
        //   console.log(node);

        //   const img = new Image()
        //   img.src = node.attrs.url
        //   node.attrs.image = img
        //   this.addNodeEvent(node)
        // }
        if (node.attrs.type === "stationunit") {
          const group = node.getParent();
          this.addNodeEvent(group.findOne(".label"));
          group.find(".innerGroup").forEach(item => {
            this.addNodeEvent(item);
            this.addNodeEvent(item.findOne(".dataKey"));
            this.addNodeEvent(item.findOne(".dataValue"));
            this.addNodeEvent(item.findOne(".dataUnit"));
          });
          const img = new Image();
          img.src = node.attrs.url;
          img.onload = () => {
            node.attrs.image = img;
            this.addNodeEvent(group);
          };
          console.log(node);
        } else if (node.attrs.name === "img") {
          const img = new Image();
          img.src = node.attrs.url;
          img.onload = () => {
            console.log(node)
            if (node.attrs.belong === "stackedLine2") {
              return
            }
            node.attrs.image = img
            this.addNodeEvent(node);
          };
        } else if (node.attrs.name === "StackedLine") {
          let img = new Image();
          const bg = node.findOne(".StackedLineBackground");
          const id = node.getAttr("id");
          const pointName = node.getAttr("pointName");
          const deviceId = node.getAttr('deviceId')
          const point = node.getAttr('point')
          if (!node.attrs.chartType) {
            node.setAttr("chartType", "line");
          }
          if (!node.attrs.yPosition) {
            node.setAttr("yPosition", "1");
          }
          if (!node.attrs.xPosition) {
            node.setAttr("xPosition", "1");
          }
          if (!node.attrs.linearStart) {
            node.setAttr("linearStart", "#157FFF99");
          }
          if (!node.attrs.itemStyle) {
            node.setAttr("itemStyle", "#5470C6FF");
          }
          if (!node.attrs.linearEnd) {
            node.setAttr("linearEnd", "#061E3C99");
          }
          if (!node.attrs.xFont) {
            node.setAttr("xFont", 16);
          }
          if (!node.attrs.xColor) {
            node.setAttr("xColor", '#FFFFFFFF');
          }
          if (!node.attrs.yFont) {
            node.setAttr("yFont", 16);
          }
          if (!node.attrs.yColor) {
            node.setAttr("yColor", '#FFFFFFFF');
          }
          if (!node.attrs.labelFont) {
            node.setAttr("labelFont", 16);
          }
          if (!node.attrs.labelColor) {
            node.setAttr("labelColor", '#FFFFFFFF');
          }
          if (!node.attrs.maxPoints) {
            node.setAttr('maxPoints', 20)
          }
          if (node.attrs.colorLinear === undefined || node.attrs.colorLinear === null) {
            node.setAttr("colorLinear", true);
          }
          const image = node.findOne('.img')
          image.width(500)
          image.height(200)
          
          this.stackedLines[id] = {
            deviceId,
            point
          };
          if (deviceId && point) {
            const width = node.scaleX() * 500;
            const height = node.scaleY() * 200;
            this.width[id] = width + "px";
            this.height[id] = height + "px";
            this.width = { ...this.width };
            this.height = { ...this.height };
            this.$nextTick(() =>
              this.drawStackedLine(id, pointName, node)
            );
          }
          img.src = backBorder;
          img.onload = () => {
            bg.attrs.image = img;
            this.layer.draw();
            this.addNodeEvent(node);
          };

          // let img1 = new Image()
          // const
        } else if (node.attrs.name === "stackedLine2") {
          let img = new Image();
          const bg = node.findOne(".StackedLine2Background");
          const id = node.getAttr("id");
          const pointName = node.getAttr("pointName");
          const deviceId = node.getAttr('deviceId')
          const point = node.getAttr('point')
          if (!node.attrs.chartType) {
            node.setAttr("chartType", "line");
          }
          if (!node.attrs.yPosition) {
            node.setAttr("yPosition", "1");
          }
          if (!node.attrs.xPosition) {
            node.setAttr("xPosition", "1");
          }
          if (!node.attrs.linearStart) {
            node.setAttr("linearStart", "#157FFF99");
          }
          if (!node.attrs.itemStyle) {
            node.setAttr("itemStyle", "#5470C6FF");
          }
          if (!node.attrs.linearEnd) {
            node.setAttr("linearEnd", "#061E3C99");
          }
          if (!node.attrs.xFont) {
            node.setAttr("xFont", 16);
          }
          if (!node.attrs.xColor) {
            node.setAttr("xColor", '#FFFFFFFF');
          }
          if (!node.attrs.yFont) {
            node.setAttr("yFont", 16);
          }
          if (!node.attrs.yColor) {
            node.setAttr("yColor", '#FFFFFFFF');
          }
          if (!node.attrs.labelFont) {
            node.setAttr("labelFont", 16);
          }
          if (!node.attrs.labelColor) {
            node.setAttr("labelColor", '#FFFFFFFF');
          }
          if (!node.attrs.maxPoints) {
            node.setAttr('maxPoints', 20)
          }
          if (node.attrs.colorLinear === undefined || node.attrs.colorLinear === null) {
            node.setAttr("colorLinear", true);
          }
          const image = node.findOne('.img')
          image.width(500)
          image.height(200)
          image.y(30)
          image.draggable(false)
          
          this.stackedLines2[id] = {
            deviceId,
            point
          };
          if (deviceId && point) {
            const width = node.scaleX() * 500;
            const height = node.scaleY() * 200;
            this.width[id] = width + "px";
            this.height[id] = height + "px";
            this.width = { ...this.width };
            this.height = { ...this.height };
            this.$nextTick(async () => {
              this.drawStackedLine(id, pointName, node);
            });
          }
          img.src = bg.attrs.src;
          img.onload = () => {
            bg.attrs.image = img;
            this.layer.draw();
            this.addNodeEvent(node);
            const stackedLine2Title = node.findOne(".stackedLine2Title")
            this.addNodeEvent(stackedLine2Title)
          };

          // let img1 = new Image()
          // const
        } else if (node.attrs.name === "StackedBar") {
          let img = new Image();
          const bg = node.findOne(".StackedBarBackground");
          const id = node.getAttr("id");
          const deviceId = node.getAttr('deviceId')
          if (deviceId) {
            if (!Array.isArray(deviceId)) {
              node.setAttr("deviceId", [deviceId])
            }
          } else {
            node.setAttr("deviceId", [])
          }
          const point = node.getAttr("point");
          if (!node.attrs.chartType) {
            node.setAttr("chartType", "bar");
          }
          if (!node.attrs.yPosition) {
            node.setAttr("yPosition", "1");
          }
          if (!node.attrs.xPosition) {
            node.setAttr("xPosition", "1");
          }
          if (!node.attrs.linearStart) {
            node.setAttr("linearStart", "#5470C6FF");
          }
          if (!node.attrs.xFont) {
            node.setAttr("xFont", 16);
          }
          if (!node.attrs.xColor) {
            node.setAttr("xColor", '#FFFFFFFF');
          }
          if (!node.attrs.yFont) {
            node.setAttr("yFont", 16);
          }
          if (!node.attrs.yColor) {
            node.setAttr("yColor", '#FFFFFFFF');
          }
          if (!node.attrs.labelFont) {
            node.setAttr("labelFont", 16);
          }
          if (!node.attrs.labelColor) {
            node.setAttr("labelColor", '#FFFFFFFF');
          }
          if (node.attrs.colorLinear === undefined || node.attrs.colorLinear === null) {
            node.setAttr("colorLinear", false);
          }
          const image = node.findOne('.img')
          image.width(500)
          image.height(200)
          this.stackedBars[id] = {
            deviceId,
            point
          };
          if (node.attrs.ratio) {
            if (node.attrs.LLJs && node.attrs.DBs && node.attrs.LLJPoint && node.attrs.DBPoint) {
              const width = node.scaleX() * 500;
              const height = node.scaleY() * 200;
              this.width[id] = width + "px";
              this.height[id] = height + "px";
              this.width = { ...this.width };
              this.height = { ...this.height };
              const attrs = node.attrs;
              if (
                attrs.term &&
                attrs.termNumber &&
                attrs.aggregationType
              ) {
                console.log('drawBar');
                
                this.getStackedBarData(
                  id,
                  attrs.deviceId,
                  attrs.point,
                  attrs.aggregationType,
                  attrs.term,
                  attrs.termNumber,
                  node
                );
              }
            }
          } else {
            if (deviceId && point) {
              const width = node.scaleX() * 500;
              const height = node.scaleY() * 200;
              this.width[id] = width + "px";
              this.height[id] = height + "px";
              this.width = { ...this.width };
              this.height = { ...this.height };
              const attrs = node.attrs;
              if (
                attrs.deviceId &&
                attrs.point &&
                attrs.term &&
                attrs.termNumber &&
                attrs.aggregationType
              ) {
                console.log('drawBar');
                
                this.getStackedBarData(
                  id,
                  attrs.deviceId,
                  attrs.point,
                  attrs.aggregationType,
                  attrs.term,
                  attrs.termNumber,
                  node
                );
              }
            }
          }
          
          img.src = backBorder;
          
          img.onload = () => {
            bg.attrs.image = img;
            this.layer.draw();
            this.addNodeEvent(node);
          };

          // let img1 = new Image()
          // const
        } else if (node.attrs.name === "StackedBar2") {
          let img = new Image();
          const bg = node.findOne(".StackedBar2Background")
          bg.width(500)
          bg.height(250)
          const id = node.getAttr("id");
          const deviceId = node.getAttr('deviceId')
          if (deviceId) {
            if (!Array.isArray(deviceId)) {
              node.setAttr("deviceId", [deviceId])
            }
          } else {
            node.setAttr("deviceId", [])
          }
          const point = node.getAttr("point");
          if (!node.attrs.chartType) {
            node.setAttr("chartType", "bar");
          }
          if (!node.attrs.yPosition) {
            node.setAttr("yPosition", "1");
          }
          if (!node.attrs.xPosition) {
            node.setAttr("xPosition", "1");
          }
          if (!node.attrs.linearStart) {
            node.setAttr("linearStart", "#5470C6FF");
          }
          if (!node.attrs.xFont) {
            node.setAttr("xFont", 16);
          }
          if (!node.attrs.xColor) {
            node.setAttr("xColor", '#FFFFFFFF');
          }
          if (!node.attrs.yFont) {
            node.setAttr("yFont", 16);
          }
          if (!node.attrs.yColor) {
            node.setAttr("yColor", '#FFFFFFFF');
          }
          if (!node.attrs.labelFont) {
            node.setAttr("labelFont", 16);
          }
          if (!node.attrs.labelColor) {
            node.setAttr("labelColor", '#FFFFFFFF');
          }
          if (node.attrs.colorLinear === undefined || node.attrs.colorLinear === null) {
            node.setAttr("colorLinear", false);
          }
          const image = node.findOne('.img')
          image.width(500)
          image.height(220)
          image.attrs.image = null
          this.stackedBars[id] = {
            deviceId,
            point
          };
          if (node.attrs.ratio) {
            if (node.attrs.LLJs && node.attrs.DBs && node.attrs.LLJPoint && node.attrs.DBPoint) {
              const width = node.scaleX() * 500;
              const height = node.scaleY() * 200;
              this.width[id] = width + "px";
              this.height[id] = height + "px";
              this.width = { ...this.width };
              this.height = { ...this.height };
              const attrs = node.attrs;
              if (
                attrs.term &&
                attrs.termNumber &&
                attrs.aggregationType
              ) {
                console.log('drawBar');
                
                this.getStackedBarData(
                  id,
                  attrs.deviceId,
                  attrs.point,
                  attrs.aggregationType,
                  attrs.term,
                  attrs.termNumber,
                  node
                );
              }
            }
          } else {
            if (deviceId && point) {
              const width = node.scaleX() * 500;
              const height = node.scaleY() * 200;
              this.width[id] = width + "px";
              this.height[id] = height + "px";
              this.width = { ...this.width };
              this.height = { ...this.height };
              const attrs = node.attrs;
              if (
                attrs.deviceId &&
                attrs.point &&
                attrs.term &&
                attrs.termNumber &&
                attrs.aggregationType
              ) {
                console.log('drawBar');
                
                this.getStackedBarData(
                  id,
                  attrs.deviceId,
                  attrs.point,
                  attrs.aggregationType,
                  attrs.term,
                  attrs.termNumber,
                  node
                );
              }
            }
          }
          
          img.src = bg.attrs.url;
          
          img.onload = () => {
            bg.attrs.image = img;
            this.layer.draw();
            this.addNodeEvent(node);
            const stackedbar2Title = node.findOne(".stackedbar2Title")
            this.addNodeEvent(stackedbar2Title)
          };

          // let img1 = new Image()
          // const
        } else if (node.attrs.name === 'effectiveAccumulation') {
          const img = node.findOne('.effectiveAccumulationBackground')
          img.width(410)
          img.height(200)
          const image = new Image()
          image.src = img.attrs.url
          image.onload = () => {
            img.attrs.image = image
            this.layer.draw()
            this.addNodeEvent(node);
            this.addNodeEvent(node.findOne('.title'));
            this.addNodeEvent(node.findOne('.el'));
            this.addNodeEvent(node.findOne('.fl'));
            this.addNodeEvent(node.findOne('.ev'));
            this.addNodeEvent(node.findOne('.fv'));
            this.addNodeEvent(node.findOne('.ratioLabel'));
            this.addNodeEvent(node.findOne('.ratioValue'));
            this.addNodeEvent(node.findOne('.ratioUnit'));
          }
          const ratio = node.findOne('.ratio')
          ratio.cache({
            padding: 10
          })
          ratio.filters([Konva.Filters.Blur])
          ratio.blurRadius(5)
          const e = node.getAttr('e') || []
          const f = node.getAttr('f') || []
          const deviceCodes = e.concat(f)
          if (deviceCodes.length === 0) {
            node.findOne('.ev')?.text('0')
            node.findOne('.fv')?.text('0')
            node.findOne('.ratioValue')?.text('0.00000')
            return
          }
          let endDate = +new Date()
          let startDate = endDate - 30 * 24 * 3600 * 1000
          endDate = moment(endDate).format('YYYY-MM-DD')
          startDate = moment(startDate).format('YYYY-MM-DD')
          const { data } = await getMonthReport(startDate, endDate, deviceCodes + '')
          let target, totalNm = 0, totalKwh = 0, totalP
          for (let i = data.length - 2; i > -1; i--) {
            target = data[i]
            if (target.electricityMeterAccumulation > 0) {
              totalKwh = target.electricityMeterAccumulation - this.eReduce
              totalKwh = totalKwh > 0 ? totalKwh : 0
              if (target.flowMeterAccumulation > 0) {
                totalNm = target.flowMeterAccumulation - this.gReduce
                totalNm = totalNm > 0 ? totalNm : 0
              }
              break
            }
          }
          totalP = totalNm == 0 ? 0 : (totalKwh / totalNm)
          totalP = totalP.toFixed(5)
          totalKwh = totalKwh.toFixed(0)
          totalNm = totalNm.toFixed(0)
          node.findOne('.ev')?.text(totalKwh)
          node.findOne('.fv')?.text(totalNm)
          node.findOne('.ratioValue')?.text(totalP)
        } else if (node.attrs.name === 'effectiveCurrent') {
          const img = node.findOne('.effectiveCurrentBackground')
          img.width(410)
          img.height(200)
          const image = new Image()
          image.src = img.attrs.url
          image.onload = () => {
            img.attrs.image = image
            this.layer.draw()
            this.addNodeEvent(node);
            this.addNodeEvent(node.findOne('.title'));
            this.addNodeEvent(node.findOne('.el'));
            this.addNodeEvent(node.findOne('.fl'));
            this.addNodeEvent(node.findOne('.ev'));
            this.addNodeEvent(node.findOne('.fv'));
            this.addNodeEvent(node.findOne('.ratioLabel'));
            this.addNodeEvent(node.findOne('.ratioValue'));
            this.addNodeEvent(node.findOne('.ratioUnit'));
          }
          const ratio = node.findOne('.ratio')
          ratio.cache({
            padding: 10
          })
          ratio.filters([Konva.Filters.Blur])
          ratio.blurRadius(5)
          const e = node.getAttr('e') || []
          const f = node.getAttr('f') || []
          const deviceCodes = e.concat(f)
          if (deviceCodes.length === 0) {
            node.findOne('.ev')?.text('0')
            node.findOne('.fv')?.text('0')
            node.findOne('.ratioValue')?.text('0.00000')
            return
          } else {
            this.connectEffectiveWebscoket(node, deviceCodes + '')
          }
        } else if (node.attrs.name === 'socialEffective') {
          const img = node.findOne('.socialEffectiveBackground')
          img.width(410)
          img.height(120)
          const image = new Image()
          image.src = img.attrs.url
          image.onload = () => {
            img.attrs.image = image
            this.layer.draw()
            this.addNodeEvent(node);
            this.addNodeEvent(node.findOne('.title'));
            this.addNodeEvent(node.findOne('.powerTitle'));
            this.addNodeEvent(node.findOne('.powerValue'));
            this.addNodeEvent(node.findOne('.CO2Title'));
            this.addNodeEvent(node.findOne('.CO2Value'));
          }

          const e = node.getAttr('e') || []
          const f = node.getAttr('f') || []
          const deviceCodes = e.concat(f)
          if (deviceCodes.length === 0) {
            this.currentItem.findOne('.ev')?.text('0')
            this.currentItem.findOne('.fv')?.text('0')
            this.currentItem.findOne('.ratioValue')?.text('0.00000')
            return
          } else {
            this.setSocialEffectiveState(node, deviceCodes + '')
          }
        } else if (node.attrs.name === 'runningState') {
          const img = node.findOne('.runningStateBackground')
          img.width(410)
          img.height(260)
          const image = new Image()
          image.src = img.attrs.url
          image.onload = () => {
            img.attrs.image = image
            this.layer.draw()
            this.addNodeEvent(node);
            this.addNodeEvent(node.findOne('.stateTitle'));
            this.addNodeEvent(node.findOne('.runningValue'));
            this.addNodeEvent(node.findOne('.runningImg'));
            this.addNodeEvent(node.findOne('.runningDescription'));
            this.addNodeEvent(node.findOne('.sleepingValue'));
            this.addNodeEvent(node.findOne('.sleepingImg'));
            this.addNodeEvent(node.findOne('.sleepingDescription'));
            this.addNodeEvent(node.findOne('.offlineValue'));
            this.addNodeEvent(node.findOne('.offlineImg'));
            this.addNodeEvent(node.findOne('.offlineDescription'));
            this.addNodeEvent(node.findOne('.errorValue'));
            this.addNodeEvent(node.findOne('.offlineImg'));
            this.addNodeEvent(node.findOne('.errorDescription'));
            this.addNodeEvent(node.findOne('.maintainValue'));
            this.addNodeEvent(node.findOne('.maintainImg'));
            this.addNodeEvent(node.findOne('.maintainDescription'));
          }
          const runningImg = node.findOne('.runningImg')
          const runningI = new Image()
          runningI.src = runningImg.attrs.url
          runningI.onload = () => {
            runningImg.attrs.image = runningI
            this.layer.draw()
          }
          const sleepingImg = node.findOne('.sleepingImg')
          const sleepingI = new Image()
          sleepingI.src = sleepingImg.attrs.url
          sleepingI.onload = () => {
            sleepingImg.attrs.image = sleepingI
            this.layer.draw()
          }
          const offlineImg = node.findOne('.offlineImg')
          const offlineI = new Image()
          offlineI.src = offlineImg.attrs.url
          offlineI.onload = () => {
            offlineImg.attrs.image = offlineI
            this.layer.draw()
          }
          const errorImg = node.findOne('.errorImg')
          const errorI = new Image()
          errorI.src = errorImg.attrs.url
          errorI.onload = () => {
            errorImg.attrs.image = errorI
            this.layer.draw()
          }
          const maintainImg = node.findOne('.maintainImg')
          const maintainI = new Image()
          maintainI.src = maintainImg.attrs.url
          maintainI.onload = () => {
            maintainImg.attrs.image = maintainI
            this.layer.draw()
          }
        } else if (node.attrs.name === 'warning') {
          const img = node.findOne('.warningBackground')
          img.width(430)
          img.height(260)
          const image = new Image()
          image.src = img.attrs.url
          image.onload = () => {
            img.attrs.image = image
            this.layer.draw()
            this.addNodeEvent(node);
          }
        }
      });
      this.stage.find(".flowingPipe").forEach(group => {
        const anim = this.startFlowingAnimation(group);
        this.animation.push(anim);
        this.addNodeEvent(group);
      });
      this.stage.find(".datetime").forEach(node => {
        this.addNodeEvent(node);
        AddDatetimeToAnim(node);
      });
      this.stage.find(".dataRow").forEach(item => {
        const device = item.getAttr("device");
        const point = item.getAttr("dataPoint");
        if (!device || !point) {
          return;
        }
        (point.details || []).forEach(d => {
          if (d.locale === "zh-CH") {
            point.zh = d.name;
          }
          if (d.locale === "en-US") {
            point.en = d.name;
          }
        });
        if (!point.zh) {
          point.zh = point.name;
        }
        if (!point.en) {
          point.en = point.zh;
        }
        const key = item.findOne(".dataKey");
        if (key) {
          let name = key.getAttr("selfDefinedName");
          if (name) {
            point.zh = point.en = name;
          }
          // const width = key.width()
          key.text(point[this.lang]);
          // const value = item.findOne('.dataValue')
          // if (value) {
          //   value.x(value.x() + key.width() - width)
          // }
          // const unit = item.findOne('.dataUnit')
          // if (unit) {
          //   unit.x(unit.x() + key.width() - width)
          // }
        }
      });
      this.stage.find(".monitorRow").forEach(item => {
        const device = item.getParent().getAttr("device");
        const point = item.getAttr("dataPoint");
        if (!device || !point) {
          return;
        }
        (point.details || []).forEach(d => {
          if (d.locale === "zh-CH") {
            point.zh = d.name;
          }
          if (d.locale === "en-US") {
            point.en = d.name;
          }
        });
        if (!point.zh) {
          point.zh = point.name;
        }
        if (!point.en) {
          point.en = point.zh;
        }
        const key = item.findOne(".monitorKey");
        if (key) {
          let name = key.getAttr("selfDefinedName");
          if (name) {
            point.zh = point.en = name;
          }
          // const width = key.width()
          key.text(point[this.lang]);
          // const value = item.findOne('.monitorValue')
          // if (value) {
          //   value.x(value.x() + key.width() - width)
          // }
          // const unit = item.findOne('.monitorUnit')
          // if (unit) {
          //   unit.x(unit.x() + key.width() - width)
          // }
        }
      });
    },
    initStage() {
      this.stage = new Konva.Stage({
        backgroundColor: this.colorPicker.obj.hex,
        width: window.innerWidth,
        height: window.innerHeight,
        container: "container",
        draggable: true
      });
    },
    addStageEvent(stage) {
      let isPaint = false;
      let rect = null;
      let startPos = null;
      stage.draggable(true);
      stage.on("mousedown touchstart", ev => {
        const pos = stage.getRelativePointerPosition();
        if (ev.evt.ctrlKey && this.transformer.nodes().length === 0) {
          stage.draggable(false);
          isPaint = true;
          rect = stage.findOne("#SelectBox");
          if (rect != null) {
            rect.destroy();
          }
          rect = this.drawRectSelectionBox(pos);
          this.layer.add(rect);
        }
        startPos = pos;
      });
      stage.on("mouseup touchend", ev => {
        if (isPaint) {
          isPaint = false;
          rect = stage.findOne("#SelectBox");
          const box = rect.getClientRect({
            relativeTo: stage
          });
          const nodes = this.layer
            .getChildren()
            .filter(node => node.name() !== "transformer")
            .filter(node => {
              const cr = node.getClientRect({
                relativeTo: stage
              });
              return (
                cr.x >= box.x &&
                cr.y >= box.y &&
                cr.x <= box.x + box.width &&
                cr.y <= box.y + box.height
              );
            });
          nodes.forEach(node => node.draggable(true));
          rect.fill("rgba(255,255,255,0)");
          this.transformer.nodes(nodes);
          this.transformer.enabledAnchors([
            "top-left",
            "top-center",
            "top-right",
            "middle-right",
            "middle-left",
            "bottom-left",
            "bottom-center",
            "bottom-right"
          ]);
          this.transformer.rotateEnabled(true);
          stage.draggable(true);
        }
      });
      stage.on("mousemove touchmove", ev => {
        if (isPaint) {
          const pos = stage.getRelativePointerPosition();
          rect = stage.findOne("#SelectBox");
          const width = pos.x - startPos.x;
          const height = pos.y - startPos.y;
          rect.width(width);
          rect.height(height);
          this.layer.draw();
        }
      });
      stage.on("click", ev => {
        if (!isPaint) {
          const rect = stage.findOne("#SelectBox");
          if (rect !== undefined) {
            rect.destroy();
          }
        }
        this.transformer.nodes([]);
        this.currentItem = null;
      });
      const scaleBy = 1.05;
      stage.on("wheel", ev => {
        if (!ev.evt.ctrlKey) {
          return;
        }
        ev.evt.preventDefault();

        const oldScale = stage.scaleX();
        const pointer = stage.getPointerPosition();

        const mousePointTo = {
          x: (pointer.x - stage.x()) / oldScale,
          y: (pointer.y - stage.y()) / oldScale
        };

        const direction = ev.evt.deltaY > 0 ? -1 : 1;
        const newScale =
          direction > 0 ? oldScale * scaleBy : oldScale / scaleBy;

        stage.scale({
          x: newScale,
          y: newScale
        });

        const newPos = {
          x: pointer.x - mousePointTo.x * newScale,
          y: pointer.y - mousePointTo.y * newScale
        };
        stage.position(newPos);
      });
    },
    drawRectSelectionBox(pos) {
      return new Konva.Rect({
        id: "SelectBox",
        x: pos.x,
        y: pos.y,
        width: 0,
        height: 0,
        draggable: true,
        fill: "rgba(255,255,255,0.07)"
      });
    },
    addNodeEvent(node) {
      if (!node) return;
      node.on("mousedown", ev => {
        const n = ev.currentTarget;
        n.draggable(true);
        this.transformer.zIndex(this.layer.children.length - 1);
        if (ev.evt.ctrlKey) {
          const nodes = this.transformer.nodes();
          nodes.push(n);
          this.transformer.nodes(nodes);
        } else {
          this.transformer.nodes([n]);
          if (n.name() === "dataBlockHeader") {
            this.transformer.enabledAnchors(["top-center", "bottom-center"]);
            this.transformer.rotateEnabled(false);
          } else if (n.name() === "flowingPipe") {
            this.transformer.enabledAnchors(["middle-right", "middle-left"]);
            this.transformer.rotateEnabled(true);
          } else {
            this.transformer.enabledAnchors([
              "top-left",
              "top-center",
              "top-right",
              "middle-right",
              "middle-left",
              "bottom-left",
              "bottom-center",
              "bottom-right"
            ]);
            this.transformer.rotateEnabled(true);
          }
        }
        this.currentItem = n;
        ev.cancelBubble = true;
        if (this.currentItem.name() === "dataRow") {
          this.selectedDataRow();
        }
        if (this.currentItem.attrs.rule && this.currentItem.attrs.rule.device) {
          const {
            driverType,
            protocolCode
          } = this.currentItem.attrs.rule.device;
          getProtocol(protocolCode)
            .then(({ data }) => {
              this.rule = data.points;
            })
            .catch(() => {
              // this.$message.error("请求失败")
            });
        }
      });
      node.on("click", async ev => {
        this.currentStationBlock = [];
        this.protocolDataPoints = [];
        this.stationDataPoints.forEach(item => {
          item.show = false;
        });
        const n = ev.currentTarget;
        this.transformer.zIndex(this.layer.children.length - 1);
        if (this.currentItem.attrs.type === "stationunit") {
          const node = this.currentItem.getParent();
          if (node.attrs.station) {
            const station = node.attrs.station;
            console.log(station);
            this.currentItem.setAttr("station", {
              id: station.id,
              name: station.name,
              code: station.code
            });
            this.$forceUpdate();
          }

          this.stationDataBlockShow = true;
          const keys = node.find(".dataKey");
          keys.forEach(key => {
            const item = this.stationDataPoints.find(
              item => item.name === key.text()
            );
            if (item) {
              item.show = true;
            }
          });
        }
        ev.cancelBubble = true;
        if (this.currentItem.name() === "monitorBlock") {
          const device = this.currentItem.getAttr("device");
          let dataRows = this.currentItem.find(".monitorRow");
          if (device) {
            const points = {};
            dataRows.forEach(d => {
              const p = d.getAttr("dataPoint");
              if (p) {
                points[p.code] = true;
              }
            });
            getProtocol(device.protocolCode)
              .then(({ data }) => {
                this.protocolDataPoints = data.points.filter(d => d.dataWrite !== 2).map(p => {
                  (p.details || []).forEach(d => {
                    if (d.locale === "zh-CH") {
                      p.zh = d.name;
                    }
                    if (d.locale === "en-US") {
                      p.en = d.name;
                    }
                  });
                  if (!p.zh) {
                    p.zh = p.name;
                  }
                  if (!p.en) {
                    p.en = p.zh;
                  }
                  p.show = !!points[p.code];
                  return p;
                });
              })
              .catch(() => {
                // this.$message.error("请求失败")
              });
          } else {
            this.protocolDataPoints = [];
          }
        }
        if (this.currentItem.name() === "dataRow") {
          const device = this.currentItem.getAttr("device");
          if (device) {
            const dataPoint = this.currentItem.getAttr("dataPoint");
            getProtocol(device.protocolCode)
              .then(({ data }) => {
                this.protocolDataPoints = data.points.filter(d => d.dataWrite !== 2).map(p => {
                  (p.details || []).forEach(d => {
                    if (d.locale === "zh-CH") {
                      p.zh = d.name;
                    }
                    if (d.locale === "en-US") {
                      p.en = d.name;
                    }
                  });
                  if (!p.zh) {
                    p.zh = p.name;
                  }
                  if (!p.en) {
                    p.en = p.zh;
                  }
                  return p;
                });
                this.protocolDataPoints.filter(
                  item => item.code === dataPoint.code
                )[0].show = true;
              })
              .catch(() => {
                // this.$message.error("请求失败")
              });
          } else {
            this.protocolDataPoints = [];
          }
        }
        if (this.currentItem.name() === "controlWidget") {
          const dtuCode = this.currentItem.getAttr("dtuCode")
          const deviceCode = this.currentItem.getAttr("deviceCode")
          const pointCode = this.currentItem.getAttr("pointCode")
          const value = this.currentItem.getAttr("value")
          if (dtuCode && deviceCode && pointCode) {
            const { message } = await switchDevice({
              dtuCode,
              deviceCode,
              pointCode,
              value
            })
            this.$message.success(message)
          }
        }
        if (this.currentItem.name() === "StackedLine") {
          const protocolCode = this.currentItem.getAttr("protocolCode");
          if (protocolCode) {
            const { data } = await getProtocol(protocolCode);
            this.pointsOfStackedLine = data.points.filter(d => d.dataWrite !== 2);
          }
          let hex8 = this.currentItem.getAttr('itemStyle') || '#5470C6FF'
          this.itemStyle = this.getTotalColorOptionByHex8(hex8)
          hex8 = this.currentItem.getAttr('linearStart') || '#157FFF99'
          this.linearStart = this.getTotalColorOptionByHex8(hex8)
          hex8 = this.currentItem.getAttr('linearEnd') || '#061E3C99'
          this.linearEnd = this.getTotalColorOptionByHex8(hex8)
          hex8 = this.currentItem.getAttr('xColor') || '#FFFFFFFF'
          this.xColor = this.getTotalColorOptionByHex8(hex8)
          hex8 = this.currentItem.getAttr('yColor') || '#FFFFFFFF'
          this.yColor = this.getTotalColorOptionByHex8(hex8)
          hex8 = this.currentItem.getAttr('labelColor') || '#FFFFFFFF'
          this.labelColor = this.getTotalColorOptionByHex8(hex8)
        }
        if (this.currentItem.name() === "stackedLine2") {
          const protocolCode = this.currentItem.getAttr("protocolCode");
          if (protocolCode) {
            const { data } = await getProtocol(protocolCode);
            this.pointsOfStackedLine2 = data.points.filter(d => d.dataWrite !== 2);
          }
          let hex8 = this.currentItem.getAttr('itemStyle') || '#5470C6FF'
          this.itemStyle = this.getTotalColorOptionByHex8(hex8)
          hex8 = this.currentItem.getAttr('linearStart') || '#157FFF99'
          this.linearStart = this.getTotalColorOptionByHex8(hex8)
          hex8 = this.currentItem.getAttr('linearEnd') || '#061E3C99'
          this.linearEnd = this.getTotalColorOptionByHex8(hex8)
          hex8 = this.currentItem.getAttr('xColor') || '#FFFFFFFF'
          this.xColor = this.getTotalColorOptionByHex8(hex8)
          hex8 = this.currentItem.getAttr('yColor') || '#FFFFFFFF'
          this.yColor = this.getTotalColorOptionByHex8(hex8)
          hex8 = this.currentItem.getAttr('labelColor') || '#FFFFFFFF'
          this.labelColor = this.getTotalColorOptionByHex8(hex8)
        }
        if (this.currentItem.name() === "StackedBar") {
          if (this.currentItem.getAttr("ratio")) {
            let v = this.currentItem.getAttr("LLJs") || []
            const promises = []
            let f
            for (let i = 0; i < this.flowList.length; i++) {
              f = this.flowList[i]
              if (v.find(fid => fid === f.id)) {
                promises.push(new Promise(async resolve => {
                  try {
                    const { data } = await getProtocol(f.protocolCode)
                    resolve(
                      data.points
                        .filter(d => d.dataWrite !== 2)
                        .map(p => {
                          (p.details || []).forEach(d => {
                            if (d.locale === "zh-CH") {
                              p.zh = d.name;
                            }
                            if (d.locale === "en-US") {
                              p.en = d.name;
                            }
                          })
                          if (!p.zh) {
                            p.zh = p.name;
                          }
                          if (!p.en) {
                            p.en = p.zh;
                          }
                          return p
                        })
                    )
                  } catch(e) {
                    console.log(e)
                    resolve([])
                  }
                }))
              }
            }
            const points = await Promise.all(promises)
            let pointMap = {}, p
            for (let i = 0; i < points.length; i++) {
              for (let j = 0; j < points[i].length; j++) {
                p = points[i][j]
                if (pointMap[p.code]) {
                  pointMap[p.code].count++
                } else {
                  pointMap[p.code] = {
                    point: p,
                    count: 1
                  }
                }
              }
            }
            const LLJPoints = []
            for (let key in pointMap) {
              if (pointMap[key].count === points.length) {
                LLJPoints.push(pointMap[key].point)
              }
            }
            this.LLJPoints = LLJPoints
            v = this.currentItem.getAttr("DBs") || []
            const promises2 = []
            let e
            for (let i = 0; i < this.electricityList.length; i++) {
              e = this.electricityList[i]
              if (v.find(fid => fid === e.id)) {
                promises2.push(new Promise(async resolve => {
                  try {
                    const { data } = await getProtocol(e.protocolCode)
                    resolve(
                      data.points
                        .filter(d => d.dataWrite !== 2)
                        .map(p => {
                          (p.details || []).forEach(d => {
                            if (d.locale === "zh-CH") {
                              p.zh = d.name;
                            }
                            if (d.locale === "en-US") {
                              p.en = d.name;
                            }
                          })
                          if (!p.zh) {
                            p.zh = p.name;
                          }
                          if (!p.en) {
                            p.en = p.zh;
                          }
                          return p
                        })
                    )
                  } catch(e) {
                    console.log(e)
                    resolve([])
                  }
                }))
              }
            }
            const points2 = await Promise.all(promises2)
            let pointMap2 = {}, p2
            for (let i = 0; i < points2.length; i++) {
              for (let j = 0; j < points2[i].length; j++) {
                p2 = points2[i][j]
                if (pointMap2[p2.code]) {
                  pointMap2[p2.code].count++
                } else {
                  pointMap2[p2.code] = {
                    point: p2,
                    count: 1
                  }
                }
              }
            }
            const DBPoints = []
            for (let key in pointMap2) {
              if (pointMap2[key].count === points2.length) {
                DBPoints.push(pointMap2[key].point)
              }
            }
            this.DBPoints = DBPoints
          } else {
            let protocolCode = this.currentItem.getAttr("protocolCode");
            if (protocolCode) {
              if (!Array.isArray(protocolCode)) {
                protocolCode = [protocolCode]
              }
              const promises = []
              for (let i = 0; i < protocolCode.length; i++) {
                promises.push(new Promise(async resolve => {
                  try {
                    const { data } = await getProtocol(protocolCode[i])
                    resolve(
                      data.points
                        .filter(d => d.dataWrite !== 2)
                        .map(p => {
                          (p.details || []).forEach(d => {
                            if (d.locale === "zh-CH") {
                              p.zh = d.name;
                            }
                            if (d.locale === "en-US") {
                              p.en = d.name;
                            }
                          })
                          if (!p.zh) {
                            p.zh = p.name;
                          }
                          if (!p.en) {
                            p.en = p.zh;
                          }
                          return p
                        })
                    )
                  } catch(e) {
                    console.log(e)
                    resolve([])
                  }
                }))
              }
              const points = await Promise.all(promises)
              let pointMap = {}, p
              for (let i = 0; i < points.length; i++) {
                for (let j = 0; j < points[i].length; j++) {
                  p = points[i][j]
                  if (pointMap[p.code]) {
                    pointMap[p.code].count++
                  } else {
                    pointMap[p.code] = {
                      point: p,
                      count: 1
                    }
                  }
                }
              }
              const pointsList = []
              for (let key in pointMap) {
                if (pointMap[key].count === points.length) {
                  pointsList.push(pointMap[key].point)
                }
              }
              this.pointsOfStackedBar = pointsList
            }
          }
          let hex8 = this.currentItem.getAttr('itemStyle') || '#5470C6FF'
          this.itemStyle = this.getTotalColorOptionByHex8(hex8)
          hex8 = this.currentItem.getAttr('linearStart') || '#157FFF99'
          this.linearStart = this.getTotalColorOptionByHex8(hex8)
          hex8 = this.currentItem.getAttr('linearEnd') || '#061E3C99'
          this.linearEnd = this.getTotalColorOptionByHex8(hex8)
          hex8 = this.currentItem.getAttr('xColor') || '#FFFFFFFF'
          this.xColor = this.getTotalColorOptionByHex8(hex8)
          hex8 = this.currentItem.getAttr('yColor') || '#FFFFFFFF'
          this.yColor = this.getTotalColorOptionByHex8(hex8)
          hex8 = this.currentItem.getAttr('labelColor') || '#FFFFFFFF'
          this.labelColor = this.getTotalColorOptionByHex8(hex8)
        }
        if (this.currentItem.name() === "StackedBar2") {
          let protocolCode = this.currentItem.getAttr("protocolCode");
          if (protocolCode) {
            if (!Array.isArray(protocolCode)) {
              protocolCode = [protocolCode]
            }
            const promises = []
            for (let i = 0; i < protocolCode.length; i++) {
              promises.push(new Promise(async resolve => {
                try {
                  const { data } = await getProtocol(protocolCode[i])
                  resolve(
                    data.points
                      .filter(d => d.dataWrite !== 2)
                      .map(p => {
                        (p.details || []).forEach(d => {
                          if (d.locale === "zh-CH") {
                            p.zh = d.name;
                          }
                          if (d.locale === "en-US") {
                            p.en = d.name;
                          }
                        })
                        if (!p.zh) {
                          p.zh = p.name;
                        }
                        if (!p.en) {
                          p.en = p.zh;
                        }
                        return p
                      })
                  )
                } catch(e) {
                  console.log(e)
                  resolve([])
                }
              }))
            }
            const points = await Promise.all(promises)
            let pointMap = {}, p
            for (let i = 0; i < points.length; i++) {
              for (let j = 0; j < points[i].length; j++) {
                p = points[i][j]
                if (pointMap[p.code]) {
                  pointMap[p.code].count++
                } else {
                  pointMap[p.code] = {
                    point: p,
                    count: 1
                  }
                }
              }
            }
            const pointsList = []
            for (let key in pointMap) {
              if (pointMap[key].count === points.length) {
                pointsList.push(pointMap[key].point)
              }
            }
            this.pointsOfStackedBar = pointsList
          }
          let hex8 = this.currentItem.getAttr('itemStyle') || '#5470C6FF'
          this.itemStyle = this.getTotalColorOptionByHex8(hex8)
          hex8 = this.currentItem.getAttr('linearStart') || '#157FFF99'
          this.linearStart = this.getTotalColorOptionByHex8(hex8)
          hex8 = this.currentItem.getAttr('linearEnd') || '#061E3C99'
          this.linearEnd = this.getTotalColorOptionByHex8(hex8)
          hex8 = this.currentItem.getAttr('xColor') || '#FFFFFFFF'
          this.xColor = this.getTotalColorOptionByHex8(hex8)
          hex8 = this.currentItem.getAttr('yColor') || '#FFFFFFFF'
          this.yColor = this.getTotalColorOptionByHex8(hex8)
          hex8 = this.currentItem.getAttr('labelColor') || '#FFFFFFFF'
          this.labelColor = this.getTotalColorOptionByHex8(hex8)
        }
        this.currentItem = n;
      });
      let flag = true;
      node.on("dragend", ev => {
        if (flag) {
          flag = false;
          this.cache();
          setTimeout(() => {
            flag = true;
          }, 3000);
        }
      });
      const mp = ["dataKey", "dataValue", "dataUnit"];
      if (mp.includes(node.name())) {
        node.on("dragend", ev => {
          const n = ev.currentTarget;
          const row = n.getParent();
          if (n.name() !== "dataKey") {
            const key = row.findOne(".dataKey");
            if (Math.abs(key.y() - n.y()) <= 15) {
              n.y(key.y());
            }
          }
        });
      }
    },
    selectedDataRow() {
      const device = this.currentItem.getAttr("device");
      if (device) {
        const dataPoint = this.currentItem.getAttr("dataPoint");
        getProtocol(device.protocolCode)
          .then(({ data }) => {
            this.protocolDataPoints = data.points.filter(d => d.dataWrite !== 2).map(p => {
              (p.details || []).forEach(d => {
                if (d.locale === "zh-CH") {
                  p.zh = d.name;
                }
                if (d.locale === "en-US") {
                  p.en = d.name;
                }
              });
              if (!p.zh) {
                p.zh = p.name;
              }
              if (!p.en) {
                p.en = p.zh;
              }
              return p;
            });
            this.protocolDataPoints.filter(
              item => item.code === dataPoint.code
            )[0].show = true;
          })
          .catch(e => {
            console.log(e);
            // this.$message.error("请求失败")
          });
      } else {
        this.protocolDataPoints = [];
      }
      this.$forceUpdate();
    },
    initTransformer() {
      const rotationSnapsArray = [];
      for (let i = 0; i <= 360; i += 5) {
        rotationSnapsArray.push(i);
      }
      this.transformer = new Konva.Transformer({
        name: "transformer",
        nodes: [],
        borderDash: [10, 3],
        anchorStrokeWidth: 1,
        anchorStroke: "#2c2c2c",
        anchorFill: "#fff",
        rotateAnchorOffset: 20,
        rotationSnaps: rotationSnapsArray,
        padding: 3,
        anchorSize: 10,
        borderStroke: "#67c0ff",
        boundBoxFunc: (oldBox, newBox) => {
          if (newBox.width <= 1 || newBox.height <= 1) {
            return oldBox;
          }
          return newBox;
        }
      });
    },
    startFlowingAnimation,
    drawFlowingPipe,
    addImageToStage(src, extra) {
      const imgObj = new Image();
      imgObj.src = src;
      const image = new Konva.Image({
        attrs: {
          image: imgObj,
          rule: {
            id: nanoid(),
            device: "",
            data: "",
            min: "",
            max: "",
            visible: ""
          }
        },
        name: "img",
        url: src,
        image: imgObj,
        draggable: false
      });
      if (extra === "stationunit") {
        image.width(270);
        image.height(120);
        const position = this.stage.getRelativePointerPosition();
        const defaultContent = {
          key: "#KEY",
          value: "#VALUE",
          unit: "#UNIT"
        };
        const group = new Konva.Group({
          name: "stationunit",
          x: position.x,
          y: position.y
        });
        const innerGroup = new Konva.Group({
          name: "innerGroup",
          x: 0,
          y: 0
        });
        const simpleText = new Konva.Text({
          name: "label",
          x: 20,
          y: 30,
          text: "Label",
          fontSize: 28,
          fontFamily: "Calibri",
          fill: "#fff"
        });
        const bg = new Konva.Rect({
          name: "background",
          x: 20,
          y: 60,
          width: 225,
          height: 30,
          fill: "rgba(249,240,255,0.25)",
          cornerRadius: 3,
          draggable: false
        });
        const key = new Konva.Text({
          name: "dataKey",
          x: bg.x() + 8,
          y: bg.y() + 8,
          text: defaultContent.key,
          fill: "#fff",
          fontSize: 14
        });
        const value = new Konva.Text({
          name: "dataValue",
          x: key.x() + key.width() + 60,
          y: key.y(),
          text: defaultContent.value,
          fill: "#fff",
          fontSize: 14
        });
        const unit = new Konva.Text({
          name: "dataUnit",
          x: value.x() + value.width() + 10,
          y: key.y(),
          text: defaultContent.unit,
          fill: "#fff",
          fontSize: 14
        });
        image.attrs.type = "stationunit";
        simpleText.text("Label");
        innerGroup.add(bg, key, value, unit);
        this.addNodeEvent(innerGroup);
        this.addNodeEvent(simpleText);
        this.addNodeEvent(key);
        this.addNodeEvent(value);
        this.addNodeEvent(unit);
        group.add(image, simpleText, innerGroup);
        this.addNodeEvent(group);
        this.layer.add(group);
        this.layer.draw();
        this.currentItem = group;
        this.transformer.nodes([group]);
        this.stationDataPoints.forEach(item => {
          item.show = false;
        });
        this.transformer.enabledAnchors([
          "top-left",
          "top-center",
          "top-right",
          "middle-right",
          "middle-left",
          "bottom-left",
          "bottom-center",
          "bottom-right"
        ]);
        return;
      }
      // 拖拽生成实时数据图表
      if (extra === "StackedLine") {
        image.width(500);
        image.height(200);
        const position = this.stage.getRelativePointerPosition();
        const group = new Konva.Group({
          name: "StackedLine",
          x: position.x,
          y: position.y
        });
        let id = 'd' + nanoid()
        group.setAttr('id', id)
        this.stackedLines[id] = {
          deviceId: '',
          point: ''
        }
        // 实时数据图表默认配置
        group.setAttr("chartType", "line");
        group.setAttr("yPosition", "1");
        group.setAttr("xPosition", "1");
        group.setAttr("xFont", 16);
        group.setAttr("xColor", '#FFFFFFFF');
        group.setAttr("yFont", 16);
        group.setAttr("yColor", '#FFFFFFFF');
        group.setAttr("labelFont", 16);
        group.setAttr("labelColor", '#FFFFFFFF');
        group.setAttr("colorLinear", true);
        group.setAttr("itemStyle", '#5470C6FF');
        group.setAttr("linearEnd", '#061E3C99');
        group.setAttr("linearStart", '#157FFF99');
        group.setAttr('maxPoints', 20)
        const imgObj = new Image();
        imgObj.src = backBorder;
        const bg = new Konva.Image({
          attrs: {
            image: imgObj
          },
          name: "StackedLineBackground",
          x: 0,
          y: 0,
          width: 500,
          height: 220,
          draggable: false,
          image: imgObj
        });
        console.log(image);
        
        group.add(image, bg);
        group.position(this.stage.getRelativePointerPosition());
        this.addNodeEvent(group);
        this.layer.add(group);
        this.layer.draw();
        // group.on('transformend', () => {
        //   const width = group.scaleX() * 500
        //   const height = group.scaleY() * 200
        //   this.width = width + 'px'
        //   this.height = height + 'px'
        //   this.$nextTick(() => {
        //     this.StackedLine.resize()
        //     const img = new Image()
        //     img.src = this.StackedLine.getDataURL('png')
        //     const image = group.findOne('.img')
        //     image.attrs.image = img
        //     image.scaleX(1 / group.scaleX())
        //     image.scaleY(1 / group.scaleY())
        //   })
        // })
        return;
      }
      // 拖拽生成聚合数据图表
      if (extra === "StackedBar") {
        image.width(500);
        image.height(200);
        const position = this.stage.getRelativePointerPosition();
        const group = new Konva.Group({
          name: "StackedBar",
          x: position.x,
          y: position.y
        });
        const id = 'd' + nanoid()
        group.setAttr('id', id)
        this.stackedBars[id] = {
          deviceId: [],
          point: ''
        }
        group.setAttr("chartType", "bar");
        group.setAttr("yPosition", "1");
        group.setAttr("xPosition", "1");
        group.setAttr("linearStart", "#5470C6FF");
        group.setAttr("xFont", 16);
        group.setAttr("xColor", '#FFFFFFFF');
        group.setAttr("yFont", 16);
        group.setAttr("yColor", '#FFFFFFFF');
        group.setAttr("labelFont", 16);
        group.setAttr("labelColor", '#FFFFFFFF');
        group.setAttr("colorLinear", false);
        const imgObj = new Image();
        imgObj.src = backBorder;
        const bg = new Konva.Image({
          attrs: {
            image: imgObj
          },
          name: "StackedBarBackground",
          x: 0,
          y: 0,
          width: 500,
          height: 220,
          draggable: false,
          image: imgObj,
          url: backBorder
        });
        
        group.add(image, bg);
        group.position(this.stage.getRelativePointerPosition());
        this.addNodeEvent(group);
        this.layer.add(group);
        this.layer.draw();
        // group.on('transformend', () => {
        //   const width = group.scaleX() * 500
        //   const height = group.scaleY() * 200
        //   this.width = width + 'px'
        //   this.height = height + 'px'
        //   this.$nextTick(() => {
        //     this.StackedLine.resize()
        //     const img = new Image()
        //     img.src = this.StackedLine.getDataURL('png')
        //     const image = group.findOne('.img')
        //     image.attrs.image = img
        //     image.scaleX(1 / group.scaleX())
        //     image.scaleY(1 / group.scaleY())
        //   })
        // })
        return;
      }
      if (extra === "StackedBar2") {
        image.setAttr("belong", "stackedLine2")
        image.width(500);
        image.height(250);
        console.log(image)
        image.setName("StackedBar2Background")
        const position = this.stage.getRelativePointerPosition();
        const group = new Konva.Group({
          name: "StackedBar2",
          x: position.x,
          y: position.y
        });
        const id = 'd' + nanoid()
        group.setAttr('id', id)
        this.stackedBars[id] = {
          deviceId: [],
          point: ''
        }
        group.setAttr("chartType", "bar");
        group.setAttr("yPosition", "1");
        group.setAttr("xPosition", "1");
        group.setAttr("linearStart", "#5470C6FF");
        group.setAttr("xFont", 16);
        group.setAttr("xColor", '#FFFFFFFF');
        group.setAttr("yFont", 16);
        group.setAttr("yColor", '#FFFFFFFF');
        group.setAttr("labelFont", 16);
        group.setAttr("labelColor", '#FFFFFFFF');
        group.setAttr("colorLinear", false);
        const imgObj = new Image();
        imgObj.src = src;
        const bg = new Konva.Image({
          attrs: {
            image: null
          },
          name: "img",
          x: 0,
          y: 30,
          width: 500,
          height: 220,
          draggable: false,
          image: null,
          url: "data:image/png;base64,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"
        });
        bg.setAttr("belong", "stackedLine2")
        const stackedbar2Title = new Konva.Text({
          name: 'stackedbar2Title',
          x: 188,
          y: 10,
          text: '聚合数据',
          fill: '#fff',
          fontSize: 30
        })
        
        group.add(image, bg, stackedbar2Title);
        group.position(this.stage.getRelativePointerPosition());
        this.addNodeEvent(stackedbar2Title);
        this.addNodeEvent(group);
        this.layer.add(group);
        this.layer.draw();
        // group.on('transformend', () => {
        //   const width = group.scaleX() * 500
        //   const height = group.scaleY() * 200
        //   this.width = width + 'px'
        //   this.height = height + 'px'
        //   this.$nextTick(() => {
        //     this.StackedLine.resize()
        //     const img = new Image()
        //     img.src = this.StackedLine.getDataURL('png')
        //     const image = group.findOne('.img')
        //     image.attrs.image = img
        //     image.scaleX(1 / group.scaleX())
        //     image.scaleY(1 / group.scaleY())
        //   })
        // })
        return;
      }
      if (extra === 'background') {
        image.width(1920)
        image.height(1080)
      }
      if (extra === 'effectiveAccumulation') {
        image.name('effectiveAccumulationBackground')
        const position = this.stage.getRelativePointerPosition();
        const group = new Konva.Group({
          name: "effectiveAccumulation",
          x: position.x,
          y: position.y
        });
        const title = new Konva.Text({
          name: "title",
          x: 10,
          y: 15,
          text: "累积能效",
          fontSize: 32,
          fontFamily: "Calibri",
          fill: "#a4d8ff"
        })
        const eLabel = new Konva.Text({
          name: 'el',
          x: 50,
          y: 70,
          text: '用电量 kW·H',
          fontSize: 28,
          fill: "#a4d8ff"
        })
        const fLabel = new Konva.Text({
          name: 'fl',
          x: 250,
          y: 70,
          text: '流量 m³',
          fontSize: 28,
          fill: "#a4d8ff"
        })
        const eValue = new Konva.Text({
          name: 'ev',
          x: 50,
          y: 110,
          text: '0',
          fontSize: 26,
          fill: "#fff"
        })
        const fValue = new Konva.Text({
          name: 'fv',
          x: 250,
          y: 110,
          text: '0',
          fontSize: 26,
          fill: "#fff"
        })
        const ratioGroup = new Konva.Group({
          name: 'ratioGroup',
          x: 10,
          y: 150,
          padding: 100
        })
        const ratio = new Konva.Rect({
          name: 'ratio',
          x: 0,
          y: 0,
          width: 390,
          height: 40,  // 高度设置为40px
          fill: 'transparent',  // 背景透明
          stroke: 'rgb(164, 216, 255)',  // 边框颜色
          strokeWidth: 2,  // 边框宽度
          cornerRadius: 20,  // 圆角
          // shadowColor: 'rgb(164, 216, 255)', // 阴影颜色
          // shadowBlur: 100,  // 阴影模糊
          // shadowOffsetX: -10,  // 阴影偏移X
          // shadowOffsetY: 5,  // 阴影偏移Y
          // shadowOpacity: 1,  // 阴影透明度
        });
        ratio.cache({
          padding: 10
        })
        ratio.filters([Konva.Filters.Blur])
        ratio.blurRadius(5)

        const ratioLabel = new Konva.Text({
          x: 30,
          y: 20,
          offsetY: 10,
          text: '气电比：',
          fontSize: 28,  // 字体大小
          fontFamily: 'Arial',
          fill: '#a4d8ff',  // 字体颜色
          align: 'center',
          verticalAlign: 'middle',
          name: 'ratioLabel'
        });
        const ratioValue = new Konva.Text({
          name: 'ratioValue',
          x: 140,
          y: 20,
          offsetY: 10,
          text: '0.00000',
          fontSize: 28,  // 字体大小
          fontFamily: 'Arial',
          fill: '#a4d8ff',  // 字体颜色
          align: 'center',
          verticalAlign: 'middle',
        })
        const ratioUnit = new Konva.Text({
          x: 250,
          y: 20,
          offsetY: 10,
          text: 'kW·H/m³',
          fontSize: 28,  // 字体大小
          fontFamily: 'Arial',
          fill: '#a4d8ff',  // 字体颜色
          align: 'center',
          verticalAlign: 'middle',
          name: 'ratioUnit'
        })
        ratioGroup.add(ratio, ratioLabel, ratioValue, ratioUnit)
        group.add(image, title, eLabel, fLabel, eValue, fValue, ratioGroup)
        group.position(this.stage.getRelativePointerPosition());
        group.setAttr('id', nanoid())
        this.addNodeEvent(ratio);
        this.addNodeEvent(ratioLabel);
        this.addNodeEvent(ratioValue);
        this.addNodeEvent(ratioUnit);
        this.addNodeEvent(title);
        this.addNodeEvent(eLabel);
        this.addNodeEvent(fLabel);
        this.addNodeEvent(eValue);
        this.addNodeEvent(fValue);
        this.addNodeEvent(group);
        this.layer.add(group);
        this.layer.draw();
        return
      }
      if (extra === 'effectiveCurrent') {
        image.name('effectiveCurrentBackground')
        const position = this.stage.getRelativePointerPosition();
        const group = new Konva.Group({
          name: "effectiveCurrent",
          x: position.x,
          y: position.y
        });
        const title = new Konva.Text({
          name: "title",
          x: 10,
          y: 15,
          text: "实时能效",
          fontSize: 32,
          fontFamily: "Calibri",
          fill: "#a4d8ff"
        })
        const eLabel = new Konva.Text({
          name: 'el',
          x: 50,
          y: 70,
          text: '用电量 kW·H',
          fontSize: 28,
          fill: "#a4d8ff"
        })
        const fLabel = new Konva.Text({
          name: 'fl',
          x: 250,
          y: 70,
          text: '流量 m³',
          fontSize: 28,
          fill: "#a4d8ff"
        })
        const eValue = new Konva.Text({
          name: 'ev',
          x: 50,
          y: 110,
          text: '0',
          fontSize: 26,
          fill: "#fff"
        })
        const fValue = new Konva.Text({
          name: 'fv',
          x: 250,
          y: 110,
          text: '0',
          fontSize: 26,
          fill: "#fff"
        })
        const ratioGroup = new Konva.Group({
          name: 'ratioGroup',
          x: 10,
          y: 150,
          padding: 100
        })
        const ratio = new Konva.Rect({
          name: 'ratio',
          x: 0,
          y: 0,
          width: 390,
          height: 40,  // 高度设置为40px
          fill: 'transparent',  // 背景透明
          stroke: 'rgb(164, 216, 255)',  // 边框颜色
          strokeWidth: 2,  // 边框宽度
          cornerRadius: 20,  // 圆角
          // shadowColor: 'rgb(164, 216, 255)', // 阴影颜色
          // shadowBlur: 100,  // 阴影模糊
          // shadowOffsetX: -10,  // 阴影偏移X
          // shadowOffsetY: 5,  // 阴影偏移Y
          // shadowOpacity: 1,  // 阴影透明度
        });
        ratio.cache({
          padding: 10
        })
        ratio.filters([Konva.Filters.Blur])
        ratio.blurRadius(5)

        const ratioLabel = new Konva.Text({
          x: 30,
          y: 20,
          offsetY: 10,
          text: '气电比：',
          fontSize: 28,  // 字体大小
          fontFamily: 'Arial',
          fill: '#a4d8ff',  // 字体颜色
          align: 'center',
          verticalAlign: 'middle',
          name: 'ratioLabel'
        });
        const ratioValue = new Konva.Text({
          name: 'ratioValue',
          x: 140,
          y: 20,
          offsetY: 10,
          text: '0.00000',
          fontSize: 28,  // 字体大小
          fontFamily: 'Arial',
          fill: '#a4d8ff',  // 字体颜色
          align: 'center',
          verticalAlign: 'middle',
          name: 'ratioValue'
        })
        const ratioUnit = new Konva.Text({
          x: 250,
          y: 20,
          offsetY: 10,
          text: 'kW·H/m³',
          fontSize: 28,  // 字体大小
          fontFamily: 'Arial',
          fill: '#a4d8ff',  // 字体颜色
          align: 'center',
          verticalAlign: 'middle',
          name: 'ratioUnit'
        })
        ratioGroup.add(ratio, ratioLabel, ratioValue, ratioUnit)
        group.add(image, title, eLabel, fLabel, eValue, fValue, ratioGroup)
        group.position(this.stage.getRelativePointerPosition());
        group.setAttr('id', nanoid())
        this.addNodeEvent(title);
        this.addNodeEvent(eLabel);
        this.addNodeEvent(fLabel);
        this.addNodeEvent(eValue);
        this.addNodeEvent(fValue);
        this.addNodeEvent(ratio);
        this.addNodeEvent(ratioLabel);
        this.addNodeEvent(ratioValue);
        this.addNodeEvent(ratioUnit);
        this.addNodeEvent(group);
        this.layer.add(group);
        this.layer.draw();
        return
      }
      if (extra === 'socialEffective') {
        image.name('socialEffectiveBackground')
        const position = this.stage.getRelativePointerPosition();
        const group = new Konva.Group({
          name: "socialEffective",
          x: position.x,
          y: position.y
        });
        const title = new Konva.Text({
          name: "title",
          x: 145,
          y: 10,
          text: "社会效益",
          fontSize: 26,
          fontFamily: "Calibri",
          fill: "#fff"
        })
        const powerTitle = new Konva.Text({
          x: 20,
          y: 50,
          text: '累计节能 kW·H',
          fontSize: 24,  // 字体大小
          fontFamily: 'Arial',
          fill: '#a4d8ff',  // 字体颜色
          align: 'center',
          verticalAlign: 'middle',
          name: 'powerTitle'
        })
        const powerValue = new Konva.Text({
          name: 'powerValue',
          x: 20,
          y: 90,
          text: '0',
          fontSize: 22,  // 字体大小
          fontFamily: 'Arial',
          fill: '#fff',  // 字体颜色
          align: 'center',
          verticalAlign: 'middle'
        })
        const CO2Title = new Konva.Text({
          x: 250,
          y: 50,
          text: 'CO₂减排量 t',
          fontSize: 24,  // 字体大小
          fontFamily: 'Arial',
          fill: '#a4d8ff',  // 字体颜色
          align: 'center',
          verticalAlign: 'middle',
          name: 'CO2Title'
        })
        const CO2Value= new Konva.Text({
          name: 'CO2Value',
          x: 250,
          y: 90,
          text: '0.000',
          fontSize: 22,  // 字体大小
          fontFamily: 'Arial',
          fill: '#fff',  // 字体颜色
          align: 'center',
          verticalAlign: 'middle'
        })
        group.setAttr('id', nanoid())
        group.add(image, title, powerTitle, powerValue, CO2Title, CO2Value)
        group.position(this.stage.getRelativePointerPosition());
        this.addNodeEvent(title);
        this.addNodeEvent(powerTitle);
        this.addNodeEvent(powerValue);
        this.addNodeEvent(CO2Title);
        this.addNodeEvent(CO2Value);
        this.addNodeEvent(group);
        this.layer.add(group);
        this.layer.draw();
        return
      }
      if (extra === 'runningState') {
        image.name('runningStateBackground')
        const position = this.stage.getRelativePointerPosition();
        const group = new Konva.Group({
          name: "runningState",
          x: position.x,
          y: position.y
        });
        const stateTitle = new Konva.Text({
          name: 'stateTitle',
          x: 132,
          y: 10,
          text: '空压机状态',
          fill: '#fff',
          fontSize: 30
        })
        const runningGroup = new Konva.Group({
          name: "runningGroup",
          x: 0,
          y: 40
        })
        const runningValue = new Konva.Text({
          name: 'runningValue',
          x: 49,
          y: 10,
          text: '0台',
          fontSize: 24,
          fill: '#117b8a',
          align: 'center',
          verticalAlign: 'middle'
        })
        let imgObj = new Image();
        imgObj.src = runningPic
        const runningImg = new Konva.Image({
          attrs: {
            image: imgObj
          },
          name: 'runningImg',
          x: 0,
          y: 30,
          width: 140,
          height: 50,
          image: imgObj,
          url: imgObj.src
        })
        const runningDescription = new Konva.Text({
          name: 'runningDescription',
          x: 42,
          y: 80,
          text: '运行',
          fontSize: 24,
          fill: '#117b8a',
          align: 'center',
          verticalAlign: 'middle'
        })
        runningGroup.add(runningValue, runningImg, runningDescription)
        const sleepingGroup = new Konva.Group({
          name: "runningGroup",
          x: 126,
          y: 40
        })
        const sleepingValue = new Konva.Text({
          name: 'sleepingValue',
          x: 49,
          y: 10,
          text: '0台',
          fontSize: 24,
          fill: '#2d65ae',
          align: 'center',
          verticalAlign: 'middle'
        })
        const sleepingImgObj = new Image()
        sleepingImgObj.src = sleepingPic
        const sleepingImg = new Konva.Image({
          attrs: {
            image: sleepingImgObj
          },
          name: 'sleepingImg',
          x: 0,
          y: 30,
          width: 140,
          height: 50,
          image: sleepingImgObj,
          url: sleepingPic
        })
        const sleepingDescription = new Konva.Text({
          name: 'sleepingDescription',
          x: 42,
          y: 80,
          text: '停机',
          fontSize: 24,
          fill: '#2d65ae',
          align: 'center',
          verticalAlign: 'middle'
        })
        sleepingGroup.add(sleepingValue, sleepingImg, sleepingDescription)
        const offlineGroup = new Konva.Group({
          name: "offlineGroup",
          x: 255,
          y: 40
        })
        const offlineValue = new Konva.Text({
          name: 'offlineValue',
          x: 49,
          y: 10,
          text: '0台',
          fontSize: 24,
          fill: '#b8b8bb',
          align: 'center',
          verticalAlign: 'middle'
        })
        const offlineImgObj = new Image();
        offlineImgObj.src = offlinePic
        const offlineImg = new Konva.Image({
          attrs: {
            image: offlineImgObj
          },
          name: 'offlineImg',
          x: 0,
          y: 30,
          width: 140,
          height: 50,
          image: offlineImgObj,
          url: offlinePic
        })
        const offlineDescription = new Konva.Text({
          name: 'offlineDescription',
          x: 42,
          y: 80,
          text: '离线',
          fontSize: 24,
          fill: '#b8b8bb',
          align: 'center',
          verticalAlign: 'middle'
        })
        offlineGroup.add(offlineValue, offlineImg, offlineDescription)
        const errorGroup = new Konva.Group({
          name: "errorGroup",
          x: 60,
          y: 150
        })
        const errorValue = new Konva.Text({
          name: 'errorValue',
          x: 49,
          y: 10,
          text: '0台',
          fontSize: 24,
          fill: '#ca0400',
          align: 'center',
          verticalAlign: 'middle'
        })
        const errorImgObj = new Image();
        errorImgObj.src = errorPic
        const errorImg = new Konva.Image({
          attrs: {
            image: errorImgObj
          },
          name: 'errorImg',
          x: 0,
          y: 30,
          width: 140,
          height: 50,
          image: errorImgObj,
          url: errorPic
        })
        const errorDescription = new Konva.Text({
          name: 'errorDescription',
          x: 42,
          y: 80,
          text: '故障',
          fontSize: 24,
          fill: '#ca0400',
          align: 'center',
          verticalAlign: 'middle'
        })
        errorGroup.add(errorValue, errorImg, errorDescription)
        const maintainGroup = new Konva.Group({
          name: "maintainGroup",
          x: 188,
          y: 150
        })
        const maintainValue = new Konva.Text({
          name: 'maintainValue',
          x: 49,
          y: 10,
          text: '0台',
          fontSize: 24,
          fill: '#eeab03',
          align: 'center',
          verticalAlign: 'middle'
        })
        let maintainImgObj = new Image();
        maintainImgObj.src = maintainPic
        const maintainImg = new Konva.Image({
          attrs: {
            image: maintainImgObj
          },
          name: 'maintainImg',
          x: 0,
          y: 30,
          width: 140,
          height: 50,
          image: maintainImgObj,
          url: maintainPic
        })
        const maintainDescription = new Konva.Text({
          name: 'maintainDescription',
          x: 42,
          y: 80,
          text: '保养',
          fontSize: 24,
          fill: '#eeab03',
          align: 'center',
          verticalAlign: 'middle'
        })
        maintainGroup.add(maintainValue, maintainImg, maintainDescription)
        group.add(image, stateTitle, runningGroup, sleepingGroup, offlineGroup, errorGroup, maintainGroup)
        group.position(this.stage.getRelativePointerPosition());
        this.addNodeEvent(stateTitle)
        this.addNodeEvent(runningValue)
        this.addNodeEvent(runningImg)
        this.addNodeEvent(runningDescription)
        this.addNodeEvent(sleepingValue)
        this.addNodeEvent(sleepingImg)
        this.addNodeEvent(sleepingDescription)
        this.addNodeEvent(offlineValue)
        this.addNodeEvent(offlineImg)
        this.addNodeEvent(offlineDescription)
        this.addNodeEvent(errorValue)
        this.addNodeEvent(errorImg)
        this.addNodeEvent(errorDescription)
        this.addNodeEvent(maintainValue)
        this.addNodeEvent(maintainImg)
        this.addNodeEvent(maintainDescription)
        this.addNodeEvent(group)
        this.layer.add(group);
        this.layer.draw();
        return
      }
      if (extra === 'stackedLine2') {
        image.setAttr("belong", "stackedLine2")
        image.width(500)
        image.height(200)
        image.y(30)
        image.attrs.image = null
        const position = this.stage.getRelativePointerPosition();
        const group = new Konva.Group({
          name: "stackedLine2",
          x: position.x,
          y: position.y
        });
        const imgObj = new Image();
        imgObj.src = src;
        const bg = new Konva.Image({
          attrs: {
            image: imgObj,
            src
          },
          name: "StackedLine2Background",
          x: 0,
          y: 0,
          width: 500,
          height: 250,
          draggable: false,
          image: imgObj
        });
        let id = 'd' + nanoid()
        group.setAttr('id', id)
        this.stackedLines2[id] = {
          deviceId: '',
          point: ''
        }
        const stackedLine2Title = new Konva.Text({
          name: 'stackedLine2Title',
          x: 188,
          y: 10,
          text: '实时数据',
          fill: '#fff',
          fontSize: 30
        })
        group.setAttr("chartType", "line");
        group.setAttr("yPosition", "1");
        group.setAttr("xPosition", "1");
        group.setAttr("xFont", 16);
        group.setAttr("xColor", '#FFFFFFFF');
        group.setAttr("yFont", 16);
        group.setAttr("yColor", '#FFFFFFFF');
        group.setAttr("labelFont", 16);
        group.setAttr("labelColor", '#FFFFFFFF');
        group.setAttr("colorLinear", true);
        group.setAttr("itemStyle", '#5470C6FF');
        group.setAttr("linearEnd", '#061E3C99');
        group.setAttr("linearStart", '#157FFF99');
        group.setAttr('maxPoints', 20)
        group.add(image, bg, stackedLine2Title)
        group.position(this.stage.getRelativePointerPosition());
        this.addNodeEvent(stackedLine2Title)
        this.addNodeEvent(group)
        this.layer.add(group);
        this.layer.draw();
        return
      }
      if (extra === 'warning') {
        image.name('warningBackground')
        const position = this.stage.getRelativePointerPosition()
        const group = new Konva.Group({
          name: 'warning',
          x: position.x,
          y: position.y
        })
        const title = new Konva.Text({
          name: 'title',
          x: 135,
          y: 15,
          text: '预警信息',
          fontSize: 32,
          fontFamily: 'Calibri',
          fill: '#fff'
        })
        group.add(image, title)
        this.addNodeEvent(group)
        this.layer.add(group)
        this.layer.draw()
        return
      }
      image.position(this.stage.getRelativePointerPosition());
      this.addNodeEvent(image);
      this.layer.add(image);
      this.layer.draw();
      // this.currentItem = image
      // this.transformer.nodes([image])
      // this.transformer.enabledAnchors(['top-left', 'top-center', 'top-right', 'middle-right', 'middle-left', 'bottom-left', 'bottom-center', 'bottom-right'])
    },
    save() {
      this.stage.attrs.backgroundColor = this.colorPicker.obj.hex;
      this.stage
        .findOne("Layer")
        .getChildren()
        .filter(
          node => node.name() === "dataBlock" && node.getChildren().length === 0
        )
        .forEach(node => node.destroy());
      const data = this.stage.toJSON();
 
      this.content.single = data;
      // deviceGroupApi.saveContent(this.$route.query.id, JSON.stringify(this.content)).then(({ message }) => {
      //   this.$message.success(message)
      // }).catch(() => {
      //   // this.$message.error("请求失败")
      // })
      this.stationRecord.content = JSON.stringify(this.content);
      updateDeviceGroup(this.stationRecord)
        .then(({ message }) => {
          this.$message.success(message);
        })
        .catch(() => {
          // this.$message.error("请求失败")
        })
    },
    saveAsUnit() {
      this.stage.attrs.backgroundColor = this.colorPicker.obj.hex;
      const data = this.stage.toJSON();
      this.content.unit = data;
      this.stationRecord.content = JSON.stringify(this.content);
      updateDeviceGroup(this.stationRecord)
        .then(({ message }) => {
          this.$message.success(message);
        })
        .catch(() => {
          // this.$message.error("请求失败")
        });
    },
    cancel() {
      this.$router.push("/equipment/group");
      this.$store.commit("setRoutePath", "/equipment/group");
    },
    toggle() {
      this.stage.destroy();
      if (this.currentPreview === "single") {
        this.loadStage(this.content.unit);
        this.currentPreview = "unit";
      } else {
        this.loadStage(this.content.single);
        this.currentPreview = "single";
      }
    },
    renderDataBlock(dataGroup) {
      dataGroup.children().forEach(item => {
        item.destroy();
      });
    },
    addDataToStatisticsBlock(val, dataPoint) {
      this.protocolDataPoints.forEach(a => {
        a.show = false;
      });
      console.log(val, dataPoint);
      dataPoint.show = val;
      this.$forceUpdate();
      const node = this.currentItem;
      node.setAttr("dataPoint", dataPoint);
      const params = {
        deviceId: node.attrs.device.id,
        startTime: +new Date() - 24 * 60 * 60 * 1000,
        endTime: +new Date(),
        pointCode: dataPoint.code
      };
      getDeviceHistoryData(params)
        .then(({ data }) => {
          node.findOne(".dataKey").text(dataPoint[this.lang]);
          node
            .findOne(".dataValue")
            .text(data.length ? data[0][dataPoint.code] : 0);
          node.findOne(".dataUnit").text(dataPoint.unit);
        })
        .catch(() => {
          // this.$message.error("请求失败")
        });
    },
    createDataRow(x = 10, y = 40) {
      const dataRow = new Konva.Group({
        name: "monitorRow",
        x,
        y
      });
      const bg = new Konva.Rect({
        name: "background",
        x: 0,
        y: 0,
        width: BG_WIDTH,
        height: BG_HEIGHT,
        // fill: 'rgba(249,240,255,0.25)',
        cornerRadius: 3,
        draggable: false
      });
      const key = new Konva.Text({
        name: "monitorKey",
        x: bg.x() + PADDING,
        y: bg.y() + PADDING,
        text: defaultContent.key,
        fill: DEFAULT_COLOR,
        fontSize: 15
      });
      const value = new Konva.Text({
        name: "monitorValue",
        x: key.x() + key.width() + GAP,
        y: key.y(),
        text: defaultContent.value,
        fill: "#3FFFFF",
        fontSize: 15
      });
      const unit = new Konva.Text({
        name: "monitorUnit",
        x: value.x() + value.width() + GAP,
        y: key.y(),
        text: defaultContent.unit,
        fill: DEFAULT_COLOR,
        fontSize: 15
      });
      dataRow.add(bg, key, value, unit);
      this.addNodeEvent(key);
      this.addNodeEvent(value);
      this.addNodeEvent(unit);
      this.addNodeEvent(dataRow);
      this.currentItem.add(dataRow);
      return dataRow;
    },
    addDataToMonitorBlock(val, point) {
      point.show = val;
      const points = this.protocolDataPoints.filter(p => p.show);
      let dataRow;
      let dataRows = this.currentItem.find(".monitorRow");
      const b = this.currentItem.findOne(".dataBlockBody");
      for (let i = points.length; i < dataRows.length; i++) {
        dataRows[i].destroy();
        if (i > 0) {
          b.height(b.height() - 25);
        }
      }
      if (points.length === 1) {
        const dataPoint = points[0];
        dataRow = this.currentItem.findOne(".monitorRow");
        if (!dataRow) {
          dataRow = this.createDataRow();
        }
        dataRow.setAttr("dataPoint", dataPoint);
        dataRows = this.currentItem.find(".monitorRow");
      }
      if (points.length > 1) {
        for (let i = 0; i < points.length; i++) {
          if (!dataRows[i]) {
            dataRows[i] = this.createDataRow(
              dataRows[i - 1]?.x(),
              dataRows[i - 1]?.y() + 25
            );
            if (i > 0) {
              b.height(b.height() + 25);
            }
          }
          dataRows[i].setAttr("dataPoint", points[i]);
        }
      }
      this.transformer.nodes([this.currentItem]);

      const params = {
        deviceId: this.currentItem.attrs.device.id,
        startTime: +new Date() - 24 * 60 * 60 * 1000,
        endTime: +new Date(),
        pointCode: points.map(p => p.code) + ""
      };
      getDeviceHistoryData(params)
        .then(({ data }) => {
          // dataRow.findOne('.dataKey').text(dataPoint[this.lang])
          // dataRow.findOne('.dataValue').text(data.length ? data[0][dataPoint.code] : 0)
          // dataRow.findOne('.dataUnit').text(dataPoint.unit)
          for (let i = 0; i < dataRows.length; i++) {
            const d = dataRows[i];
            const p = d.getAttr("dataPoint");
            let v = data.length ? data.at(-1) : {};
            console.log(p, v);
            d.findOne(".monitorKey").text(p[this.lang]);
            d.findOne(".monitorValue").text(v[p.code] || 0);
            d.findOne(".monitorUnit").text(p.unit);
          }
        })
        .catch(() => {
          // this.$message.error("请求失败")
        });

      this.$forceUpdate();
    },
    addDataToStationBlock(e, index) {
      const currentStationBlock = [];
      this.stationDataPoints.forEach(p => {
        if (p.show) {
          currentStationBlock.push(p);
        }
      });
      this.currentStationBlock = currentStationBlock;
      let node = this.currentItem;
      let nodes;
      if (node.find) {
        nodes = node.find(".innerGroup");
      } else {
        node = node.getParent();
        nodes = node.find(".innerGroup");
      }
      const img = node.findOne(".img");
      const group = img.getParent();
      console.log(currentStationBlock);
      if (currentStationBlock.length > nodes.length) {
        const innerGroup = nodes.at(-1);
        const item = innerGroup.clone({
          x: innerGroup.x(),
          y: innerGroup.y() + 40
        });
        node.add(item);
        img.height(img.height() + 40);
        group.height(img.height());
        nodes = group.find(".innerGroup");
        for (let i = 0; i < currentStationBlock.length; i++) {
          nodes[i].findOne(".dataKey").text(currentStationBlock[i].name);
          nodes[i].findOne(".dataValue").text("0");
          nodes[i].findOne(".dataUnit").text(currentStationBlock[i].unit);
        }
      } else if (currentStationBlock.length === nodes.length) {
        const data = currentStationBlock.at(-1);
        nodes[0].findOne(".dataKey").text(data.name);
        nodes[0].findOne(".dataValue").text("0");
        nodes[0].findOne(".dataUnit").text(data.unit);
      } else {
        if (currentStationBlock.length === 0) {
          nodes[0].findOne(".dataKey").text("#KEY");
          nodes[0].findOne(".dataValue").text("#VALUE");
          nodes[0].findOne(".dataUnit").text("#UNIT");
        } else {
          for (let i = 0; i < currentStationBlock.length; i++) {
            nodes[i].findOne(".dataKey").text(currentStationBlock[i].name);
            nodes[i].findOne(".dataValue").text("0");
            nodes[i].findOne(".dataUnit").text(currentStationBlock[i].unit);
          }
          nodes.at(-1).destroy();
          img.height(img.height() - 40);
          group.height(img.height());
        }
      }
      // if (currentStationBlock.length > nodes.length) {
      //   const innerGroup = nodes.at(-1)
      //   const item = innerGroup.clone({
      //     x: innerGroup.x(),
      //     y: innerGroup.y() + 40
      //   })
      //   const data = currentStationBlock[index]
      //   item.findOne('.dataKey').text(data.name)
      //   item.findOne('.dataValue').text('0')
      //   item.findOne('.dataUnit').text(data.unit)
      //   node.add(item)
      //   img.height(img.height() + 40)
      //   group.height(img.height())
      // } else if (currentStationBlock.length === nodes.length) {
      //   const data = currentStationBlock.at(-1)
      //   nodes[0].findOne('.dataKey').text(data.name)
      //   nodes[0].findOne('.dataValue').text('0')
      //   nodes[0].findOne('.dataUnit').text(data.unit)
      // } else {
      //   if (currentStationBlock.length === 0) {
      //     nodes[0].findOne('.dataKey').text('#KEY')
      //     nodes[0].findOne('.dataValue').text('#VALUE')
      //     nodes[0].findOne('.dataUnit').text('#UNIT')
      //   } else {
      //     nodes[index].destroy()
      //     for (let i = index; i < nodes.length; i++) {
      //       nodes[i].y(nodes[i].y() - 40)
      //     }
      //     // nodes = node.find('.innerGroup')
      //     // const innerGroup = nodes.at(-1)
      //     // const data = currentStationBlock.at(-1)
      //     // innerGroup.findOne('.dataKey').text(data.name)
      //     // innerGroup.findOne('.dataValue').text('0')
      //     // innerGroup.findOne('.dataUnit').text(data.unit)
      //     img.height(img.height() - 40)
      //     group.height(img.height())
      //   }
      // }
      node.setAttr("dataPoint", currentStationBlock);
    },
    bindingDevice(value) {
      const device = this.deviceList.find(item => item.id === value);
      const node = this.currentItem;
      console.log(device);
      node.setAttr("device", {
        id: device.id,
        code: device.code,
        driver: device.driverType,
        protocolCode: device.protocolCode
      });
      const dataPoint = node.getAttr("dataPoint");
      getProtocol(device.protocolCode)
        .then(({ data }) => {
          this.protocolDataPoints = data.points.filter(d => d.dataWrite !== 2).map(p => {
            (p.details || []).forEach(d => {
              if (d.locale === "zh-CH") {
                p.zh = d.name;
              }
              if (d.locale === "en-US") {
                p.en = d.name;
              }
            });
            if (!p.zh) {
              p.zh = p.name;
            }
            if (!p.en) {
              p.en = p.zh;
            }
            return p;
          });
          if (dataPoint) {
            this.protocolDataPoints.filter(
              item => item.code === dataPoint.code
            )[0].show = true;
          }
        })
        .catch(() => {
          // this.$message.error("请求失败")
        });
    },
    bindingMonitorDevice(value) {
      const device = this.deviceList.find(item => item.id === value);
      const node = this.currentItem;
      node.setAttr("device", {
        id: device.id,
        code: device.code,
        driver: device.driverType,
        protocolCode: device.protocolCode
      });
      node.findOne(".dataBlockTitle").text(device.name);
      node.findOne(".dataBlockBody").height(70);
      const dataRows = node.find(".monitorRow");

      for (let i = 0; i < dataRows.length; i++) {
        if (i === 0) {
          dataRows[0].findOne(".monitorKey").text(defaultContent.key);
          dataRows[0].findOne(".monitorValue").text(defaultContent.value);
          dataRows[0].findOne(".monitorUnit").text(defaultContent.unit);
          continue;
        }
        dataRows[i].destroy();
      }
      this.transformer.nodes([this.currentItem]);
      const dataPoint = node.getAttr("dataPoint");
      getProtocol(device.protocolCode)
        .then(({ data }) => {
          this.protocolDataPoints = data.points.filter(d => d.dataWrite !== 2).map(p => {
            (p.details || []).forEach(d => {
              if (d.locale === "zh-CH") {
                p.zh = d.name;
              }
              if (d.locale === "en-US") {
                p.en = d.name;
              }
            });
            if (!p.zh) {
              p.zh = p.name;
            }
            if (!p.en) {
              p.en = p.zh;
            }
            return p;
          });
        })
        .catch(() => {
          // this.$message.error("请求失败")
        });
    },
    bindingStation(value) {
      console.log(this.stations, value);
      const station = this.stations.find(item => item.id === value);
      const node = this.currentItem;
      node.setAttr("station", {
        id: station.id,
        name: station.name,
        code: station.code,
        id: station.id
      });
      this.$forceUpdate();
      console.log(station);
      node.find(".label")[0].text(station.name);
      this.stationDataBlockShow = true;
    },
    dataBlockBindDevice(dataBlock, value) {
      dataBlock.setAttr("device", {});
      const device = this.deviceList.filter(device => device.id === value)[0];
      dataBlock.setAttr("device", {
        id: device.id,
        code: device.code,
        name: device.name
      });
      dataBlock.findOne(".dataBlockTitle").text(device.name);
      this.$forceUpdate();
    },
    changeStatisticsBlockTitle(e) {
      const title = e.target.value;
      this.currentItem.text(title);
      this.currentItem.setAttr("selfDefinedName", title);
    },
    drawLabel() {
      const simpleText = new Konva.Text({
        name: "text",
        x: 0,
        y: 0,
        text: "Label",
        fontSize: 35,
        fontFamily: "Calibri",
        fill: "#fff"
      });
      return simpleText;
    },
    renderDeviceData(params, record) {
      params.forEach(item => {
        const device = item.getAttr("device");
        const point = item.getAttr("dataPoint");
        if (!device || !point) {
          return;
        }
        if (device.code === record.device_code) {
          const value = item.findOne(".dataValue");
          value.text(record[point.code]);
        }
      });
    },
    cache() {
      this.originator.setStage(this.stage.clone());
      this.manager.save();
    },
    undo() {
      this.manager.back();
      this.transformer.destroy();
      this.layer.destroy();
      this.stage.destroy();
      this.loadStage(this.manager.getStage().toJSON());
    },
    bindControlWidget(deviceId) {
      const device = this.deviceList.find(device => device.id === deviceId)
      this.currentItem.setAttr("deviceId", deviceId)
      this.currentItem.setAttr("deviceCode", device.code)
      this.currentItem.setAttr("dtuCode", device.dtuCode)
      this.currentItem.setAttr("protocolCode", device.protocolCode)
      getProtocol(device.protocolCode).then(({ data: { points } }) => {
        this.protocolDataPoints = points.filter(p => p.dataWrite === 4)
        this.$forceUpdate()
      })
    },
    bindControlWidgetPoint(pointCode) {
      const point = this.protocolDataPoints.find(
        item => item.code === pointCode
      )
      this.currentItem.setAttr("pointCode", pointCode)
      this.currentItem.setAttr("pointName", point.name)
      this.currentItem.setAttr("range0", point.range[0])
      this.currentItem.setAttr("range1", point.range[1])
      this.currentItem.setAttr("coefficient", point.coefficient)
      this.$forceUpdate()
    },
    bindStatsWidget(value) {
      this.currentItem.setAttr("data", value);
      const { deviceId, pointCode, aggregationType } = value;
      if (deviceId > 0 && pointCode !== "" && aggregationType !== "") {
        const arr = [value];
        getDeviceAggregation(arr).then(({ data }) => {
          if (data.length > 0) {
            this.currentItem.setText(data[0].value);
          } else {
            this.currentItem.setText(0);
          }
        });
      }
    },
    // 图表绑定设备
    async bindDeviceToChart(v) {
      const device = this.deviceList.find(d => d.id == v)
      const id = this.currentItem.getAttr('id')
      this[map[this.currentItem.name()].options][id].deviceId = v
      if (this.options[id]) {
        this.options[id] = null
        this.charts[id].dispose()
        this.charts[id] = null
        delete this.width[id]
        delete this.height[id]
        const image = this.currentItem.findOne('.img')
        image.attrs.image = null
      }
      this.currentItem.setAttr("point", null);
      this.currentItem.setAttr("pointName", null);
      this.currentItem.setAttr("deviceId", device.id);
      this.currentItem.setAttr("deviceCode", device.code);
      this.currentItem.setAttr("protocolCode", device.protocolCode);
      try {
        const { data } = await getProtocol(device.protocolCode);
        this[map[this.currentItem.name()].pointsList] = data.points.filter(d => d.dataWrite !== 2);
      } catch (e) {
        console.log(e);
      }
      this.$forceUpdate();
    },
    async bindDeviceToChart2(v) {
      const promises = []
      let d, deviceCodes = [], protocolCodes = []
      for (let i = 0; i < this.deviceList.length; i++) {
        d = this.deviceList[i]
        if (v.find(did => did === d.id)) {
          deviceCodes.push(d.code)
          protocolCodes.push(d.protocolCode)
          promises.push(new Promise(async resolve => {
            try {
              const { data } = await getProtocol(d.protocolCode)
              resolve(
                data.points
                  .filter(d => d.dataWrite !== 2)
                  .map(p => {
                    (p.details || []).forEach(d => {
                      if (d.locale === "zh-CH") {
                        p.zh = d.name;
                      }
                      if (d.locale === "en-US") {
                        p.en = d.name;
                      }
                    })
                    if (!p.zh) {
                      p.zh = p.name;
                    }
                    if (!p.en) {
                      p.en = p.zh;
                    }
                    return p
                  })
              )
            } catch(e) {
              console.log(e)
              resolve([])
            }
          }))
        }
      }
      const id = this.currentItem.getAttr('id')
      this[map[this.currentItem.name()].options][id].deviceId = v
      if (this.options[id]) {
        this.options[id] = null
        this.charts[id].dispose()
        this.charts[id] = null
        delete this.width[id]
        delete this.height[id]
        const image = this.currentItem.findOne('.img')
        image.attrs.image = null
      }
      const points = await Promise.all(promises)
      let pointMap = {}, p
      for (let i = 0; i < points.length; i++) {
        for (let j = 0; j < points[i].length; j++) {
          p = points[i][j]
          if (pointMap[p.code]) {
            pointMap[p.code].count++
          } else {
            pointMap[p.code] = {
              point: p,
              count: 1
            }
          }
        }
      }
      const pointsList = []
      for (let key in pointMap) {
        if (pointMap[key].count === points.length) {
          pointsList.push(pointMap[key].point)
        }
      }
      this.currentItem.setAttr("point", null);
      this.currentItem.setAttr("pointName", null);
      this.currentItem.setAttr("deviceId", v);
      this.currentItem.setAttr("deviceCode", deviceCodes);
      this.currentItem.setAttr("protocolCode", protocolCodes);
      this[map[this.currentItem.name()].pointsList] = pointsList
      this.$forceUpdate();
    },
    async bindLLJsToChart(v) {
      const promises = []
      let f
      for (let i = 0; i < this.flowList.length; i++) {
        f = this.flowList[i]
        console.log(i, f)
        if (v.find(fid => fid === f.id)) {
          promises.push(new Promise(async resolve => {
            try {
              const { data } = await getProtocol(f.protocolCode)
              resolve(
                data.points
                  .filter(d => d.dataWrite !== 2)
                  .map(p => {
                    (p.details || []).forEach(d => {
                      if (d.locale === "zh-CH") {
                        p.zh = d.name;
                      }
                      if (d.locale === "en-US") {
                        p.en = d.name;
                      }
                    })
                    if (!p.zh) {
                      p.zh = p.name;
                    }
                    if (!p.en) {
                      p.en = p.zh;
                    }
                    return p
                  })
              )
            } catch(e) {
              console.log(e)
              resolve([])
            }
          }))
        }
      }
      const id = this.currentItem.getAttr('id')
      this[map[this.currentItem.name()].options][id].LLJs = v
      if (this.options[id]) {
        this.options[id] = null
        this.charts[id].dispose()
        this.charts[id] = null
        delete this.width[id]
        delete this.height[id]
        const image = this.currentItem.findOne('.img')
        image.attrs.image = null
      }
      const points = await Promise.all(promises)
      let pointMap = {}, p
      for (let i = 0; i < points.length; i++) {
        for (let j = 0; j < points[i].length; j++) {
          p = points[i][j]
          if (pointMap[p.code]) {
            pointMap[p.code].count++
          } else {
            pointMap[p.code] = {
              point: p,
              count: 1
            }
          }
        }
      }
      const LLJPoints = []
      for (let key in pointMap) {
        if (pointMap[key].count === points.length) {
          LLJPoints.push(pointMap[key].point)
        }
      }
      this.LLJPoints = LLJPoints
      this.currentItem.setAttr("LLJPoint", null)
      this.currentItem.setAttr("LLJPointName", null)
      this.currentItem.setAttr("LLJs", v)
      // this.currentItem.setAttr("deviceCode", device.code);
      // this.currentItem.setAttr("protocolCode", device.protocolCode);
      // try {
      //   const { data } = await getProtocol(device.protocolCode);
      //   this[map[this.currentItem.name()].pointsList] = data.points.filter(d => d.dataWrite !== 2);
      // } catch (e) {
      //   console.log(e);
      // }
      this.$forceUpdate();
    },
    async bindDBsToChart(v) {
      const promises = []
      let e
      for (let i = 0; i < this.electricityList.length; i++) {
        e = this.electricityList[i]
        if (v.find(fid => fid === e.id)) {
          promises.push(new Promise(async resolve => {
            try {
              const { data } = await getProtocol(e.protocolCode)
              resolve(
                data.points
                  .filter(d => d.dataWrite !== 2)
                  .map(p => {
                    (p.details || []).forEach(d => {
                      if (d.locale === "zh-CH") {
                        p.zh = d.name;
                      }
                      if (d.locale === "en-US") {
                        p.en = d.name;
                      }
                    })
                    if (!p.zh) {
                      p.zh = p.name;
                    }
                    if (!p.en) {
                      p.en = p.zh;
                    }
                    return p
                  })
              )
            } catch(e) {
              console.log(e)
              resolve([])
            }
          }))
        }
      }
      const id = this.currentItem.getAttr('id')
      this[map[this.currentItem.name()].options][id].LLJs = v
      if (this.options[id]) {
        this.options[id] = null
        this.charts[id].dispose()
        this.charts[id] = null
        delete this.width[id]
        delete this.height[id]
        const image = this.currentItem.findOne('.img')
        image.attrs.image = null
      }
      const points = await Promise.all(promises)
      let pointMap = {}, p
      for (let i = 0; i < points.length; i++) {
        for (let j = 0; j < points[i].length; j++) {
          p = points[i][j]
          if (pointMap[p.code]) {
            pointMap[p.code].count++
          } else {
            pointMap[p.code] = {
              point: p,
              count: 1
            }
          }
        }
      }
      const DBPoints = []
      for (let key in pointMap) {
        if (pointMap[key].count === points.length) {
          DBPoints.push(pointMap[key].point)
        }
      }
      this.DBPoints = DBPoints
      this.currentItem.setAttr("DBPoint", null)
      this.currentItem.setAttr("DBPointName", null)
      this.currentItem.setAttr("DBs", v)
      // this.currentItem.setAttr("deviceCode", device.code);
      // this.currentItem.setAttr("protocolCode", device.protocolCode);
      // try {
      //   const { data } = await getProtocol(device.protocolCode);
      //   this[map[this.currentItem.name()].pointsList] = data.points.filter(d => d.dataWrite !== 2);
      // } catch (e) {
      //   console.log(e);
      // }
      this.$forceUpdate();
    },
    // 数据点绑定图表
    bindPointToChart(point) {
      const oldPoint = this.currentItem.getAttr('point')
      if (oldPoint === point.code) return
      this.currentItem.setAttr("point", point.code);
      this.currentItem.setAttr("pointName", point.name);
      const id = this.currentItem.getAttr('id')
      this[map[this.currentItem.name()].options][id].point = point.code
      if (this.options[id]) {
        this.options[id] = null
        this.charts[id].dispose()
        this.charts[id] = null
        const image = this.currentItem.findOne('.img')
        image.attrs.image = null
      }
      const width = this.currentItem.scaleX() * 500;
      const height = this.currentItem.scaleY() * 200;
      this.width[id] = width + "px";
      this.height[id] = height + "px";
      this.width = { ...this.width };
      this.height = { ...this.height };
      this.$forceUpdate();
      this.$nextTick(() => {
        const attrs = this.currentItem.attrs;
        if (this.currentItem.name() === 'StackedBar' && attrs.aggregationType && attrs.term && attrs.termNumber) {
          this.getStackedBarData(
            id,
            attrs.deviceId,
            attrs.point,
            attrs.aggregationType,
            attrs.term,
            attrs.termNumber
          );
        }
        if (this.currentItem.name() === 'StackedLine') {
          this.drawStackedLine(id, point.name, this.currentItem)
        }
        if (this.currentItem.name() === 'stackedLine2') {
          this.drawStackedLine(id, point.name, this.currentItem)
        }
      });
    },
    bindLLJPointToChart(point) {
      const oldPoint = this.currentItem.getAttr('LLJPoint')
      if (oldPoint === point.code) return
      this.currentItem.setAttr("LLJPoint", point.code);
      this.currentItem.setAttr("LLJPointName", point.name);
      const id = this.currentItem.getAttr('id')
      this[map[this.currentItem.name()].options][id].point = point.code
      if (this.options[id]) {
        this.options[id] = null
        this.charts[id].dispose()
        this.charts[id] = null
        const image = this.currentItem.findOne('.img')
        image.attrs.image = null
      }
      const width = this.currentItem.scaleX() * 500;
      const height = this.currentItem.scaleY() * 200;
      this.width[id] = width + "px";
      this.height[id] = height + "px";
      this.width = { ...this.width };
      this.height = { ...this.height };
      this.$forceUpdate();
      this.$nextTick(() => {
        const attrs = this.currentItem.attrs;
        if (attrs.aggregationType && attrs.term && attrs.termNumber && attrs.DBPoint?.length) {
          this.getStackedBarData(
            id,
            attrs.deviceId,
            attrs.point,
            attrs.aggregationType,
            attrs.term,
            attrs.termNumber
          )
        }
      });
    },
    bindDBPointToChart(point) {
      const oldPoint = this.currentItem.getAttr('DBPoint')
      if (oldPoint === point.code) return
      this.currentItem.setAttr("DBPoint", point.code);
      this.currentItem.setAttr("DBPointtName", point.name);
      const id = this.currentItem.getAttr('id')
      this[map[this.currentItem.name()].options][id].point = point.code
      if (this.options[id]) {
        this.options[id] = null
        this.charts[id].dispose()
        this.charts[id] = null
        const image = this.currentItem.findOne('.img')
        image.attrs.image = null
      }
      const width = this.currentItem.scaleX() * 500;
      const height = this.currentItem.scaleY() * 200;
      this.width[id] = width + "px";
      this.height[id] = height + "px";
      this.width = { ...this.width };
      this.height = { ...this.height };
      this.$forceUpdate();
      this.$nextTick(() => {
        const attrs = this.currentItem.attrs;
        if (attrs.aggregationType && attrs.term && attrs.termNumber && attrs.LLJs && attrs.DBs && attrs.LLJPoint && attrs.DBPoint) {
          this.getStackedBarData(
            id,
            attrs.deviceId,
            attrs.point,
            attrs.aggregationType,
            attrs.term,
            attrs.termNumber
          )
        }
      });
    },
    bindAggregationTypeToStackedBar(v) {
      this.currentItem.setAttr("aggregationType", v);
      const id = this.currentItem.getAttr('id')
      const attrs = this.currentItem.attrs;

      const ratio = attrs.ratio

      if (ratio) {
        if (attrs.aggregationType && attrs.term && attrs.termNumber && attrs.LLJs && attrs.DBs && attrs.LLJPoint && attrs.DBPoint) {
          this.getStackedBarData(
            id,
            attrs.deviceId,
            attrs.point,
            attrs.aggregationType,
            attrs.term,
            attrs.termNumber
          )
        }
      } else {
        if (attrs.deviceId && attrs.point && attrs.term && attrs.termNumber) {
          this.getStackedBarData(
            id,
            attrs.deviceId,
            attrs.point,
            attrs.aggregationType,
            attrs.term,
            attrs.termNumber
          );
        }
      }
      this.$forceUpdate();
    },
    bindTermToStackedBar(v) {
      this.currentItem.setAttr("term", v);
      const attrs = this.currentItem.attrs;
      const id = this.currentItem.getAttr('id')

      if (attrs.ratio) {
        if (attrs.aggregationType && attrs.term && attrs.termNumber && attrs.LLJs && attrs.DBs && attrs.LLJPoint && attrs.DBPoint) {
          this.getStackedBarData(
            id,
            attrs.deviceId,
            attrs.point,
            attrs.aggregationType,
            attrs.term,
            attrs.termNumber
          )
        }
      } else {
        if (attrs.deviceId && attrs.point && attrs.term && attrs.termNumber) {
          this.getStackedBarData(
            id,
            attrs.deviceId,
            attrs.point,
            attrs.aggregationType,
            attrs.term,
            attrs.termNumber
          );
        }
      }
      this.$forceUpdate();
    },
    bindTermNumberToStackedBar(v) {
      debounce(() => {
        this.currentItem.setAttr("termNumber", v);
        const attrs = this.currentItem.attrs;
        const id = this.currentItem.getAttr('id')

        if (attrs.ratio) {
          if (attrs.aggregationType && attrs.term && attrs.termNumber && attrs.LLJs && attrs.DBs && attrs.LLJPoint && attrs.DBPoint) {
            this.getStackedBarData(
              id,
              attrs.deviceId,
              attrs.point,
              attrs.aggregationType,
              attrs.term,
              attrs.termNumber
            )
          }
        } else {
          if (attrs.deviceId && attrs.point && attrs.term && attrs.termNumber) {
            this.getStackedBarData(
              id,
              attrs.deviceId,
              attrs.point,
              attrs.aggregationType,
              attrs.term,
              attrs.termNumber
            );
          }
        }
        this.$forceUpdate();
      }, 500);
    },
    handleScaleChange(e, type) {
      if (this.currentItem.name() === 'StackedBar') {
        debounce(() => {
          this.currentItem[`scale${type}`](Number(e.target.value))
          const width = this.currentItem.scaleX() * 500;
          const height = this.currentItem.scaleY() * 200;
          const id = this.currentItem.getAttr('id')
          this.width[id] = width + "px";
          this.height[id] = height + "px";
          this.width = { ...this.width };
          this.height = { ...this.height };
          
          this.$nextTick(() => {
            this.charts[id].resize();
            const img = new Image();
            img.src = this.charts[id].getDataURL("png");
            
            const image = this.currentItem.findOne(".img");
            
            image.scaleX(1)
            image.scaleY(1)
            image.attrs.image = img;
            // image.scaleX(1 / this.currentItem.scaleX())
            // image.scaleY(1 / this.currentItem.scaleY())
          });
        }, 300)
      } else {
        this.currentItem[`scale${type}`](+e.target.value)
      }
    },
    handleYPositionChange(e) {
      const y = e.target.value;
      const id = this.currentItem.getAttr('id')
      if (this.options[id]) {
        this.options[id].yAxis.axisLabel.show = !!+y;
        this.charts[id].setOption(
          this.options[id],
          { replaceMerge: ["yAxis", "grid"] }
        );
      }
      this.currentItem.setAttr("yPosition", y);
      this.$forceUpdate();
    },
    handleXPositionChange(e) {
      const y = e.target.value;
      const id = this.currentItem.getAttr('id')
      if (this.options[id]) {
        this.options[id].xAxis.axisLabel.show = !!+y;
        this.charts[id].setOption(
          this.options[id],
          { replaceMerge: ["xAxis", "grid"] }
        );
      }
      this.currentItem.setAttr("xPosition", y);
      this.$forceUpdate();
    },
    handleBarXPositionChange(e) {
      const y = e.target.value;
      const point = this.currentItem.getAttr("point");
      const deviceId = this.currentItem.getAttr("deviceId");
      if (this.barOptions[deviceId + point]) {
        this.barOptions[deviceId + point].xAxis.axisLabel.show = !!+y;
        this.barCharts[deviceId + point].setOption(
          this.barOptions[deviceId + point],
          { replaceMerge: ["xAxis", "grid"] }
        );
      }
      this.currentItem.setAttr("xPosition", y);
      this.$forceUpdate();
    },
    connectWebSocket() {
      const authorization =
        "Bearer " + JSON.parse(localStorage.getItem("token"));
      this.webSocket = new WebSocket(
        `${websocketUrl}/group/${this.$route.query.id}?token=${authorization}`
      );
      this.webSocket.onopen = () => {};
      this.webSocket.onmessage = ev => {
        const record = JSON.parse(ev.data);
        const block = this.stage.find(".dataRow");
        this.renderDeviceData(block, record);
        const list = this.stage.find(".dataBlock");
        const deviceCode = record.device_code;
        list.forEach(block => {
          const device = block.getAttr("device");
          if (device) {
            if (device.code === deviceCode && record.deviceStatus) {
              let tags = record.deviceStatus.split(",");
              tags = tags.map(t => {
                const c = this.deviceStatus.find(d => d.value === t);
                return c;
              });
              widget.dataBlock.updateHeaderTag(block, tags);
            }
          }
        });
        const monitors = this.stage.find(".monitorBlock");
        monitors.forEach(m => {
          const device = m.getAttr("device");
          if (device && device.code === record.device_code) {
            if (record.deviceStatus) {
              let tags = record.deviceStatus.split(",");
              tags = tags.map(t => {
                const c = this.deviceStatus.find(d => d.value === t);
                return c;
              });
              widget.dataBlock.updateHeaderTag(m, tags);
            }
            const rows = m.find(".monitorRow");
            rows.forEach(r => {
              const point = r.getAttr("dataPoint");
              if (point) {
                r.findOne(".monitorValue")?.text(record[point.code]);
              }
            });
          }
        });
        const stackedLine = this.stage.find(".StackedLine");
        if (stackedLine?.length) {
          stackedLine.forEach(s => {
            const code = s.getAttr("deviceCode");
            const point = s.getAttr("point");
            const maxPoints = s.getAttr("maxPoints");
            const id = s.getAttr('id')
            if (code && point && record.device_code === code) {
              if (
                maxPoints &&
                this.options[id].xAxis.data?.length === maxPoints
              ) {
                this.options[id].xAxis.data.shift();
                this.options[id].series[0].data.shift();
              }
              if (this.options[id]) {
                this.options[id].xAxis.data.push(
                  moment(+new Date()).format("HH:mm:ss")
                );
                const index = this.options[id].series[0].data.length - 1
                const lastPoint = this.options[id].series[0].data[index]
                if (lastPoint instanceof Object) {
                  this.options[id].series[0].data[index] = lastPoint.value
                }
                this.options[id].series[0].data.push({
                  value: record[point],
                  label: {
                    show: true,
                    position: 'top'
                  }
                });
                this.charts[id].on("finished", () => {
                  const img = new Image();
                  img.src = this.charts[id].getDataURL("png");
                  const image = s.findOne(".img");
                  image.attrs.image = img;
                  s.add(image.clone());
                  image.destroy();
                });
                this.charts[id]?.setOption(this.options[id], {
                  replaceMerge: ["yAxis", "grid", "series"]
                });
              }
            }
          });
        }
        const stackedLine2 = this.stage.find(".stackedLine2");
        if (stackedLine2?.length) {
          stackedLine2.forEach(s => {
            const code = s.getAttr("deviceCode");
            const point = s.getAttr("point");
            const maxPoints = s.getAttr("maxPoints");
            const id = s.getAttr('id')
            if (code && point && record.device_code === code) {
              if (
                maxPoints &&
                this.options[id].xAxis.data?.length === maxPoints
              ) {
                this.options[id].xAxis.data.shift();
                this.options[id].series[0].data.shift();
              }
              if (this.options[id]) {
                this.options[id].xAxis.data.push(
                  moment(+new Date()).format("HH:mm:ss")
                );
                const index = this.options[id].series[0].data.length - 1
                const lastPoint = this.options[id].series[0].data[index]
                if (lastPoint instanceof Object) {
                  this.options[id].series[0].data[index] = lastPoint.value
                }
                this.options[id].series[0].data.push({
                  value: record[point],
                  label: {
                    show: true,
                    position: 'top'
                  }
                });
                this.charts[id].on("finished", () => {
                  const img = new Image();
                  img.src = this.charts[id].getDataURL("png");
                  let image = s.findOne(".img");
                  image.draggable(false)
                  image.attrs.image = img;
                  s.add(image.clone());
                  image.destroy();
                });
                this.charts[id]?.setOption(this.options[id], {
                  replaceMerge: ["yAxis", "grid", "series"]
                });
              }
            }
          });
        }
      };
    },
    async getStackedBarData(
      id,
      deviceId,
      pointCode,
      aggregationType,
      term,
      termNumber,
      node = this.currentItem
    ) {
      let startTime, endTime;
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth();
      if (term === "30d") {
        const firstDayOfNextMonth = +new Date(year, month + 1);

        let targetMonth = month - termNumber + 1;
        const targetYear = year + Math.floor(targetMonth / 12);
        targetMonth = (targetMonth + 12) % 12;
        const firstDayOfTargetMonth = +new Date(targetYear, targetMonth, 1);
        startTime = firstDayOfTargetMonth;
        endTime = firstDayOfNextMonth;
      }
      if (term === "1w") {
        const now = new Date()
        const start = now - termNumber * 7 * 24 * 60 * 60 * 1000
        startTime = +this.getMonday(start)
        endTime = +this.getSunday(now)
      }
      if (term === "1d") {
        const date = now.getDate();
        endTime = +new Date(year, month, date + 1, 0, 0, 0, 0);
        startTime = +new Date(year, month, date - termNumber + 1, 0, 0, 0, 0);
      }
      if (term === '1h') {
        // 获取当前时间对应的整点时间戳
        const now = new Date()
        now.setMinutes(0, 0, 0); // 将分钟、秒钟和毫秒数设为 0
        now.setHours(now.getHours() + 1); // 将小时数加一，表示下一个整点
        endTime = now.getTime()
        startTime = endTime - termNumber * 60 * 60 * 1000
      }

      let deviceIds = deviceId
      if (node.getAttr("ratio")) {
        try {
          const { data } = await getMultiAggregation(
            [
              {
                duration: term,
                deviceId: node.getAttr("LLJs") || [],
                pointCode: node.getAttr("LLJPoint"),
                aggregationType,
                startTime,
                endTime
              },
              {
                duration: term,
                deviceId: node.getAttr("DBs") || [],
                pointCode: node.getAttr("DBPoint"),
                aggregationType,
                startTime,
                endTime
              }
            ]
          )
          console.log(data)
          const xAxis = [];
          const seriesData = [];
          let value, n;
          let start = term === '1d' ? 0 : 1, end = data[0].values.length
          if (term === "1w") {
            start = end - termNumber
          }
          let week
          for (let i = start; i < end; i++) {
            value = data[0].values[i];
            if (term === "1d") {
              xAxis.push(value.time.substring(5, 10));
            }
            if (term === "1w") {
              week = this.getWeekNumber(value.time)
              let s = week.weekNumber
              if (this.lang === "en") {
                if (s == 1) {
                  s += "st"
                } else if (s == 2) {
                  s += "nd"
                } else if (s == 3) {
                  s += "rd"
                } else {
                  s += "th"
                }
              } else {
                s += "周"
              }
              xAxis.push(s)
            }
            if (term === "30d") {
              xAxis.push(+value.time.substring(5, 7) + "月");
            }
            if (term === '1h') {
              xAxis.push(value.time.split(' ')[1].substring(0, 5))
            }
            if (value.value && data[1].values[i]?.value) {
              n = +((data[1].values[i].value / value.value).toFixed(5))
            } else {
              n = 0
            }
            seriesData.push(n);
          }
          
          this.drawStackedBar(id, xAxis, seriesData, node)
          return
        } catch(e) {
          console.log(e)
          return
        }
      }

      try {
        const { data } = await getMultiAggregation([
          {
            duration: term,
            deviceId: deviceIds,
            pointCode,
            aggregationType,
            startTime,
            endTime
          }
        ]);
        // this.stackedBarData = data
        const xAxis = [];
        const seriesData = [];
        let value;
        let start = term === '1d' ? 0 : 1, end = data[0].values.length
        if (term === "1w") {
          start = end - termNumber
        }
        let week
        for (let i = start; i < end; i++) {
          value = data[0].values[i];
          if (term === "1d") {
            xAxis.push(value.time.substring(5, 10));
          }
          if (term === "1w") {
            week = this.getWeekNumber(value.time)
            let s = week.weekNumber
            if (this.lang === "en") {
              if (s == 1) {
                s += "st"
              } else if (s == 2) {
                s += "nd"
              } else if (s == 3) {
                s += "rd"
              } else {
                s += "th"
              }
            } else {
              s += "周"
            }
            xAxis.push(s)
          }
          if (term === "30d") {
            xAxis.push(+value.time.substring(5, 7) + "月");
          }
          if (term === '1h') {
            xAxis.push(value.time.split(' ')[1].substring(0, 5))
          }
          seriesData.push(value.value);
        }
        
        this.drawStackedBar(id, xAxis, seriesData, node);
      } catch (e) {
        console.log(e);
      }
    },
    drawStackedBar(id, xAxis, data, node = this.currentItem) {
      const yVisible = node.getAttr('yPosition')
      const xVisible = node.getAttr('xPosition')
      const fixed = node.getAttr('fixed')
      const borderRadius = node.getAttr('borderRadius') || 0
      if (!this.charts[id]) {
        this.charts[id] = this.$echarts.init(
          document.querySelector(`#${id}`),
          null,
          {
            render: "canvas",
            useDirtyRect: false
          }
        );
        this.charts[id].on("finished", () => {
          const img = new Image();
          img.src = this.charts[id].getDataURL("png");
          
          const image = node.findOne(".img");
          
          image.attrs.image = img;
          node.add(image.clone());
          image.destroy();
        });
      }

      this.options[id] = {
        animation: false,
        backgroundColor: "",
        tooltip: {
          trigger: "axis"
        },
        grid: {
          containLabel: true,
          top: "18%",
          left: "6%",
          right: "6%",
          bottom: "1%"
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          data: xAxis,
          axisTick: {
            show: false
          },
          axisLabel: {
            interval: 0,
            textStyle: {
              fontSize: node.getAttr('xFont') || 16
            },
            color: node.getAttr('xColor') || this.xColor.hex8,
            show: isNaN(+xVisible) ? true : !!+xVisible
          },
          splitLine: {
            show: false
          },
          axisTick: {
            show: false
          },
          axisLine: {
            onZero: false
          }
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false
          },
          axisLabel: {
            show: isNaN(+yVisible) ? true : !!+yVisible,
            textStyle: {
              fontSize: node.getAttr('yFont') || 16
            },
            color: node.getAttr('yColor') || this.yColor.hex8
          }
        },
        series: [
          {
            data,
            type: node.getAttr('chartType') || 'bar',
            itemStyle: {
              color: node.getAttr('itemStyle') || this.itemStyle.hex8,
              borderRadius: [+borderRadius, +borderRadius, 0, 0]
            },
            label: {
              show: true,
              color: node.getAttr('labelColor') || this.labelColor.hex8,
              position: 'top',
              fontSize: node.getAttr('labelFont') || 16
            }
          }
        ]
      };
      const colorLinear = node.getAttr('colorLinear')
      if (colorLinear === false) {
        delete this.options[id].series[0].areaStyle
      } else {
        this.options[id].series[0][(node.getAttr('chartType') || 'line') === 'line' ? 'areaStyle' : 'itemStyle'] = {
          color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: node.getAttr('linearStart') || this.linearStart.hex8
            },
            {
              offset: 1,
              color: node.getAttr('linearEnd') || this.linearEnd.hex8
            }
          ]),
          borderRadius: [+borderRadius, +borderRadius, 0, 0]
        }
      }
      if (!isNaN(+fixed)) {
        this.options[id].series[0].label.formatter = o => (+o.value).toFixed(+fixed)
      }
      this.charts[id].setOption(
        this.options[id]
      );
      node.on("transformend", () => {
        const width = this.currentItem.scaleX() * 500;
        const height = this.currentItem.scaleY() * 200;
        this.width[id] = width + "px";
        this.height[id] = height + "px";
        this.width = { ...this.width };
        this.height = { ...this.height };
        
        this.$nextTick(() => {
          this.charts[id].resize();
          const img = new Image();
          img.src = this.charts[id].getDataURL("png");
          console.log(img.src);
          
          const image = this.currentItem.findOne(".img");
          console.log(image.scale());
          
          image.scaleX(1)
          image.scaleY(1)
          image.attrs.image = img;
          // image.scaleX(1 / this.currentItem.scaleX())
          // image.scaleY(1 / this.currentItem.scaleY())
        });
      });
    },
    handleXChange(e) {
      debounce(() => {
        const id = this.currentItem.getAttr('id')
        
        this.currentItem?.setAttr("xFont", e.target.value);
        if (this.options[id]) {
          this.options[id].xAxis.axisLabel.textStyle.fontSize = isNaN(+e.target.value) ? 16 : +e.target.value

          this.charts[id].setOption(
            this.options[id],
            { replaceMerge: ["xAxis"] }
          );
        }
        this.$forceUpdate();
      }, 200);
    },
    handleYChange(e) {
      debounce(() => {
        this.currentItem?.setAttr("yFont", e.target.value);
        const id = this.currentItem.getAttr('id')
        if (this.options[id]) {
          this.options[id].yAxis.axisLabel.textStyle.fontSize = isNaN(+e.target.value) ? 16 : +e.target.value

          this.charts[id].setOption(
            this.options[id],
            { replaceMerge: ["yAxis"] }
          );
        }
        this.$forceUpdate();
      }, 200);
    },
    handleLabelChange(e) {
      debounce(() => {
        this.currentItem?.setAttr("labelFont", e.target.value);
        const id = this.currentItem.getAttr('id')
        if (this.options[id]) {
          this.options[id].series[0].label.fontSize = isNaN(+e.target.value) ? 16 : +e.target.value

          this.charts[id].setOption(
            this.options[id],
            { replaceMerge: ["series"] }
          );
        }
        this.$forceUpdate();
      }, 200);
    },
    handleTypeChange(e) {
      this.currentItem.setAttr("chartType", e.target.value);
      this.$forceUpdate();
      const linearStart = this.currentItem.getAttr('lnearStart') || this.linearStart.hex8
      const linearEnd = this.currentItem.getAttr('linearEnd') || this.linearEnd.hex8
      const itemStyle = this.currentItem.getAttr('itemStyle') || this.itemStyle.hex8
      const id = this.currentItem.getAttr('id')
      const colorLinear = this.currentItem.getAttr('colorLinear')
      const borderRadius = this.currentItem.getAttr('borderRadius') || 0  
      const option = this.options[id]
      const chart = this.charts[id]
      let color = {}
      option.series[0].type = e.target.value
      if (e.target.value === 'bar') {
        if (colorLinear) {
          color = new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: linearStart
            },
            {
              offset: 1,
              color: linearEnd
            }
          ])
        } else {
          color = itemStyle
        }
        option.series[0].itemStyle = {
          color,
          borderRadius: [+borderRadius, +borderRadius, 0, 0]
        }
      }
      if (e.target.value === 'line') {
        if (colorLinear) {
          color = new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
            {
              offset: 0,
              color: linearStart
            },
            {
              offset: 1,
              color: linearEnd
            }
          ])
          option.series[0].areaStyle = {
            color
          }
        } else {
          delete option.series[0].areaStyle
          option.series[0].itemStyle = {
            color: itemStyle
          }
        }
      }
      chart.setOption(option, { replaceMerge: ['series'] })
    },
    handleBarTypeChange(e) {
      this.currentItem.setAttr("chartType", e.target.value);
      this.$forceUpdate();
      const deviceId = this.currentItem.getAttr('deviceId')
      const point = this.currentItem.getAttr('point')
      if (this.barOptions[deviceId + point]) {
        this.barOptions[deviceId + point].series[0].type = e.target.value
        this.barCharts[deviceId + point].setOption(this.barOptions[deviceId + point], { replaceMerge: ['series'] })
      }
    },
    handleMaxPointsChange(e) {
      debounce(() => {
        const id = this.currentItem.getAttr('id')
        this.currentItem.setAttr('maxPoints', e > 0 ? e: '')
        
        if (this.options[id]) {
          const data = this.options[id].series[0].data || []
          if (e <= 0) return
          
          if (e < data.length) {
            this.options[id].series[0].data = data.slice(data.length - e>= 0 ? data.length - e : 0, data.length)
            this.options[id].xAxis.data = (this.options[id].xAxis.data || []).slice(data.length - e>= 0 ? data.length - e : 0, data.length)
            this.charts[id].setOption(this.options[id], { replaceMerge: ['series', 'xAxis'] })
          }
        }
        this.$forceUpdate()
      }, 500)
    },
    getTotalColorOptionByHex8(hex8) {
      // const hex8 = this.currentItem.getAttr('itemStyle') || '#5470C6FF'
      const r = parseInt(hex8.slice(1, 3), 16);
      const g = parseInt(hex8.slice(3, 5), 16);
      const b = parseInt(hex8.slice(5, 7), 16);
      const a = parseInt(hex8.slice(7, 9), 16) / 255;
      return {
        hex8,
        rgba: {
          r,
          g,
          b,
          a
        }
      }
    },
    cancelColorPick(visibleField, colorField, defaultColor) {
      this[visibleField] = false
      const hex8 = this.currentItem.getAttr(colorField) || defaultColor
      const r = parseInt(hex8.slice(1, 3), 16);
      const g = parseInt(hex8.slice(3, 5), 16);
      const b = parseInt(hex8.slice(5, 7), 16);
      const a = parseInt(hex8.slice(7, 9), 16) / 255;

      this[colorField] = {
        hex8,
        rgba: {
          r,
          g,
          b,
          a
        }
      }
    },
    confirmColorPick(visibleField, colorField, colorSetter) {
      this[visibleField] = false
      const id = this.currentItem.getAttr('id')
      this.currentItem.setAttr(colorField, this[colorField].hex8)
      if (this.options[id]) {
        this[colorSetter](id)
      }
      this.$forceUpdate()
    },
    setXColor(id) {
      this.options[id].xAxis.axisLabel.color = this.xColor.hex8
      this.charts[id].setOption(this.options[id], {
        replaceMerge: ['xAxis']
      })
    },
    setYColor(id) {
      this.options[id].yAxis.axisLabel.color = this.yColor.hex8
      this.charts[id].setOption(this.options[id], {
        replaceMerge: ['yAxis']
      })
    },
    setLabelColor(id) {
      this.options[id].series[0].label.color = this.labelColor.hex8
      this.charts[id].setOption(this.options[id], {
        replaceMerge: ['series']
      })
    },
    setItemStyle(id) {
      const borderRadius = this.currentItem.getAttr('borderRadius') || 0
      this.options[id].series[0].itemStyle = {
        color: this.itemStyle.hex8,
        borderRadius: [+borderRadius, +borderRadius, 0, 0]
      }
      this.charts[id].setOption(this.options[id], {
        replaceMerge: ['series']
      })
    },
    setLinearColor(id) {
      const borderRadius = this.currentItem.getAttr('borderRadius') || 0
      const type = this.currentItem.getAttr('chartType')
      const linearStart = this.linearStart.hex8
      const linearEnd = this.linearEnd.hex8
      this.options[id].series[0][map[type]] = {
        color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
          {
            offset: 0,
            color: linearStart
          },
          {
            offset: 1,
            color: linearEnd
          }
        ]),
        borderRadius: [+borderRadius, +borderRadius, 0, 0]
      }
      this.charts[id].setOption(this.options[id], { replaceMerge: ['series'] })
    },
    handleColorLinearChange(e) {
      this.currentItem.setAttr('colorLinear', e.target.value)
      const name = this.currentItem.name()
      const borderRadius = this.currentItem.getAttr('borderRadius') || 0
      this.$forceUpdate()
      const id = this.currentItem.getAttr('id')
      const linearStart = this.currentItem.getAttr('lnearStart') || this.linearStart.hex8
      const linearEnd = this.currentItem.getAttr('linearEnd') || this.linearEnd.hex8
      const itemStyle = this.currentItem.getAttr('itemStyle') || this.itemStyle.hex8
      const chartType = this.currentItem.getAttr('chartType')
      if (this.options[id]) {
        if (e.target.value) {
          if (chartType === 'line') {
            this.options[id].series[0].areaStyle = {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: linearStart
                },
                {
                  offset: 1,
                  color: linearEnd
                }
              ])
            }
          }
          if (chartType === 'bar') {
            this.options[id].series[0].itemStyle = {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: linearStart
                },
                {
                  offset: 1,
                  color: linearEnd
                }
              ]),
              borderRadius: [+borderRadius, +borderRadius, 0, 0]
            }
          }
        } else {
          if (chartType === 'line') {
            delete this.options[id].series[0].areaStyle
          } else {
            this.options[id].series[0].itemStyle = {
              color: itemStyle,
              borderRadius: [+borderRadius, +borderRadius, 0, 0]
            }
          }
        }
        this.charts[id].setOption(this.options[id], { replaceMerge: ['series'] })
      }
    },
    changeFixed(e) {
      debounce(() => {
        const id = this.currentItem.getAttr('id')
        if (!e.target.value) {
          this.currentItem?.setAttr("fixed", '')
          if (this.options[id]) {
            delete this.options[id].series[0].label.formatter
            this.charts[id].setOption(
              this.options[id],
              { replaceMerge: ["series"] }
            )
          }
          this.$forceUpdate()
          return
        }
        if (isNaN(+e.target.value)) return;
        this.currentItem?.setAttr("fixed", +e.target.value);
        if (this.options[id]) {
          this.options[id].series[0].label.formatter = o => {
            return (+o.value).toFixed(+e.target.value)
          }

          this.charts[id].setOption(
            this.options[id],
            { replaceMerge: ["series"] }
          );
        }
        this.$forceUpdate();
      }, 200);
    },
    changeDataRate(e) {
      debounce(() => {
        const id = this.currentItem.getAttr('id')
        if (!e.target.value) {
          this.currentItem?.setAttr("dataRate", '')
          this.$forceUpdate()
          return
        }
        if (isNaN(+e.target.value)) return;
        this.currentItem?.setAttr("dataRate", +e.target.value);
        this.$forceUpdate();
        const deviceId = this.currentItem.getAttr("deviceId")
        const pointCode = this.currentItem.getAttr("point")
        const aggregationType = this.currentItem.getAttr("aggregationType")
        const term = this.currentItem.getAttr("term")
        const termNumber = this.currentItem.getAttr("termNumber")
        this.getStackedBarData(id, deviceId, pointCode, aggregationType, term, termNumber, this.currentItem)
      }, 300);
    },
    changeBorderRadius(e) {
      debounce(() => {
        const id = this.currentItem.getAttr('id')
        if (!e.target.value) {
          this.currentItem?.setAttr("borderRadius", '')
          if (this.options[id]) {
            delete this.options[id].series[0].itemStyle.borderRadius
            this.charts[id].setOption(
              this.options[id],
              { replaceMerge: ["series"] }
            )
          }
          this.$forceUpdate()
          return
        }
        if (isNaN(+e.target.value)) return;
        this.currentItem?.setAttr("borderRadius", +e.target.value);
        if (this.options[id]) {
          this.options[id].series[0].itemStyle.borderRadius = [+e.target.value, +e.target.value, 0, 0]

          this.charts[id].setOption(
            this.options[id],
            { replaceMerge: ["series"] }
          );
        }
        this.$forceUpdate();
      }, 200);
    },
    bindUpdateTermNumberToStackedBar(e) {
      this.currentItem.setAttr('updateTermNumber', e)
      this.$forceUpdate();
    },
    bindUpdateTermTypeToSatckedBar(e) {
      this.currentItem.setAttr('gap', e)
      this.$forceUpdate();
    },
    handleSizeChange(e, type) {
      debounce(() => {
        this.currentItem[type](Number(e.target.value))
        this.$forceUpdate()
      }, 200)
    },
    handleEChange(v) {
      this.currentItem.setAttr('e', v)
      this.$forceUpdate()
      this.setEffectiveState((this.currentItem.getAttr('f') || []).concat(this.currentItem.getAttr('e') || []))
    },
    handleSEChange(v) {
      this.currentItem.setAttr('e', v)
      this.$forceUpdate()
      this.setSocialEffectiveState(this.currentItem, (this.currentItem.getAttr('f') || []).concat(this.currentItem.getAttr('e') || []))
    },
    hanldeSFChange(v) {
      this.currentItem.setAttr('f', v)
      this.$forceUpdate()
      this.setSocialEffectiveState(this.currentItem, (this.currentItem.getAttr('f') || []).concat(this.currentItem.getAttr('e') || []))
    },
    async setSocialEffectiveState(n, deviceCodes) {
      if (deviceCodes.length) {
        const endDate = +new Date()
        const startDate = endDate - 30 * 24 * 3600 * 1000
        try {
          const { data } = await getMonthReport(moment(startDate).format('YYYY-MM-DD'), moment(endDate).format('YYYY-MM-DD'), deviceCodes + '')
          let target, totalNm = 0, totalKwh = 0
          for (let i = data.length - 2; i > -1; i--) {
            target = data[i]
            if (target.electricityMeterAccumulation > 0) {
              totalKwh = target.electricityMeterAccumulation - this.eReduce
              totalKwh = totalKwh > 0 ? totalKwh : 0
              if (target.flowMeterAccumulation > 0) {
                totalNm = target.flowMeterAccumulation - this.gReduce
                totalNm = totalNm > 0 ? totalNm : 0
              }
              break
            }
          }
          const totalReduce = (this.gasElectricRatio * totalNm - totalKwh).toFixed(0)
          const CO2 = (totalReduce * 0.942 / 1000).toFixed(3)

          const powerValue = n.findOne('.powerValue')
          if (powerValue) {
            powerValue.setText(totalReduce)
          }
          const CO2Value = n.findOne('.CO2Value')
          if (CO2Value) {
            CO2Value.setText(CO2)
          }
        } catch(e) {
          console.log(e)
        }
      } else {
        const powerValue = this.currentItem.findOne('.powerValue')
        if (powerValue) {
          powerValue.setText(totalReduce)
        }
        const CO2Value = this.currentItem.findOne('.CO2Value')
        if (CO2Value) {
          CO2Value.setText(CO2)
        }
      }
    },
    handleEchangeC(v) {
      this.currentItem.setAttr('e', v)
      const f = this.currentItem.getAttr('f') || []
      const ds = v.concat(f)
      const id = this.currentItem.getAttr('id')
      if (this.effectiveWebsocket[id]) {
        this.effectiveWebsocket[id].close()
        delete this.effectiveWebsocket[id]
      }
      if (ds.length) {
        this.connectEffectiveWebscoket(this.currentItem, ds + '')
      } else {
        this.currentItem.findOne('.ev')?.text('0')
        this.currentItem.findOne('.fv')?.text('0')
        this.currentItem.findOne('.ratioValue')?.text('0.00000')
      }
      this.$forceUpdate()
    },
    hanldeFChange(v) {
      this.currentItem.setAttr('f', v)
      this.$forceUpdate()
      this.setEffectiveState((this.currentItem.getAttr('f') || []).concat(this.currentItem.getAttr('e') || []))
    },
    handleFchangeC(v) {
      this.currentItem.setAttr('f', v)
      const e = this.currentItem.getAttr('e') || []
      const ds = e.concat(v)
      const id = this.currentItem.getAttr('id')
      if (this.effectiveWebsocket[id]) {
        this.effectiveWebsocket[id].close()
        delete this.effectiveWebsocket[id]
      }
      if (ds.length) {
        this.connectEffectiveWebscoket(this.currentItem, ds + '')
      } else {
        this.currentItem.findOne('.ev')?.text('0')
        this.currentItem.findOne('.fv')?.text('0')
        this.currentItem.findOne('.ratioValue')?.text('0.00000')
      }
      this.$forceUpdate()
    },
    async setEffectiveState(deviceCodes) {
      if (deviceCodes.length === 0) {
        this.currentItem.findOne('.ev')?.text('0')
        this.currentItem.findOne('.fv')?.text('0')
        this.currentItem.findOne('.ratioValue')?.text('0.00000')
        return
      }
      let endDate = +new Date()
      let startDate = endDate - 30 * 24 * 3600 * 1000
      endDate = moment(endDate).format('YYYY-MM-DD')
      startDate = moment(startDate).format('YYYY-MM-DD')
      const { data } = await getMonthReport(startDate, endDate, deviceCodes + '')
      let target, totalNm = 0, totalKwh = 0, totalP
      for (let i = data.length - 2; i > -1; i--) {
        target = data[i]
        if (target.electricityMeterAccumulation > 0) {
          totalKwh = target.electricityMeterAccumulation - this.eReduce
          totalKwh = totalKwh > 0 ? totalKwh : 0
          if (target.flowMeterAccumulation > 0) {
            totalNm = target.flowMeterAccumulation - this.gReduce
            totalNm = totalNm > 0 ? totalNm : 0
          }
          break
        }
      }
      totalP = totalNm == 0 ? 0 : (totalKwh / totalNm)
      totalP = totalP.toFixed(5)
      totalKwh = totalKwh.toFixed(0)
      totalNm = totalNm.toFixed(0)
      this.currentItem.findOne('.ev')?.text(totalKwh)
      this.currentItem.findOne('.fv')?.text(totalNm)
      this.currentItem.findOne('.ratioValue')?.text(totalP)
    },
    connectEffectiveWebscoket(n, deviceCodes) {
      const id = n.getAttr('id')
      const authorization = 'Bearer ' + JSON.parse(localStorage.getItem('token'))
      this.effectiveWebsocket[id] = new WebSocket(`wss://ygk.deman.cn:9006/ws/device/group/${this.$route.query.id}?token=${authorization}`)
      this.effectiveWebsocket[id].onopen = () => {
        this.effectiveWebsocket[id].send(deviceCodes)
      }
      this.effectiveWebsocket[id].onmessage = m => {
        const record = JSON.parse(m.data)
        if (!record.device_code) {
          n.findOne('.ev')?.text(record.power)
          n.findOne('.fv')?.text(record.flow)
          n.findOne('.ratioValue')?.text(record.gasElectricRatio)
        }
      }
    },
    toggleRatioModeToNode(e) {
      this.currentItem.setAttr("ratio", e.target.checked)
      const id = this.currentItem.getAttr('id')
      if (this.options[id]) {
        this.options[id] = null
        this.charts[id].dispose()
        this.charts[id] = null
        const image = this.currentItem.findOne('.img')
        image.attrs.image = null
      }
      const attrs = this.currentItem.attrs
      if (attrs.ratio) {
        if (attrs.aggregationType && attrs.term && attrs.termNumber && attrs.LLJs && attrs.DBs && attrs.LLJPoint && attrs.DBPoint) {
          this.getStackedBarData(
            id,
            attrs.deviceId,
            attrs.point,
            attrs.aggregationType,
            attrs.term,
            attrs.termNumber
          )
        }
      } else {
        if (attrs.deviceId && attrs.point && attrs.term && attrs.termNumber) {
          this.getStackedBarData(
            id,
            attrs.deviceId,
            attrs.point,
            attrs.aggregationType,
            attrs.term,
            attrs.termNumber
          );
        }
      }
      this.$forceUpdate()
    },
    getMonday(d) {
      const date = new Date(d)

      const dayOfWeek = date.getDay()
      const mondayOffset = dayOfWeek === 0 ? 6 : dayOfWeek - 1

      const monday = new Date(date)
      monday.setDate(date.getDate() - mondayOffset)
      monday.setHours(0, 0, 0, 0)

      return monday
    },
    getSunday(d) {
      const date = new Date(d)

      const dayOfWeek = date.getDay()
      const sundayOffset = dayOfWeek === 0 ? 0 : 7 - dayOfWeek

      const sunday = new Date(date)
      sunday.setDate(date.getDate() + sundayOffset)
      sunday.setHours(23, 59, 59, 999)

      return sunday
    },
    getWeekNumber(d) {
      const date = new Date(d)
      date.setHours(0, 0, 0, 0)

      const dayOfWeek = date.getDay()
      const thursdayOffset = dayOfWeek <= 4 ? 4 - dayOfWeek : 11 - dayOfWeek
      const thursday = new Date(date)
      thursday.setDate(date.getDate() + thursdayOffset)

      const year = thursday.getFullYear()
      const firstDayOfYear = new Date(year, 0, 1)
      const firsThursday = new Date(firstDayOfYear)

      const firstDayOfWeek = firstDayOfYear.getDay()
      const daysToFirstThursday = firstDayOfWeek <= 4 ? 4 - firstDayOfWeek : 11- firstDayOfWeek
      firsThursday.setDate(firstDayOfYear.getDate() + daysToFirstThursday)

      if (firsThursday.getTime() > thursday.getTime()) {
        const prevYear = year - 1
        const prevFirstDayOfYear = new Date(prevYear, 0, 1)
        const prevFirstThursday = new Date(prevFirstDayOfYear)

        const prevFirstDayOfWeek = prevFirstDayOfYear.getDay()
        const prevDaysToFirstThursday = prevFirstDayOfWeek <= 4 ? 4 - prevFirstDayOfWeek : 11 - prevFirstDayOfWeek
        prevFirstThursday.setDate(prevFirstDayOfYear.getDate() + prevDaysToFirstThursday)

        const diffInMs = thursday - prevFirstThursday
        const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24))
        const weekNumber = Math.floor(diffInDays / 7) + 1

        return {
          weekNumber,
          year: prevYear
        }
      }

      const diffInMs = thursday - firsThursday
      const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24))
      const weekNumber = Math.floor(diffInDays / 7) + 1;

      return {
        weekNumber,
        year
      }
    }
  }
};
</script>

<style lang="less" scoped>
.bg-white {
  background-color: #fff;
}

.header-wrap {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #eee;
}

/deep/ .ant-collapse > .ant-collapse-item > .ant-collapse-header {
  background-color: rgb(240, 239, 238);
  padding: 6px 10px 6px 40px;
}

.container-header {
  padding: 0 10px;
  background-color: rgb(240, 239, 238);

  .container-selector {
    display: flex;
    align-items: center;
    height: 34px;
    background-color: rgb(240, 239, 238);
  }
}

input:focus {
  outline: none;
}

/deep/
  .ant-collapse-borderless
  > .ant-collapse-item
  > .ant-collapse-content
  > .ant-collapse-content-box {
  padding-top: 0;
}

/deep/ .ant-collapse-content > .ant-collapse-content-box {
  padding: 0;
}

/deep/ .ant-table-small > .ant-table-content > .ant-table-body {
  margin: 0;
}
/deep/ .ant-layout-sider {
  overflow: auto;
  height: calc(100% - 68px);
}
.btn-group {
  display: flex;
  margin-top: 8px;
  justify-content: center;
  /deep/ .el-button {
    width: 60px;
  }
}
.vc-chrome {
  box-shadow: 0 0 1px rgba(0,0,0,.3), 0 0px 0px rgba(0,0,0,.3)!important;
}
.item-wrapper:hover {
  border: 1px solid #000049;
}
</style>
